import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import ExpectedError, {
    EXPECTED_ERROR_CATEGORY,
    EXPECTED_ERROR_CLASSIFICATION,
    EXPECTED_ERROR_SOURCE,
} from "models/helper/ExpectedError";
import WrapNodeTypes from "models/audioEditor/sequencerNodes/WrapNodeTypes";
import PersistentModels from "services/PersistentModels";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import StartWrapSequencerNode from "models/audioEditor/sequencerNodes/StartWrapSequencerNode";
import EndWrapSequencerNode from "models/audioEditor/sequencerNodes/EndWrapSequencerNode";
import SequencerWordNodeView from "views/audioEditor/sequencerNodeView/SequencerWordNodeView";
import SequencerAudioEventNodeView from "views/audioEditor/sequencerNodeView/SequencerAudioEventNodeView";
import SequencerPauseNodeView from "views/audioEditor/sequencerNodeView/SequencerPauseNodeView";
import SequencerDeletedNodeView from "views/audioEditor/sequencerNodeView/SequencerDeletedNodeView";
//import SequencerMusicWrapperNodeView from "views/audioEditor/sequencerNodeView/SequencerMusicWrapperNodeView";
import SequencerPunctuationNodeView from "views/audioEditor/sequencerNodeView/SequencerPunctuationNodeView";
import SequencerUnsupportedNodeView from "views/audioEditor/sequencerNodeView/SequencerUnsupportedNodeView";
import KeyboardKeyHandlerHelper from "models/helper/KeyboardKeyHandlerHelper";
import SequencerStartMusicWrapNodeView from "views/audioEditor/sequencerNodeView/SequencerStartMusicWrapNodeView";
import SequencerEndMusicWrapdNodeView from "views/audioEditor/sequencerNodeView/SequencerEndMusicWrapdNodeView";
import SequencerStartMuteWrapNodeView from "views/audioEditor/sequencerNodeView/SequencerStartMuteWrapNodeView";
import SequencerEndMuteWrapNodeView from "views/audioEditor/sequencerNodeView/SequencerEndMuteWrapNodeView";
import SequencerAudioNodeView from "views/audioEditor/sequencerNodeView/SequencerAudioNodeView";
import SequencerVideoNodeView from "views/audioEditor/sequencerNodeView/SequencerVideoNodeView";
//import SequencerNodeInspectorSectionView from "views/audioEditor/sequencerNodeInspectorSection/SequencerNodeInspectorSectionView";
import Sortable from "libs/sortablejs/Sortable";
import VideoContext from "libs/videoContext/videoContext";
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import SequencerTemplate from 'text!../../../templates/audioEditor/SequencerTemplate.html';
import SequencerNodeContextMenuTemplate from "text!../../../templates/audioEditor/SequencerNodeContextMenuTemplate.html";
import MusicWrapperSequencerNodeContextMenuTemplate from "text!../../../templates/audioEditor/MusicWrapperSequencerNodeContextMenuTemplate.html";
import AudioSequencerNodeContextMenuTemplate from "text!../../../templates/audioEditor/AudioSequencerNodeContextMenuTemplate.html";
import SequencerDeletedNodeContextMenuTemplate from "text!../../../templates/audioEditor/SequencerDeletedNodeContextMenuTemplate.html";
import VideoSequencerNodeContextMenuTemplate from "text!../../../templates/audioEditor/VideoSequencerNodeContextMenuTemplate.html";
import CorrectTranscriptionContextMenuTemplate from "text!../../../templates/audioEditor/CorrectTranscriptionContextMenuTemplate.html";
import SequencerContextMenuDefaultTemplate from "text!../../../templates/audioEditor/SequencerContextMenuDefaultTemplate.html";
import TippyTooltipTemplate from "text!../../../templates/common/TippyTooltipTemplate.html";
import SequencerNodeUtils from 'models/audioEditor/SequencerNodeUtils';
import Mousetrap from 'mousetrap';
//import TippyJS from "tippyJS";
//import TippyJS from 'tippy.js';
import TippyJS, {createSingleton} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import noUiSlider from "nouislider";
import ti18n from 'i18n!nls/Sequenceri18n';
import ti18nMute from 'i18n!nls/MuteWrapi18n';
import utilsi18n from 'i18n!nls/Utilsi18n';
import timeloomRendereri18n from 'i18n!nls/TimeloomRendereri18n';
import RSVP from 'rsvp';
import Shepherd from 'shepherd.js';
import SpeakerParagraphContainerView from 'views/audioEditor/sequencerNodeView/SpeakerParagraphContainerView';
import UnlabelledParagraphContainerView from 'views/audioEditor/sequencerNodeView/UnlabeledParagraphContainerView';
import EditorSearchPanel from "components/EditorSearchPanel";
import { createRoot } from "react-dom/client";
import React from "react";
import TimeloomRenderer from "components/audioEditor/TimeloomRenderer";
import AudioBufferHelper from "models/audioEditor/AudioBufferHelper";
const SequencerMutationAccess = require("views/audioEditor/SequencerMutationAccess");

const {
    canDisplayMoreOptionMenu,
    canTriggerAdjustTiming,
    canTriggerIgnoreSelectedNodes,
    canTriggerPasteClipboardBeforeSelection,
    canTriggerSequencerMutation,
    canTriggerTranscriptCorrection,
    canTriggerWrapSelectedNodesWithMusic,
} = SequencerMutationAccess;
import ParagraphLayoutBuilder from "models/audioEditor/ParagraphLayoutBuilder";
import createParagraphBoundaryPolicyForSequencer from "models/audioEditor/createParagraphBoundaryPolicyForSequencer";
import ParagraphBoundaryPreference from "models/audioEditor/ParagraphBoundaryPreference";
import SelectionSpeakerChangeHelper from "models/audioEditor/SelectionSpeakerChangeHelper";

const Rollout = RolloutHelper.getInstance();

const MUTE_MENU_LOCATION = 'add'; // 'add' on master; 'effects' on experimental (Phase 2)

/**
 * Factory map: WrapNodeType → {Start: ViewClass, End: ViewClass}
 * This centralizes wrap type → view mapping so adding a new wrap type
 * only requires adding one entry here instead of scattered if/else checks.
 */
const WRAP_TYPE_TO_VIEW_MAP = {
    [WrapNodeTypes.MUSIC]: {
        Start: SequencerStartMusicWrapNodeView,
        End: SequencerEndMusicWrapdNodeView
    },
    [WrapNodeTypes.MUTE]: {
        Start: SequencerStartMuteWrapNodeView,
        End: SequencerEndMuteWrapNodeView
    },
};

function normalizeAutomationTranscriptText(text) {
    if (text === null || text === undefined) {
        return "";
    }

    return String(text)
        .toLowerCase()
        .replace(/[\u2018\u2019]/g, "'")
        .replace(/[`"\u201c\u201d]/g, " ")
        .replace(/[.,!?;:()[\]{}]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

function tokenizeAutomationTranscriptText(text) {
    const normalizedText = normalizeAutomationTranscriptText(text);
    return normalizedText ? normalizedText.split(" ") : [];
}

function getAutomationNodeText(sequencerNode) {
    if (!sequencerNode || typeof sequencerNode.getContent !== "function") {
        return null;
    }

    const content = sequencerNode.getContent(false);
    return typeof content === "string" && content.indexOf("<") === -1
        ? content
        : null;
}

function getAutomationNodeType(sequencerNode) {
    if (!sequencerNode) {
        return null;
    }

    const constructorFn = typeof sequencerNode.getConstructor === "function"
        ? sequencerNode.getConstructor()
        : sequencerNode.constructor;

    return constructorFn && (constructorFn.CLASSNAME || constructorFn.name)
        ? (constructorFn.CLASSNAME || constructorFn.name)
        : null;
}

function normalizeAutomationRandomInteger(value, fallbackValue) {
    const normalizedValue = Number(value);
    return Number.isFinite(normalizedValue)
        ? Math.floor(normalizedValue)
        : fallbackValue;
}

function hashAutomationSeed(seed) {
    const seedString = String(seed);
    let hash = 2166136261;

    for (let i = 0; i < seedString.length; i++) {
        hash ^= seedString.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }

    return hash >>> 0;
}

function createAutomationRandomGenerator(seed) {
    if (seed === undefined || seed === null) {
        return Math.random;
    }

    let state = hashAutomationSeed(seed) || 1;

    return function() {
        state = Math.imul(state, 1664525) + 1013904223;
        state >>>= 0;
        return state / 4294967296;
    };
}

//const TIME_IN_MILLISECONDS_TO_ALLOW_MOVING_NODES = 500;
const MARGIN_TOP_WHEN_AUTO_SCROLLING = 30 * 2; // 2 lines
const DISPLAY_WARNING_ABOUT_NOISE_CANCELLATION_DURATION = Rollout.getFeatureVariable(Rollout.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR, Rollout.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR.variables.display_noise_cancellation_warning, true);
const ENABLE_NOISE_CANCELLATION_FEATURE =  Rollout.getFeatureVariable(Rollout.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR, Rollout.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR.variables.enable_noise_cancellation_feature, true);
const ALLOW_USER_TO_CLIP_SELECTION = Rollout.isFeatureEnabled(Rollout.FEATURES.ALLOW_USER_TO_CLIP_SELECTION_IN_AUDIO_EDITOR,true);
const BREAK_DOWN_TEXT_IN_AUDIO_EDITOR_AUTOMATICALLY = Rollout.isFeatureEnabled(Rollout.FEATURES.BREAK_DOWN_TEXT_IN_AUDIO_EDITOR_AUTOMATICALLY, true);
const CUT_COPY_PASTE_FEATURE_AVAILABLE = Rollout.isFeatureEnabled(Rollout.FEATURES.CUT_COPY_PASTE_IN_AUDIO_EDITOR, true);
const ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR = Rollout.isFeatureEnabled(Rollout.FEATURES.ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR, true);
const EDIT_VIDEO_FILES = Rollout.isFeatureEnabled(Rollout.FEATURES.EDIT_VIDEO_FILES, true);

const ALLOW_PLAYBACK_OF_SEARCH_RESULTS = Rollout.getFeatureVariable(Rollout.FEATURES.ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR, Rollout.FEATURES.ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR.variables.allow_playback_of_search_result, true);
const CONFIGURE_SOUND_ENHANCING = Rollout.isFeatureEnabled(Rollout.FEATURES.CONFIGURE_SOUND_ENHANCING, false);
const USE_SCRIPT_PROCESSOR_IN_SAFARI = Rollout.getFeatureVariable(Rollout.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR, Rollout.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR.variables.apply_safari_workaround_for_audioworklet_incomplete_impl, true);

const TURN_ON_HACK_IN_AUDIO_EDITOR_TO_PREVENT_STALLED_PLAYBACK = Rollout.isFeatureEnabled(Rollout.FEATURES.TURN_ON_HACK_IN_AUDIO_EDITOR_TO_PREVENT_STALLED_PLAYBACK);
const TIME_IN_MILLISEC_TO_TRIGGER_RESTART_AFTER_STALLED = Rollout.getFeatureVariable(Rollout.FEATURES.TURN_ON_HACK_IN_AUDIO_EDITOR_TO_PREVENT_STALLED_PLAYBACK, Rollout.FEATURES.TURN_ON_HACK_IN_AUDIO_EDITOR_TO_PREVENT_STALLED_PLAYBACK.variables.time_in_milliseconds_to_trigger_restart_after_stalled, 1000);
const MIN_TIME_BETWEEN_STALL_MONITOR_SAMPLES_MS = 100;
const STALLED_PLAYBACK_PROGRESS_EPSILON_MS = 5;
const STALLED_PLAYBACK_AUDIO_CONTEXT_EPSILON_SECONDS = 0.005;
const SHOW_SEARCH_WIDGET_ON_LEFT_SECTION_OF_EDITOR = Rollout.isFeatureEnabled(Rollout.FEATURES.SHOW_SEARCH_WIDGET_ON_LEFT_SECTION_OF_EDITOR, true);
const DO_NOT_USE_TIPPYJS_MENU = false;
const DELAY_FOR_EXECUTING_SEARCH_QUERY_IN_MILLISECONDS =  500;
const LINE_HEIGHT = 20;
const USE_PARAGRAPH_SUMMARY_TO_INCREASE_RENDERING_SPEED = false;
// Incremental paragraph updates: skip the full DOM teardown-and-rebuild for node add/remove
// events (the 99% hot path — typing, deleting single words, placeholder swaps). Structural events that actually
// move paragraph boundaries (speaker change, Cmd+Enter, layout wrap insert, etc.) still go
// through `paragraphStructureChanged` -> `_scheduleParagraphLayoutRebuild` unchanged. Any
// edge case inside the incremental path falls back to the full rebuild automatically.
// Flip to `false` to restore the post-April-2026-refactor behaviour as a kill switch.
const ENABLE_INCREMENTAL_PARAGRAPH_UPDATES = true;
const TIMELOOM_RENDERER_READY_TIMEOUT_MS = 10000;
const MAX_TIMELOOM_RENDERER_RECOVERY_ATTEMPTS = 1;

const DESTROY_CONTEXT_MENU_ON_SCROLL = true;
const HIDE_PAUSE_UNDER_10_MILLISECONDS = true;

function scheduleMicrotaskOrFallback(callback){
    if(typeof window !== "undefined" && typeof window.queueMicrotask === "function"){
        window.queueMicrotask(callback);
        return;
    }
    if(typeof Promise !== "undefined" && typeof Promise.resolve === "function"){
        Promise.resolve().then(callback);
        return;
    }
    _.defer(callback);
}

const PARAGRAPH_LAYOUT_RULES = Object.freeze({
    maxSentencesPerParagraph: ParagraphLayoutBuilder.DEFAULT_MAX_SENTENCES_PER_PARAGRAPH,
    maxWordsPerParagraph: ParagraphLayoutBuilder.DEFAULT_MAX_WORDS_PER_PARAGRAPH,
    maxNumberOfSequencerNodesPerParagraph: ParagraphLayoutBuilder.DEFAULT_MAX_NUMBER_OF_SEQUENCER_NODES_PER_PARAGRAPH,
    longPauseDurationInMillisecondsToForceBreak: 1500,
});
const DEFAULT_PARAGRAPH_BOUNDARY_POLICY_FOR_SEQUENCER = createParagraphBoundaryPolicyForSequencer();

function getWindowedAudioDebugVisibilityState() {
    return {
        hidden:
            typeof document !== 'undefined' &&
            typeof document.hidden !== 'undefined'
                ? document.hidden === true
                : null,
        visibilityState:
            typeof document !== 'undefined' &&
            typeof document.visibilityState !== 'undefined'
                ? document.visibilityState
                : null,
        hasFocus:
            typeof document !== 'undefined' &&
            typeof document.hasFocus === 'function'
                ? document.hasFocus()
                : null
    };
}

function recordWindowedAudioDebugEvent(eventName, payload) {
    try {
        if (
            typeof window === 'undefined' ||
            typeof window.__recordWindowedAudioDebugEvent !== 'function'
        ) {
            return;
        }
        window.__recordWindowedAudioDebugEvent(eventName, payload || {});
    } catch (_) {
        // Ignore debug trace failures.
    }
}

const SequencerView = Backbone.View.extend({



    initialize : function(options) {
        this.compiledTemlate =  _.template(SequencerTemplate);
        this.compiledContextMenuTemplate =  _.template(SequencerNodeContextMenuTemplate);
        this.compiledMusicWrapperContextMenuTemplate =  _.template(MusicWrapperSequencerNodeContextMenuTemplate);
        this.compiledAudioSequencerNodeContextMenuTemplate =  _.template(AudioSequencerNodeContextMenuTemplate);
        this.compiledSequencerDeletedNodeContextMenuTemplate =  _.template(SequencerDeletedNodeContextMenuTemplate);
        this.compiledVideoSequencerNodeContextMenuTemplate =  _.template(VideoSequencerNodeContextMenuTemplate);
        this.compiledCorrectTranscriptContextMenuTemplate = _.template(CorrectTranscriptionContextMenuTemplate);
        this.compliledContextMenuDefaultTemplate = _.template(SequencerContextMenuDefaultTemplate);
        this.compiledTippyTooltipTemplate =  _.template(TippyTooltipTemplate);
        this.model = options? options.model : null;
        this._sequencerController = options? options.sequencerController : null;
        this._sequencerNodeCidToSequencerNodeViewMap = {};
        this._sequencerNodeElArray = [];
        this._sequencerNodeElToIndexMap = new Map();
        this._arrayOfSelectedSequencerNodeModels = [];
        this._arrayOfSequencerNodeViewCidBeingListenedTo = [];
        this._arrayOfParagraphContainerViewCidBeingListenedTo = [];
        this._arrayOfParagraphContainerViews = [];
        this._currentlyDisplayedTippyInstance = null;
        this._currentDisplayedCorrectTranscriptsContextMenuInstance = null;
        this._paragraphViewCidToParagraphView = {};
        this._selectedNodeInfo = null;
        this._lastViewMapRebuildAt = null;
        this._sortableInstance = null;
        this._sequencerNodeViewCurrentlyHighlightedAsPlaying = null;
        this._isUserManuallyScrolling = false;
        this._warningDisplayedAboutNoiseCancellationDuration = false;
        this._warningDisplayedAboutMagicSoundEnhancerDuration = false;
        this._webGLWarningDisplayed = false;
        this._beautifyMenuDisplayed = false;
        this._keyboardEventsSetup = false;
        this._hasMutationAccess = true;
        this._timeloomRendererReadyTimeoutId = null;
        this._timeloomRendererInitAttemptId = 0;
        this._timeloomRendererRecoveryAttempts = 0;
        this._cancelPendingTimeloomRendererRecovery = null;
        this._hasMutationAccess = true;
        this._paragraphObserver = this._initializeParagraphObserver();
        this._paragraphLayoutRebuildPending = false;
        this._paragraphLayoutRebuildScheduled = false;
        this._paragraphLayoutRefreshAfterStandaloneRemovePending = false;
        this._paragraphLayoutRefreshAfterStandaloneRemoveScheduled = false;
        this._paragraphContainerViewsPendingCleanup = new Set();
        this._paragraphContainerCleanupScheduled = false;
        PersistentModels.getInstance().getRouter().registerForViewportHeightChange(this.cid,this.onOrientationChangeFunction.bind(this));
        
        if(this.model){
            this.listenTo(this.model, "add", this._onSequencerNodeAddedToSequencer);
            this.listenTo(this.model, "remove", this._onSequencerNodeRemovedToSequencer);
            this.listenTo(this.model, "reset", this._onSequencerResetted);
            this.listenTo(this.model, "closeSearchPanel", this.onExitCurrentMode);
            this.listenTo(this.model, "sequencerRenderingStarted", this.onAudioRenderingStarted);
            this.listenTo(this.model, "sequencerRenderingCompleted", this.onAudioRenderingCompleted);
            this.listenTo(this.model, "sequencerRenderingFailed", this.onAudioRenderingFailed);
            this.listenTo(this.model, "change:renderedBufferPlaying", this.onRenderedBufferPlayingChange);
            this.listenTo(this.model, "change:renderingBeingCreated", this.onRenderingBeingCreatedChange);
            this.listenTo(this.model, "change:renderedBufferPlaybackLoading", this.onRenderedBufferPlaybackLoadingChange);
            this.listenTo(this.model, "change:autoscroll", this.onAutoscrollChange);
            this.listenTo(this.model, "change:hasVideoSegment", this.onHasVideoSegmentChanged)
            this.listenTo(this.model, "change:isBeingSaved", this.onIsBeingSavedChange);
            this.listenTo(this.model.getSequencerSettings(), "change:noiseCancellationOn", this.onNoiseCancellationOnChange);
            this.listenTo(this.model.getSequencerSettings(), "change:showIgnoredContent", this.onShowIgnoredContentSettingChange);
            this.listenTo(this.model.getSequencerSettings(), "change:revealDeletedContent", this.onRevealDeletedContentSettingChange);
            this.listenTo(this.model.getSequencerSettings(), "change:showGapsBetweenWords", this.onShowGapNodesSettingChange);
            this.listenTo(this.model.getSequencerSettings(), "change:showEditBoundaries", this.onShowEditBoundariesSettingChange);
            this.listenTo(this.model.getSequencerSettings(), "change:showDarkTheme", this.onShowDarkThemeChange);
            this.listenTo(this.model.getSequencerSettings(), "change:autoscroll", this.onAutoscrollSettingChange);
            
            this.listenTo(this.model, "change:numberOfRenderingRequestPending", this.onNumberOfRenderRequestPendingChange);
            this.listenTo(this.model, "historyUpdated", this.onHistoryUpdated);
            this.listenTo(this.model, "paragraphStructureChanged", this._scheduleParagraphLayoutRebuild);
            this.listenTo(this.model.getSearchWidget(), "change:nodesInFocus", this.onNodeSetInSearchFocusChange);
            this.listenTo(this.model.getSearchWidget(), "change:indexOfNodeInFocus", this.onIndexOfNodeInFocusChange);
            this.listenTo(this.model.getSearchWidget(), "selectDeletedNode", this.onSelectDeletedNode);
            this.listenTo(this.model.getSearchWidget(), "change:searchOn", this.onSearchModeChange);
            this.listenTo(this.model.getSearchWidget(), "change:playbackOn", this.onPlaybackOnChange);
            this.listenTo(this.model.getSearchWidget(), "change:searchType", this.onSearchTypeChange)

            
            
            
            this.listenTo(this.model, "deleteOperationInteruptedBecauseOfWrapNodeOrphan", this.onDeletionNodeInterruptedBecauseOfWrapOrphanNode);
            this.listenTo(this.model, "selectedNodeNeedToBeNextToEachotherError", this.onSelectedNodeNeedToBeNextToEachotherError);
            this.listenTo(this.model, "videoResolutionChanged", this._onVideoResolutionChanged);
            this.listenTo(this.model, "projectConfigChanged", this._onProjectConfigChanged);
            this.listenTo(this.model, "themeChanged", this._onThemeChanged);
            this.listenTo(this.model, "durationChanged", this._onDurationChanged);
        }
        this._listenForKeyboardEvents();
    },


    
    onOrientationChangeFunction  : function(newViewPortHeigh, forceResizing) {
        if(this.$el.is(":visible") || forceResizing){
            this.$el.css("height", (this._heightMarginInPx? (newViewPortHeigh - this._heightMarginInPx):newViewPortHeigh)  + "px");
        }
    },
    
    events : {
        "click #ignoreSelectedNodesBtn:not(.disabled)": "onIgnoreSelectedNodesBtnClicked",
        "click #wrapWithMusicBtn:not(.disabled)": "onWrapWithMusicBtnClicked",
        "click #wrapWithMuteBtn:not(.disabled)": "onWrapWithMuteBtnClicked",
        "click #playFromBtn:not(.disabled)": "onPlayFromBtnClicked",
        "click #transcribedSequencerNodeBtn:not(.disabled)":"onTranscribeSequencerNodeBtnClicked",
        "click #viewSettingsForMusicWrapperBtn:not(.disabled)":"onViewSettingForMusicWrapperBtnClicked",
        "click #deleteMusicWrapperBtn:not(.disabled)":"onDeleteMusicWrapperBtn",
        "click #playSequencerBtn:not(.disabled)" : "onPlaySequencerBtnClicked",
        "click #stopSequencerBtn:not(.disabled)" : "onPlaySequencerBtnClicked",
        "click #autoScrollBtn:not(.disabled)" : "onAutoscrollButtonClicked",
        "click #noiseCancellationBtn:not(.disabled)" : "onNoiseCancellationButtonClicked",
        "click #showHelpBtn:not(.disabled)" : "onShowHelpBtnClicked",
        "click #turnSearchOnBtn:not(.disabled)": "onSearchTurnedOn",
        "click #showBeatifyMenuBtn:not(.disabled)":"onSoundEnhancerBtnClicked",
        "click #showAutomatedOperationsMenuBtn:not(.disabled)":"onShowAutomatedOperationsMenuBtnClicked",
        "click #insertBtn:not(.disabled)":"onInsertButtonClicked",
        "click #insertElementBtn:not(.disabled)":"onInsertElementButtonClicked",
        "click #insertVideoBtn:not(.disabled)":"onInsertVideoButtonClicked",
        "click #recordAndInsert:not(.disabled)":"onRecordAndInsertButtonClicked",
        "click #deleteAllExceptSelectedBtn:not(.disabled)":"onDeleteAllExceptSelectedNodesButtonClicked",
        "click #saveAsClipBtn:not(.disabled)": "onSaveAsClipButtonCliked",
        "click #createClipSelection:not(.disabled)": "onCreateClipButtonCliked",
        //"click #deleteAudioSequencerNodeBtn:not(.disabled)": "onDeleteAudioSequencerNodeBtnClicked",
        "click #deleteSequencerNodeBtn:not(.disabled)":"onDeleteSequencerNodeBtnClicked",
        "click #moreOptionBtn:not(.disabled)": "onMoreOptionsButtonClicked",
        "click #previousResultBtn:not(.disabled)": "onShowPreviousNodeFoundInSearch",
        "click #nextResultBtn:not(.disabled)": "onShowNextNodeFoundInSearch",
        "click #exit_search_btn:not(.disabled)": "onExitCurrentMode",
        "click #clearSearchInputBtn:not(.disabled)": "onClearSearchInput",
        "click #turnOnPlayOnSearchBtn:not(.disabled)": "onTurnSearchPlaybackOff",
        "click #turnOffPlayOnSearchBtn:not(.disabled)": "onTurnSearchPlaybackOn",
       // "click #correctBtn:not(.disable)": "onCorrectTranscriptBtnClicked",
        "click #editTranscriptBtn:not(.disabled)":"showContextMenuForCorrectingTranscripts",
        "click #configureViewBtn":"onShowConfigureViewPopup",
        "click #projectSettingsBtn":"onShowProjectSettingsPopup",
        "click #downloadClipBtn:not(.disable)":"onDownloadClipButtonClicked",
        "click #playSelectionBtn:not(:disabled)":"onPlaySearchSelectionAndSurroundingClicked",
        "click #playWithoutSelection:not(:disabled)":"onPlaySearchurroundingWithoutSelectionClicked",
        "click #deleteSelectionBtn:not(:disabled)":"onDeleteSelectionClicked",
        "click #removeAllHightlightedBtn:not(:disabled)":"onDeleteAllHighlightedClicked",
        "click #restoreDetetedNodeBtn:not(:disabled)":"onDeleteSequencerNodeRestoredButtonClicked",
        "click #shareProjectBtn:not(.disabled)":"onShareProjectBtnClicked",


        "click #undoBtn:not(.disabled)": "onUndoShortcutKeyPressed",
        "click #redoBtn:not(.disabled)": "onRedoShortcutKeyPressed",
        "mouseenter #playerSongPositionSlider":"_onUserStartedDraggingSlider",
        "mouseleave #playerSongPositionSlider":"_onUserStoppedDraggingSlider",
        "wheel .sequencer_node_container":"_onWheelScrollInSequencerContainer",
        //"dragover .sequencer_node_container" : "_onDragOver",
        //"dragleave .sequencer_node_container" : "_onDragLeave",
        //"drop .sequencer_node_container" : "_onDrop",

    },

    onShowHelpBtnClicked : function(event){
        this.trigger("showHelp");
    },

    onShareProjectBtnClicked : function(event){
        this.trigger("shareProject");
    },

    disableUploadButton : function(){
        this.$el.find("#insertBtn, #insertElementBtn, #insertVideoBtn").addClass("disabled");
    },

    disableTranscribeButton : function(){
        this.$el.find("#transcribedSequencerNodeBtn").addClass("disabled");
    },

    disableEditToolbar : function(){
        this.$el.find(".bottom_toolbar button").addClass("disabled");
        this.$el.find(".header_toolbar button").not("#showHelpBtn").addClass("disabled");
        this.$el.find("#shareProjectBtn").addClass("disabled").css("pointer-events", "none");
    },

    hideEditToolbar : function(){
        // Header toolbar: hide editing buttons, keep Search, Display settings, Help
        const headerButtonsToHide = [
            "#undoBtn", "#redoBtn",
            "#showAutomatedOperationsMenuBtn",
            "#noiseCancellationBtn",
            "#showBeatifyMenuBtn",
            "#shareProjectBtn",
            "#autoScrollBtn",
            "#savingtn", "#savedBtn"
        ];
        headerButtonsToHide.forEach(function(selector){
            this.$el.find(selector).hide();
        }.bind(this));
        // Hide the delimiter between save/undo buttons
        this.$el.find(".header_toolbar .button_delimiter").hide();

        // Bottom toolbar: hide editing buttons, keep play/stop and playback progress
        const bottomButtonsToHide = [
            "#viewSettingsForMusicWrapperBtn",
            "#ignoreSelectedNodesBtn",
            "#insertElementBtn",
            "#deleteMusicWrapperBtn",
            "#moreOptionBtn",
            "#playFromBtn"
        ];
        bottomButtonsToHide.forEach(function(selector){
            this.$el.find(selector).hide();
        }.bind(this));
        // Hide the always_displayed_context_menu section entirely for viewers
        this.$el.find(".bottom_toolbar .always_displayed_context_menu").hide();
    },

    hideShareButton : function(){
        this.$el.find("#shareProjectBtn").hide();
    },

    setShareButtonLoading : function(isLoading, savingLabel){
        const shareBtn$el = this.$el.find("#shareProjectBtn");
        if(!shareBtn$el.length){
            return;
        }
        if(isLoading){
            if(this._shareProjectBtnLoadingState == null){
                this._shareProjectBtnLoadingState = {
                    html: shareBtn$el.html(),
                    disabledClass: shareBtn$el.hasClass("disabled"),
                    pointerEvents: shareBtn$el.css("pointer-events"),
                    ariaBusy: shareBtn$el.attr("aria-busy")
                };
            }
            const labelText = savingLabel || "Saving…";
            shareBtn$el.addClass("disabled").attr("aria-busy", "true");
            shareBtn$el.html('<span class="icon pe-7s-refresh-2" style="font-weight: 400; animation: tr_share_spin 1s linear infinite; display: inline-block;"></span><label>' + _.escape(labelText) + '</label>');
            // Inject the spinner keyframes once. Cheaper than adding a new CSS file for a single-use animation.
            if(!document.getElementById("tr_share_spin_style")){
                const styleEl = document.createElement("style");
                styleEl.id = "tr_share_spin_style";
                styleEl.textContent = "@keyframes tr_share_spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }";
                document.head.appendChild(styleEl);
            }
        }else if(this._shareProjectBtnLoadingState != null){
            const previousState = this._shareProjectBtnLoadingState;
            shareBtn$el.html(previousState.html);
            shareBtn$el.toggleClass("disabled", previousState.disabledClass);
            if(previousState.pointerEvents){
                shareBtn$el.css("pointer-events", previousState.pointerEvents);
            }else{
                shareBtn$el.css("pointer-events", "");
            }
            if(previousState.ariaBusy == null){
                shareBtn$el.removeAttr("aria-busy");
            }else{
                shareBtn$el.attr("aria-busy", previousState.ariaBusy);
            }
            this._shareProjectBtnLoadingState = null;
        }
    },

    showGuestBanner : function(message){
        const banner$el = this.$el.find("#guest_access_banner");
        banner$el.find(".guest_banner_text").text(message);
        banner$el.css("display", "flex");
    },

    hideGuestBanner : function(){
        this.$el.find("#guest_access_banner").hide();
    },

    setMutationAccess : function(hasMutationAccess){
        this._hasMutationAccess = hasMutationAccess !== false;
        this.$el.attr("mutation_access", this.hasMutationAccess() ? "true" : "false");
        if(!this.hasMutationAccess()){
            this.$el.find("#undoBtn, #redoBtn").addClass("disabled");
            this.$el.find("#deleteSelectionBtn, #removeAllHightlightedBtn").prop("disabled", true);
            // Close any open context menus so they cannot trigger a mutation
            // after access has just been revoked.
            this._destroyContextMenuDisplayed();
            this._destroySpeakerContextMenuIfApplicable();
        }
        // Refresh the full selection-driven UI so toolbar buttons, menus and
        // other controls immediately reflect the new mutation-access state.
        this._onSelectionChange();
    },

    hasMutationAccess : function(){
        return this._hasMutationAccess !== false;
    },

    onSearchModeChange: function(){
        const searchOn =  this.model.getSearchWidget().isSearchOn();
        this.$el.attr("search_mode_on", searchOn?"true": "false");
        this.$el.attr("show_search_widget_on_left_side", SHOW_SEARCH_WIDGET_ON_LEFT_SECTION_OF_EDITOR?"true": "false");
        this.onSearchTypeChange();
        if(searchOn){
            this.onClearSearchInput();
            this._updatePreviousAndNextSearchButtons();
            this.onSearchTurnedOn();
        }
    },

    onSearchTypeChange : function(){
        const searchType =  this.model.getSearchWidget().getSearchType();
        const searchParams = this.model.getSearchWidget().getSearchParams();
        switch(searchType){
            case this.model.getSearchWidget().SEARCH_TYPE.DISFLUENCY_SEARCH:
                this.$el.attr("search_type", "disfluency");
                break;
            case this.model.getSearchWidget().SEARCH_TYPE.TEXT_SEARCH:
                this.$el.attr("search_type", "text");
                break;
            case this.model.getSearchWidget().SEARCH_TYPE.FILLER_WORDS:
                this.$el.attr("search_type", "filler_words");
                break;
            case this.model.getSearchWidget().SEARCH_TYPE.SILENCES:
                this.$el.attr("search_type", "silences");
                this.$el.find(".silences_search_label").html(`${searchParams && searchParams.maxSilenceInMilliseconds? window.getI18n(ti18n, "SILENCES_FOUND_OVER") + " "+ searchParams.maxSilenceInMilliseconds/1000+"s": window.getI18n(ti18n, "SILENCES_FOUND")}`)
                break;
        }
    },

    onPlaybackOnChange: function(){
        const playbackOn =  this.model.getSearchWidget().getPlaybackOn();
        this.$el.attr("search_playback_on", playbackOn?"true": "false");
    },

    onHasVideoSegmentChanged : function(){
        const hasVideo = this.model.getHasVideoSegment() && window.chrome && EDIT_VIDEO_FILES;

        if(hasVideo){
            this.$el.attr("do_not_display_video", "false");
            // Initialize video renderer (Timeloom or VideoContext based on feature flag)
            this.initTimeloomRenderer();
        }else{
            this._teardownActiveVideoRenderer();
            this.$el.attr("do_not_display_video", "true");
            if(this.model.getHasVideoSegment() && EDIT_VIDEO_FILES){
                window.alertWarningMessage(window.getI18n(ti18n, "TO_EDIT_VIDEO_PLEASE_USE_CRHOME"));
            }
        }
    },

    _teardownActiveVideoRenderer: function() {
        // Invalidate any in-flight Timeloom init attempt before teardown
        // finishes. A stale async onReady from an earlier root must not
        // resurrect the renderer or re-subscribe historyUpdated listeners
        // after the React root has already been unmounted.
        this._timeloomRendererInitAttemptId = (this._timeloomRendererInitAttemptId || 0) + 1;
        this._clearTimeloomRendererReadyWatchdog();
        if (this._rendererRecreationTimeout) {
            clearTimeout(this._rendererRecreationTimeout);
            this._rendererRecreationTimeout = null;
        }
        if (this.model) {
            this.stopListening(this.model, "historyUpdated", this.onModernRendererHistoryUpdated);
        }
        const modernVideoRenderer = this._modernVideoRenderer;
        const videoContext = this._videoCtx;
        this._modernVideoRenderer = null;
        this._videoCtx = null;
        if (modernVideoRenderer && typeof modernVideoRenderer.destroy === "function") {
            try {
                modernVideoRenderer.destroy();
            } catch (error) {
                console.error('[SequencerView] Error destroying modern video renderer:', error);
            }
        }
        if (this._modernRendererRoot) {
            try {
                this._modernRendererRoot.unmount();
            } catch (error) {
                console.error('[SequencerView] Error unmounting modern renderer:', error);
            } finally {
                this._modernRendererRoot = null;
            }
        }
        if (videoContext) {
            try {
                videoContext.destroy?.();
            } catch (error) {
                console.error('[SequencerView] Error destroying legacy video context:', error);
            }
        }
        if (this.model) {
            if (typeof this.model.setModernVideoRenderer === "function") {
                try {
                    this.model.setModernVideoRenderer(null);
                } catch (error) {
                    console.error('[SequencerView] Error clearing modern video renderer on model:', error);
                    this.model._modernVideoRenderer = null;
                }
            } else {
                this.model._modernVideoRenderer = null;
            }
            if (typeof this.model.setVideoContext === "function") {
                try {
                    this.model.setVideoContext(null);
                } catch (error) {
                    console.error('[SequencerView] Error clearing legacy video context on model:', error);
                    this.model._videoContext = null;
                }
            } else {
                this.model._videoContext = null;
            }
        }
        this._initializingModernRenderer = false;
        this._timeloomRendererRecoveryAttempts = 0;
        this._videoContextFallbackTried = false;
    },

    onIsBeingSavedChange: function(){
        const isBeingSaved = this.model.get("isBeingSaved");
        this.$el.attr("is_project_being_saved", isBeingSaved?"true":"false");
    },

    _initializeParagraphObserver: function(){
        return  new IntersectionObserver((function(entries) {
            entries.forEach((function(entry){
              if (entry.isIntersecting) {
                // The element is in the viewport
                // You can perform your desired actions here
                const paragraphViewCid = entry.target.getAttribute("view_cid");
                if(paragraphViewCid){
                    const paragraphView = this._paragraphViewCidToParagraphView[paragraphViewCid];
                    if(paragraphView){
                        paragraphView.showHideParagraphSummary(false);
                    }
                }
              } else {
                // The element is not in the viewport
                // You can handle this situation as needed
                const paragraphViewCid = entry.target.getAttribute("view_cid");
                if(paragraphViewCid){
                    const paragraphView = this._paragraphViewCidToParagraphView[paragraphViewCid];
                    if(paragraphView){
                        paragraphView.showHideParagraphSummary(true);
                    }
                }
              }
            }).bind(this));
          }).bind(this));
    },

    _onWheelScrollInSequencerContainer : function(){
        this._isUserManuallyScrolling = true;
    },

    onTurnSearchPlaybackOn: function(){
        if(ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR){
            this.trigger("turnSearchPlaybackOn");
        }
    },

    onShowConfigureViewPopup : function(){
        this.trigger("showConfigureViewPopup");
    },

    onShowProjectSettingsPopup : function(){
        this.trigger("showProjectSettingsPopup");
    },

    onTurnSearchPlaybackOff: function(){
        if(ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR){
            this.trigger("turnSearchPlaybackOff");
        }
    },

    onSoundEnhancerBtnClicked: function(){
        if(!this.isOnboardingDisplayed()){
            this.trigger("showSoundEnhancerSettings");
        }
    },

    onShowAutomatedOperationsMenuBtnClicked: function(){
        if(!this.isOnboardingDisplayed()){
            this.trigger("showAutomatedOperationsMenu");
        }
    },

    isSequencerSettingsDisplayed : function(){
        return  this.$el.attr("show_sequencer_settings") === "true"
    },

    setSequencerSettingsDisplayed : function(show){
        this.$el.attr("show_sequencer_settings", show ?"true":"false");
        if(show){
            this.showBeatifyMenuBtn$el.addClass("active");
        }else{
            this.showBeatifyMenuBtn$el.removeClass("active");
        }
    },
    onPlaySearchSelectionAndSurroundingClicked: function(){
      this.trigger("playSelectionAndSurroundings")  
    },

    onPlaySearchurroundingWithoutSelectionClicked: function(){
        this.trigger("playSurroundingsWithoutSelection")  
    },

    onDeleteSelectionClicked: function(){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this.trigger("deleteSearchSelection");
        }
    },

    onDeleteAllHighlightedClicked: function(){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this.trigger("deleteAllSearchSelection");
        }
    },

    onDeleteSequencerNodeRestoredButtonClicked: function(){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this.trigger("restoreDeleteNode");
        }
    },

    onShowSequencerSettingsBtnClicked:function(){
        this.setSequencerSettingsDisplayed(!this.isSequencerSettingsDisplayed());
    },

    isSequencerAutomatedOperationsMenuDisplayed : function(){
        return  this.$el.attr("show_sequencer_automated_operations_menu") === "true"
    },

    setSequencerAutomationOperationsMenuDisplayed : function(show){
        this.$el.attr("show_sequencer_automated_operations_menu", show ?"true":"false");
        if(show){
            this.showBeatifyMenuBtn$el.addClass("active");
        }else{
            this.showBeatifyMenuBtn$el.removeClass("active");
        }
    },

    onShowSequencerAutomationOperationsMenuBtnClicked:function(){
        this.setSequencerAutomationOperationsMenuDisplayed(!this.isSequencerAutomatedOperationsMenuDisplayed());
    },

    getSoundEnhancerButton$el : function(){
        return this.showBeatifyMenuBtn$el;
    },

    getShowAutomatedOperationsMenuBtn$el : function(){
        return this.showAutomatedOperationsMenuBtn$el;
    },

    getShowHelpMenuBtn$el : function(){
        return this.showHelpBtn$el;
    },

    getConfigureViewBtn$el : function(){
        return this.configureViewBtn$el;
    },

    getProjectSettingsBtn$el : function(){
        return this.projectSettingsBtn$el;
    },


    _onSequencerResetted : function(){
        this.unselectCurrentlySelectedSequencerNodes();
        for(let nodeCid in this._sequencerNodeCidToSequencerNodeViewMap){
            const sequencerNodeView = this._sequencerNodeCidToSequencerNodeViewMap[nodeCid];
            if(sequencerNodeView){
                this._disposeDetachedSequencerNodeView(nodeCid, sequencerNodeView);
            }
        }
        const paragraphContainerViewsToDestroy = this._arrayOfParagraphContainerViews.slice();
        for(let i = 0; i < paragraphContainerViewsToDestroy.length; i++){
            this._destroyParagraphContainerView(paragraphContainerViewsToDestroy[i]);
        }
        if(this.sequencerNodeContainer$el){
            this.sequencerNodeContainer$el.find(".sequencer_paragraph").remove();
        }
        this._sequencerNodeCidToSequencerNodeViewMap = {};
        this._arrayOfSequencerNodeViewCidBeingListenedTo = [];
        this._arrayOfParagraphContainerViewCidBeingListenedTo = [];
        this._arrayOfParagraphContainerViews = [];
        this._paragraphViewCidToParagraphView = {};
        this._sequencerNodeElArray = [];
        this._sequencerNodeElToIndexMap = new Map();
        this._currentlyDisplayedTippyInstance = null;
        this._selectedNodeInfo = null;
        this._lastViewMapRebuildAt = null;
        this._sortableInstance = null;
        this._sequencerNodeViewCurrentlyHighlightedAsPlaying = null;
        this._isUserManuallyScrolling = false;
        this._warningDisplayedAboutNoiseCancellationDuration = false;
        this._warningDisplayedAboutMagicSoundEnhancerDuration = false;
        this._beautifyMenuDisplayed = false;
        this._paragraphLayoutRebuildPending = false;
        this._paragraphLayoutRebuildScheduled = false;
        this._paragraphLayoutRefreshAfterStandaloneRemovePending = false;
        this._paragraphLayoutRefreshAfterStandaloneRemoveScheduled = false;
        this._paragraphContainerViewsPendingCleanup = new Set();
        this._paragraphContainerCleanupScheduled = false;
        // Invalidate the cached analysis so a post-reset call to
        // _getCurrentParagraphLayoutAnalysis does not return descriptors
        // built from the pre-reset timeline.
        this._paragraphLayoutAnalysis = null;
        if(this._paragraphObserver && this._paragraphObserver.disconnect){
            this._paragraphObserver.disconnect();
            this._paragraphObserver = this._initializeParagraphObserver();
        }
    },


    _getClosestHTMLElementInDistance: function(arrayOfElements, clientX, clientY, onlyCompareWithElementOnSameLine){
        let closestEl =  null;
        const textLineHeight = 30;
        let closestElDistance = null;
        if(arrayOfElements){
            arrayOfElements.map(function( index, el){
                if(el){
                    const boundingClientRect = el.getBoundingClientRect();
                    if(boundingClientRect){
                        const a = boundingClientRect.x - clientX;
                        const b = boundingClientRect.y - clientY;
                        if(!onlyCompareWithElementOnSameLine  || textLineHeight *3 >= Math.abs(b)){
                            const distance = Math.sqrt( a*a + b*b );
                            if(!closestEl || distance < closestElDistance){
                                closestEl =  el;
                                closestElDistance = distance;
                            }
                        }
                    }
                }

            });
        }
        return closestEl;
    },

    

    _getClosestSequencerNodeViewToPosition: function(clientX, clientY){
        const elements = document.elementsFromPoint(clientX, clientY);
        let closestSequencerNodeViewFound =  null;
        for(let i =0; i < elements.length; i++){
            const el = elements[i];
            if(el.classList.contains("sequencer_node")){
                const closestSequencerNodeCidFound = el.getAttribute("segment_node_cid");
                closestSequencerNodeViewFound = closestSequencerNodeCidFound?this.getSequencerNodeViewFromSequencerNodeCid(closestSequencerNodeCidFound): null;
                break;
            }
        }
        if(!closestSequencerNodeViewFound){
            const lastElementsBeforeLineBreak = this.$el.find(".sequencer_node_container fullstop.sequencer_node.punctiation_audio_segment_node:nth-of-type(5n), .sequencer_node_container fullstop.sequencer_node.punctiation_audio_segment_node:last-of-type").map((function(index, el){
                const fullstopSequencerNodeCId = el.getAttribute("segment_node_cid");
                const fullstopSequencerNodeView = fullstopSequencerNodeCId?this.getSequencerNodeViewFromSequencerNodeCid(fullstopSequencerNodeCId): null;
                if(fullstopSequencerNodeView){
                    const visibleSequencerNode = fullstopSequencerNodeView.getModel().getPreviousVisibleSequencerNode();
                    if(visibleSequencerNode){
                        const visibleSequencerNodeView = this.getSequencerNodeViewFromSequencerNodeCid(visibleSequencerNode.cid);
                        return visibleSequencerNodeView.$el.get(0);
                    }
                }
            }).bind(this));

            if(!closestSequencerNodeViewFound){
                closestSequencerNodeViewFound = this._getSequencerNodeViewFromEl(this._getClosestHTMLElementInDistance(lastElementsBeforeLineBreak, clientX, clientY, false));
            }
        }

        return closestSequencerNodeViewFound;
    },

    _getSequencerNodeViewFromEl : function(el){
        if(el && el.classList.contains("sequencer_node")){
            const cid = el.getAttribute("segment_node_cid");
            return this.getSequencerNodeViewFromSequencerNodeCid(cid);
        }
    },

    _getClosestSequencerNodeViewFromEvent : function(e){
        return this._getClosestSequencerNodeViewToPosition(e.clientX, e.clientY);
    },

    /*_onDragOver : function(e){
        e.originalEvent.preventDefault();
        if(this.$el.find(".sequencer_node_container .node_drag_over").length == 0){
            const closestSequencerNodeViewFound = this._getClosestSequencerNodeViewFromEvent(e);
            if(closestSequencerNodeViewFound){
                this.$el.find(".sequencer_node_container .node_drag_over").removeClass("node_drag_over");
                this.$el.find(".sequencer_node_container .node_drag_over_after").removeClass("node_drag_over_after");
                $(closestSequencerNodeViewFound).addClass("node_drag_over_after");
            }
        }else{
            this.$el.find(".sequencer_node_container .node_drag_over_after").removeClass("node_drag_over_after");
        }
    },

    _onDragLeave : function(){
        this.$el.find(".sequencer_node_container .node_drag_over_after").removeClass("node_drag_over_after");
    },

    _onDrop : function(e){
        e.originalEvent.preventDefault();
        const sequencerNodeDragAfterTarget$el = this.$el.find(".sequencer_node_container .node_drag_over_after");
        if(sequencerNodeDragAfterTarget$el.length > 0){
            sequencerNodeDragAfterTarget$el.removeClass("node_drag_over_after");
            const sequencerNodeElCid = sequencerNodeDragAfterTarget$el.attr("segment_node_cid");
            const sequencerNodeDragAfterTargetView = this._sequencerNodeCidToSequencerNodeViewMap[sequencerNodeElCid];
            if(sequencerNodeDragAfterTargetView){
                const file = e.originalEvent.dataTransfer.files[0];
                if(e.originalEvent.dataTransfer.files.length > 0){
                    this._onFileInsertedAtTheEnd(file);
                    this.trigger("uploadFileAndInsertAfter",file, sequencerNodeDragAfterTargetView.getModel());
                }else{

                    const dropInfo  = {"modelCidOfSequencerNodeBeingDrop": e.originalEvent.dataTransfer.getData("text/plain"), "sequencerNodeViewTarget": sequencerNodeDragAfterTargetView};
                    this._onSequencerNodeBeingDroppedAfterSequencerNode(dropInfo)
                }
            }

        }
    },*/



    onInsertButtonClicked : function(event){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isInsertActionAvailable(),
        })){
            this.trigger("insertAudioNodeTriggered", true);
        }
        if(event){
            event.stopPropagation()
        }
    },

    onInsertVideoButtonClicked : function(event){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isInsertActionAvailable(),
        })){
            this.trigger("insertVideoNodeTriggered", true);
        }
        if(event){
            event.stopPropagation()
        }
    },

    onRecordAndInsertButtonClicked : function(event){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isInsertActionAvailable(),
        })){
            this.trigger("recordAndInsertTriggered", true);
        }
        if(event){
            event.stopPropagation()
        }
    },

    onDeleteAllExceptSelectedNodesButtonClicked: function(event){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isDeleteActionAvailable(),
        })){
            this.trigger("deleteAllExceptSelectedNodes", true);
        }
        if(event){
            event.stopPropagation()
        }
    },

    setUnsafeToRemove: function(unsafeToRemove){
        this._unsafeToRemove = unsafeToRemove;
    },

    isUnsafeToRemove: function(){
        return this._unsafeToRemove;
    },

    onInsertElementButtonClicked: function(event){
        if(!this.isInsertElementAvailable()){
            if(event){
                event.stopPropagation();
            }
            return;
        }
        if(!this._currentInsertElementContextMenuDisplayedInstance){
            const menuInfoArray = [];
            this._destroyContextMenuDisplayed(true);
            if(this.isWrapWithBackgroundMusicActionAvailable()){
                menuInfoArray.push(Utils.getInstance().createMenuInfoItem("wrapSelectionWithMusic", window.getI18n(ti18n,"WRAP_WITH_AUDIO"), (e)=>{this.destroyInsertElementContextMenuDisplayedInstance(); this.onWrapWithMusicBtnClicked(e)}, `<i class="icon pe-7s-music music_icon" ></i>`));
            }
            if (MUTE_MENU_LOCATION === 'add' && this._canSelectionBeWrappedWithMute()) {
                menuInfoArray.push(Utils.getInstance().createMenuInfoItem("wrapSelectionWithMute", window.getI18n(ti18nMute, "ADD_MUTE_WRAP_MENU_LABEL"), (e)=>{this.destroyInsertElementContextMenuDisplayedInstance(); this.onWrapWithMuteBtnClicked(e)}, `<i class="icon pe-7s-mute mute_icon"></i>`));
            }
            if(this.isInsertActionAvailable()){
                menuInfoArray.push(Utils.getInstance().createMenuInfoItem("insertMusic", window.getI18n(ti18n,"INSERT"), (e)=>{this.destroyInsertElementContextMenuDisplayedInstance(); this.onInsertButtonClicked(e)}, `<i class="icon pe-7s-volume" ></i>`));
                menuInfoArray.push(Utils.getInstance().createMenuInfoItem("insertVideo", window.getI18n(ti18n,"INSERT_VIDEO_AT_START"), (e)=>{this.destroyInsertElementContextMenuDisplayedInstance(); this.onInsertVideoButtonClicked(e)}, `<i class="icon pe-7s-film" ></i>`));
                menuInfoArray.push(Utils.getInstance().createMenuInfoItem("recordAndInsert", window.getI18n(ti18n,"RECORD_AND_INSERT_BEFORE"), (e)=>{this.destroyInsertElementContextMenuDisplayedInstance(); this.onRecordAndInsertButtonClicked(e)}, `<i class="icon pe-7s-micro" ></i>`));
            }

            const contextMenuTippyJSInstance = Utils.getInstance().createContextMenu(menuInfoArray, event.target, this.sequencerNodeContainer$el.get(0), "bottom", true);
            this._currentInsertElementContextMenuDisplayedInstance = contextMenuTippyJSInstance;

            // Add viewport validation for programmatic clicks
            if (contextMenuTippyJSInstance && contextMenuTippyJSInstance.popper) {
                requestAnimationFrame(() => {
                    // Verify menu wasn't destroyed during async callback
                    if (this._currentInsertElementContextMenuDisplayedInstance !== contextMenuTippyJSInstance) {
                        return;
                    }

                    const popperRect = contextMenuTippyJSInstance.popper.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const viewportWidth = window.innerWidth;

                    // Check if popper is out of viewport
                    if (popperRect.top < 0 || popperRect.left < 0 ||
                        popperRect.bottom > viewportHeight || popperRect.right > viewportWidth) {
                        // Force reposition
                        if (contextMenuTippyJSInstance.popperInstance) {
                            contextMenuTippyJSInstance.popperInstance.update();
                        }
                    }
                });
            }
        }
        if(event){
            event.stopPropagation()
        }
    },

    destroyInsertElementContextMenuDisplayedInstance : function(){
        if(this._currentInsertElementContextMenuDisplayedInstance){
            if( this._currentInsertElementContextMenuDisplayedInstance.destroy){
                this._currentInsertElementContextMenuDisplayedInstance.destroy();
            }
            if( this._currentInsertElementContextMenuDisplayedInstance.close){
                this._currentInsertElementContextMenuDisplayedInstance.close();
            }
            this._currentInsertElementContextMenuDisplayedInstance = null;
        }
    },

    destroySubContextMenuViewIfApplicable : function(){
        if(this._subContextMenuView){
            if( this._subContextMenuView.destroy){
                this._subContextMenuView.destroy();
            }
            if( this._subContextMenuView.close){
                this._subContextMenuView.close();
            }
        }
    },

    setSubContextMenuView : function(subContextMenuView){
        this.destroySubContextMenuViewIfApplicable();
        this._subContextMenuView =  subContextMenuView;
    },  


    onMoreOptionsButtonClicked: function(event){
        if(!this.isMoreOptionAvailable()){
            if(event){
                event.stopPropagation()
            }
            return;
        }
        if($.contains(this.bottomBar$el.get(0), event.target)){
            this.trigger("showMoreOptionMenu", $(event.target), function(){}, "left bottom");
        }else{
            this.trigger("showMoreOptionMenu", $(event.target), function(){}, "bottom right");
        }
        
        if(event){
            event.stopPropagation()
        }
    },



    onSaveAsClipButtonCliked : function(){
        this._destroyContextMenuDisplayed();
        if(this.isClippingActionAvailable()){
            this.trigger("saveAsClipTriggered", true);
        }
    },

    onCreateClipButtonCliked : function(){
        this._destroyContextMenuDisplayed();
        if(this.isCreateClipActionAvailable()){
            this.trigger("createClipTriggered", true);
        }
    },

    onCopySelectionToClipboardTriggered: function(){
        this._destroyContextMenuDisplayed();
        if(this.isCopyActionAvailable()){
            this.trigger("copySelectionToClipboard");
        }
    },

    onPasteClipboardBeforeSelectionTriggered: function(){
        if(this._editingLocked){
            return false;
        }
        this._destroyContextMenuDisplayed();
        if(this.isPasteActionAvailable()){
            this.trigger("pasteClipboardBeforeSelection");
        }
    },

    onCutAndCopySelectionToClipboardTriggered: function(){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isCutActionAvailable(),
        })){
            this.trigger("cutAndCopySelectionToClipboard");
        }
    },

    onSelectAllTriggered: function(){
        if(this.model.getFirstNode() && this.model.getLastNode()){
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid( this.model.getLastNode().cid, this.model.getFirstNode().cid), false, true);
        }
    },

    getLastNodeSequencerNodeView: function(){
        if(this.model.getLastNode() && this.model.getLastNode().cid){
            return this.getSequencerNodeViewFromSequencerNodeCid(this.model.getLastNode().cid);
        }
    },

    onDeleteButtonClicked: function(event){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isDeleteActionAvailable(),
        })){

            // Check if it's a wrap node and route to appropriate handler
            if(this.isSelectedNodeAStartOrEndWrapNode()){
                const selectionInfo = this.getSelectionNode();
                const node = selectionInfo ? selectionInfo.startSequencerNodeModel : null;
                const wrapType = node ? WrapNodeTypes.getWrapNodeTypeForSequencerNode(node) : null;

                // Route music wraps through the legacy delete path and all other wraps
                // through the generic wrap-delete flow.
                if(
                    wrapType === WrapNodeTypes.MUSIC
                    || (node && (Utils.getInstance().isStartMusicWrapSequencerNodeInstance(node)
                        || Utils.getInstance().isEndMusicWrapSequencerNodeInstance(node)))
                ){
                    this.onDeleteMusicWrapperBtn();
                } else {
                    this.onDeleteWrapNodeBtn();
                }
            }else{
                if(this.isSelectedNodeAnAudioNode()){
                    this.onDeleteSequencerNodeBtnClicked();
                }
                if(this.isSelectedNodeAnVideoNode()){
                    this.onDeleteSequencerNodeBtnClicked();
                }
            }
        }
        if(event){
            event.stopPropagation()
        }
    },

    /*onDeleteAudioSequencerNodeBtnClicked : function(event){
        this._destroyContextMenuDisplayed();
        this.trigger("deleteAudioSequencerNodeTriggered");
        if(event){
            event.stopPropagation()
        }
    },*/

    onDeleteSequencerNodeBtnClicked : function(event){
        this._destroyContextMenuDisplayed();
        if(canTriggerSequencerMutation({
            hasMutationAccess: this.hasMutationAccess(),
            actionAvailable: this.isDeleteActionAvailable(),
        })){
            this.trigger("deleteSequencerNodeTriggered");
        }
        if(event){
            event.stopPropagation()
        }
    },

    onDownloadClipButtonClicked : function(event){
        this._destroyContextMenuDisplayed();
        this.trigger("downloadClipTriggered");
        if(event){
            event.stopPropagation()
        }
    },


    onNumberOfRenderRequestPendingChange : function(){
        this.$el.attr("is_there_pending_render_request",this.model.isTherePendingRenderingRequest())
    },

    onRenderingBeingCreatedChange : function(){
        this.$el.attr("rendering_being_created",this.model.isRenderingBeingCreated())
        if(!this.model.isRenderingBeingCreated()){
            this.onRenderedBufferPlayingChange();
        }
    },

    onRenderedBufferPlaybackLoadingChange : function(){
        this.$el.attr("rendered_buffer_playback_loading",this.model.isRenderedBufferPlaybackLoading());
        if(!this.model.isRenderedBufferPlaybackLoading()){
            this.onRenderedBufferPlayingChange();
        }
    },

    /**
     * Set the video seek loading state.
     * Shows loading indicator while video renderer is seeking/rendering a frame.
     * @param {boolean} isLoading - Whether video seek is in progress
     */
    setVideoSeekLoading: function(isLoading) {
        this.$el.attr("video_seek_loading", isLoading ? "true" : "false");
    },

    onHistoryUpdated : function(){
        const canUndoOperation = this.model.getHistoryManagement().canUndoOperation();
        const canRedoOperation = this.model.getHistoryManagement().canRedoOperation();
        if(canUndoOperation && this.hasMutationAccess()){
            this.undoBtn$el.removeClass("disabled");
        }else{
            this.undoBtn$el.addClass("disabled");
        }
        if(canRedoOperation && this.hasMutationAccess()){
            this.redoBtn$el.removeClass("disabled");
        }else{
            this.redoBtn$el.addClass("disabled");
        }
    },

    onRenderedBufferPlayingChange : function(){
        this.$el.attr("rendering_buffer_playing",this.model.isRenderedBufferPlaying());
        // Note: rendered_buffer_playback_loading is managed exclusively by onRenderedBufferPlaybackLoadingChange
        // and the stall monitor. Writing it here from the model would clobber the stall monitor's DOM value.
        if(this.model.isRenderedBufferPlaying()){
            this._startFunctionToUpdatePlaybackProgress();
        }else{
            this._stopFunctionToUpdatePlaybackProgress();
            this._resetPlaybackStallMonitoring();
        }
    },

    onPlaySequencerBtnClicked : function(event){
        if(event){
            event.stopPropagation();
        }
        if(this.model && this.model.isTherePendingRenderingRequest()){
            return;
        }
        this.trigger("playPauseSequencer");
    },

    

    _startFunctionToUpdatePlaybackProgress : function(){
        // Guard: if a loop is already running, do nothing.
        // Backbone event chains can trigger this from within an active RAF callback,
        // which would otherwise spawn a second parallel loop.
        if(this._isPlaybackProgressLoopActive || this._updateRequestAnimationFrameId){
            return;
        }
        this._isPlaybackProgressLoopActive = true;
        this._resetPlaybackStallMonitoring();
        this._updateRequestAnimationFrameId = window.requestAnimationFrame(this._updatePlaybackInfo.bind(this));
    },

    _resetPlaybackStallMonitoring : function(){
        this._lastMonitoredPlaybackProgressInMilliseconds = null;
        this._lastMonitoredPlaybackAudioContextCurrentTime = null;
        this._lastMonitoredPlaybackProgressTimestamp = null;
        this._playbackPotentialStallStartedAt = null;
        this._hasLoggedPotentialPlaybackStall = false;
    },

    _startPlaybackStallRecovery : function(recoveryPromise){
        if(!recoveryPromise || typeof recoveryPromise.then !== "function"){
            this._playbackStallRecoveryPromise = null;
            return;
        }
        this._playbackStallRecoveryPromise = recoveryPromise.then((function(result){
            this._playbackStallRecoveryPromise = null;
            return result;
        }).bind(this), (function(error){
            this._playbackStallRecoveryPromise = null;
            console.error("failed to recover from stalled playback. Error:" + error);
            return null;
        }).bind(this));
    },

    _updatePlaybackInfo : function(){
        // The slider/cursor updates on every rAF tick for smooth visual tracking.
        // Text labels (time display) are throttled to ~15fps (every 66ms) because
        // their DOM mutations cause video playback stutters via layout recalculation.
        // The stall monitor also runs every rAF tick for prompt detection.
        const durationInMilliseconds  = this.model.getDurationInMilliseconds();
        const playbackProgressInMilliseconds  = this.model.getPlaybackProgressInMilliseconds();
        if(durationInMilliseconds > 0){
            const percentageOverHundred = playbackProgressInMilliseconds  * 100 / durationInMilliseconds;
            if(this._playerSliderEl && this._playerSliderEl.noUiSlider && !this._playerSliderEl._isUserDragged){
                this._playerSliderEl.noUiSlider.set(percentageOverHundred);
            }
        }
        var now = performance.now();
        var PLAYBACK_UI_UPDATE_INTERVAL_MS = 66;
        var shouldUpdateTextLabels = !this._lastPlaybackUIUpdateTime || (now - this._lastPlaybackUIUpdateTime >= PLAYBACK_UI_UPDATE_INTERVAL_MS);
        if(shouldUpdateTextLabels){
            this._lastPlaybackUIUpdateTime = now;
            this.totalTime$el.html(Utils.getInstance().formatPlaybackPositionToString(durationInMilliseconds/1000));
            this.timeElapsed$el.html(Utils.getInstance().formatPlaybackPositionToString(playbackProgressInMilliseconds/1000));
        }
        this.monitorPlaybackStateInCasePlaybackStalled();
        if(this._isPlaybackProgressLoopActive){
            this._updateRequestAnimationFrameId = requestAnimationFrame(this._updatePlaybackInfo.bind(this));
        }
    },

    monitorPlaybackStateInCasePlaybackStalled : function(){
        //this might be caused because the audiocontext magically stopped working
        try{
            if(this.model.isPlaying()){
                const shouldMonitorForPlaybackStalls =
                    this.model.hasPlaybackStarted &&
                    this.model.hasPlaybackStarted() &&
                    !this.model.isRenderedBufferPlaybackLoading() &&
                    !this._playbackStallRecoveryPromise;
                if(!shouldMonitorForPlaybackStalls){
                    if(!this._isFirefoxBrowser() && !this.model.isRenderedBufferPlaybackLoading()){
                        if(this.$el.attr("rendered_buffer_playback_loading") != "false"){
                            this.$el.attr("rendered_buffer_playback_loading",false);
                        }
                    }
                    this._resetPlaybackStallMonitoring();
                    return;
                }
                const timeInMillisecondsToRestartAfterStalled = TIME_IN_MILLISEC_TO_TRIGGER_RESTART_AFTER_STALLED;
                const lastMonitoredPlaybackProgressInMilliseconds = this._lastMonitoredPlaybackProgressInMilliseconds;
                const lastMonitoredPlaybackAudioContextCurrentTime = this._lastMonitoredPlaybackAudioContextCurrentTime;
                const lastMonitoredPlaybackProgressTimestamp = this._lastMonitoredPlaybackProgressTimestamp;
                const playbackProgressInMilliseconds  = this.model.getPlaybackProgressInMilliseconds();
                const playbackAudioContextCurrentTime = this.model.getPlaybackAudioContextCurrentTime();

                // Skip stall detection during windowed decode wait and for a grace period
                // after decode completes to avoid false-positive restarts.
                const isWaitingForDecode = this.model.isWaitingForWindowedDecode();
                const decodeCompletedAt = this.model.getWindowedDecodeCompletedTimestamp();
                const WINDOWED_DECODE_GRACE_PERIOD_MS = 2000;
                const inGracePeriod = decodeCompletedAt && ((new Date()).getTime() - decodeCompletedAt < WINDOWED_DECODE_GRACE_PERIOD_MS);
                if (isWaitingForDecode || inGracePeriod) {
                    // Reset stall timer so timeout doesn't accumulate during decode/grace period
                    this._lastMonitoredPlaybackProgressInMilliseconds = playbackProgressInMilliseconds;
                    this._lastMonitoredPlaybackAudioContextCurrentTime = playbackAudioContextCurrentTime;
                    this._lastMonitoredPlaybackProgressTimestamp = (new Date()).getTime();
                    return;
                }

                const now = (new Date()).getTime();
                if(lastMonitoredPlaybackProgressTimestamp == null || lastMonitoredPlaybackProgressInMilliseconds == null || lastMonitoredPlaybackAudioContextCurrentTime == null){
                    this._lastMonitoredPlaybackProgressInMilliseconds = playbackProgressInMilliseconds;
                    this._lastMonitoredPlaybackAudioContextCurrentTime = playbackAudioContextCurrentTime;
                    this._lastMonitoredPlaybackProgressTimestamp = now;
                    return;
                }
                if(now - lastMonitoredPlaybackProgressTimestamp < MIN_TIME_BETWEEN_STALL_MONITOR_SAMPLES_MS){
                    // Compare playback state over a meaningful wall-clock span.
                    // Sampling every requestAnimationFrame can produce false stalls
                    // when adjacent frames land only a few milliseconds apart.
                    return;
                }
                const playbackProgressDeltaInMilliseconds = Math.abs(playbackProgressInMilliseconds - lastMonitoredPlaybackProgressInMilliseconds);
                const playbackAudioContextCurrentTimeDelta = Math.abs(playbackAudioContextCurrentTime - lastMonitoredPlaybackAudioContextCurrentTime);
                const isPotentialPlaybackStall =
                    this.model.canPlayThrough() &&
                    playbackProgressDeltaInMilliseconds <= STALLED_PLAYBACK_PROGRESS_EPSILON_MS &&
                    playbackAudioContextCurrentTimeDelta <= STALLED_PLAYBACK_AUDIO_CONTEXT_EPSILON_SECONDS;
                if(isPotentialPlaybackStall){
                    if(this._playbackPotentialStallStartedAt == null){
                        this._playbackPotentialStallStartedAt = lastMonitoredPlaybackProgressTimestamp;
                    }
                    if(!this._isFirefoxBrowser()){
                            //not updating the play button because is seems to be creating some flickering in Firefo
                            //that is not bad anyway because the issue doesn't occurs in Firefox
                            //So far it only seems to be a Chrome and Opera issue
                        if(this.$el.attr("rendered_buffer_playback_loading") != "true"){
                            this.$el.attr("rendered_buffer_playback_loading",true);
                        }
                    }
                    if(!this._hasLoggedPotentialPlaybackStall){
                        this._hasLoggedPotentialPlaybackStall = true;
                        console.warn("something might be wrong with audio context");
                    }
                    if(now - this._playbackPotentialStallStartedAt > timeInMillisecondsToRestartAfterStalled){
                        let playbackRecoveryPromise = null;
                        if(TURN_ON_HACK_IN_AUDIO_EDITOR_TO_PREVENT_STALLED_PLAYBACK && window.chrome){
                            playbackRecoveryPromise = this.model.restartPlayingSequencerRenderingAndSuspendAudioContextForStalledPlayback();
                        }else{
                            playbackRecoveryPromise = this.model.stopPlayingSequencerRenderingAndSuspendAudioContextForStalledPlayback();
                        }
                        this._startPlaybackStallRecovery(playbackRecoveryPromise);
                        this._lastMonitoredPlaybackProgressInMilliseconds = playbackProgressInMilliseconds;
                        this._lastMonitoredPlaybackAudioContextCurrentTime = playbackAudioContextCurrentTime;
                        this._lastMonitoredPlaybackProgressTimestamp = now;
                        this._playbackPotentialStallStartedAt = null;
                        this._hasLoggedPotentialPlaybackStall = false;
                        console.warn("we paused the playback and suspend audio context. It should be resume on automatically the time user press play");
                    }
                }else{
                    if(!this._isFirefoxBrowser()){
                        if(this.$el.attr("rendered_buffer_playback_loading") != "false"){
                            this.$el.attr("rendered_buffer_playback_loading",false);
                        }
                    }
                    this._playbackPotentialStallStartedAt = null;
                    this._hasLoggedPotentialPlaybackStall = false;
                    this._lastMonitoredPlaybackProgressInMilliseconds = playbackProgressInMilliseconds;
                    this._lastMonitoredPlaybackAudioContextCurrentTime = playbackAudioContextCurrentTime;
                    this._lastMonitoredPlaybackProgressTimestamp = now;
                }
            }
        }catch(error){
            console.error("failed monitoring playback state. Error:"+ error);
        }
    },

    _stopFunctionToUpdatePlaybackProgress : function(){
        this._isPlaybackProgressLoopActive = false;
        if(this._updateRequestAnimationFrameId){
            window.cancelAnimationFrame(this._updateRequestAnimationFrameId);
            this._updateRequestAnimationFrameId = null;
        }
        // Clear throttled scroll timer to prevent stale scroll after stop
        if(this._pendingPlaybackScrollTimerId){
            clearTimeout(this._pendingPlaybackScrollTimerId);
            this._pendingPlaybackScrollTimerId = null;
            this._pendingPlaybackScrollNodeView = null;
        }
        this._lastPlaybackUIUpdateTime = null;
        this._lastPlaybackScrollTime = null;
    },

    /**
     * Updates the progress bar cursor and time display to a specific position.
     * Called when a node is selected to move the progress bar to that node's position.
     * This is a one-time update (not animation-frame based like playback updates).
     *
     * @param {number} positionInMilliseconds - The position to set the progress bar to
     */
    updateProgressBarPosition: function(positionInMilliseconds) {
        const durationInMilliseconds = this.model.getDurationInMilliseconds();
        if (!durationInMilliseconds || durationInMilliseconds <= 0) {
            return;
        }

        // Update total time display (ensures it stays in sync after undo/redo)
        if (this.totalTime$el) {
            this.totalTime$el.html(Utils.getInstance().formatPlaybackPositionToString(durationInMilliseconds / 1000));
        }

        // Update time elapsed display
        if (this.timeElapsed$el) {
            this.timeElapsed$el.html(Utils.getInstance().formatPlaybackPositionToString(positionInMilliseconds / 1000));
        }

        // Update slider position (as percentage)
        const percentageOverHundred = (positionInMilliseconds * 100) / durationInMilliseconds;
        if (this._playerSliderEl && this._playerSliderEl.noUiSlider && !this._playerSliderEl._isUserDragged) {
            this._playerSliderEl.noUiSlider.set(percentageOverHundred);
        }
    },

    /**
     * Handler for durationChanged event from the model.
     * Called when timeline duration changes due to:
     * - Node insertion (audio/video clips)
     * - Node removal
     * - Padding/spacing property changes
     * Updates the total time display in the progress bar.
     *
     * Note: Always uses calculateEstimatedDurationInMilliseconds() because when this
     * event fires, the timeline has been modified and the renderer's cached duration
     * (from getDurationInMilliseconds()) is stale. The estimated duration iterates
     * through current nodes and provides an accurate calculation.
     */
    _onDurationChanged: function() {
        // Only update if the view has been rendered (totalTime$el exists)
        if (!this.totalTime$el || !this.model) {
            return;
        }

        // Always use calculateEstimatedDurationInMilliseconds() because this event fires
        // when nodes are added/removed/modified, meaning the renderer's cached duration
        // (from getDurationInMilliseconds) is stale and hasn't been re-rendered yet.
        // The estimated duration iterates through current nodes for an accurate calculation.
        const durationInMilliseconds = this.model.calculateEstimatedDurationInMilliseconds();

        if (durationInMilliseconds && durationInMilliseconds > 0) {
            this.totalTime$el.html(Utils.getInstance().formatPlaybackPositionToString(durationInMilliseconds / 1000));
        }
    },

    getModel : function(){
        return this.model;
    },

    onAutoscrollButtonClicked : function(){
        this.getModel().setAutoScroll(!this.getModel().getAutoScroll());
    },

    onNoiseCancellationButtonClicked : function(){
        if(!this.hasMutationAccess()){
            return;
        }
        if(!this.isOnboardingDisplayed()){
            if(DISPLAY_WARNING_ABOUT_NOISE_CANCELLATION_DURATION && !this._warningDisplayedAboutNoiseCancellationDuration && !this.getModel().getSequencerSettings().isNoiseCancellationOn()){
                this._warningDisplayedAboutNoiseCancellationDuration = true;
                Utils.getInstance().showWarningNotification(window.getI18n(ti18n, "NOISE_CANCELLAITON_TIME_WARNING"))
            }
            this.getModel().toggleNoiseCancellation();
        }
    },

    onAutoscrollChange : function(){
        if(this.getModel().getAutoScroll()){
            this.autoScrollBtn$el.addClass("active");
            //Utils.getInstance().showTrebbleReadyNotification("Autoscroll turned on");
        }else{
            this.autoScrollBtn$el.removeClass("active");
            //Utils.getInstance().showTrebbleReadyNotification("Autoscroll turned off");
        }
    },

    _updatePreviousAndNextSearchButtons :function(){
        if(this.model.getSearchWidget().canMoveToNextResult()){
            this.showNextSearchBtn$el.removeClass("disabled");
        }else{
            this.showNextSearchBtn$el.addClass("disabled");
        }

        if(this.model.getSearchWidget().canMoveToPreviousResult()){
            this.showPreviousSearchBtn$el.removeClass("disabled");
        }else{
            this.showPreviousSearchBtn$el.addClass("disabled");
        }

        const arrayOfSequencerNodeInFocus =  this.model.getSearchWidget().getSequencerNodesCurrentlyInFocus();
        if(arrayOfSequencerNodeInFocus && arrayOfSequencerNodeInFocus.length > 0){
            this.playSelectionBtn$el.prop('disabled', false);
            this.playWithoutSelection$el.prop('disabled', false);
            this.deleteSelectionBtn$el.prop('disabled', !this.hasMutationAccess());
            this.deleteAllHighligthed$el.prop('disabled', !this.hasMutationAccess());
        }else{
            this.playSelectionBtn$el.prop('disabled', true);
            this.playWithoutSelection$el.prop('disabled', true);
            this.deleteSelectionBtn$el.prop('disabled', true);
            this.deleteAllHighligthed$el.prop('disabled', true);
        }
    },


    onNodeSetInSearchFocusChange : function(arrayOfSequencerNodeInFocus){
        arrayOfSequencerNodeInFocus =  this.model.getSearchWidget().getSequencerNodesCurrentlyInFocus();
        if(arrayOfSequencerNodeInFocus && arrayOfSequencerNodeInFocus.length > 0){
            const firstSequencerNodeInFocus = arrayOfSequencerNodeInFocus[0];
            const lastSequencerNodeInFocus = arrayOfSequencerNodeInFocus[arrayOfSequencerNodeInFocus.length - 1];
            const firstSequencerNodeView =  this.getSequencerNodeViewFromSequencerNode(firstSequencerNodeInFocus);
            //const lastSequencerNodeView =  this.getSequencerNodeViewFromSequencerNode(lastSequencerNodeInFocus);
            let firstSequencerNodeToPlay = null;
            let lastSequencerNodeToPlay = null;
            if(firstSequencerNodeView){
                this.scrollToSequencerNodeIfneccessary(firstSequencerNodeView, true);
            }
            if(this.model.getSearchWidget().getPlaybackOn() && ALLOW_PLAYBACK_OF_SEARCH_RESULTS){
                const isAWordNodeFunction = (function(node){
                    return Utils.getInstance().isWordSequencerNodeInstance(node);
                })

                firstSequencerNodeToPlay = firstSequencerNodeInFocus.getPreviousNodeMatchingCondition(isAWordNodeFunction.bind(firstSequencerNodeInFocus), 4);
                if(!firstSequencerNodeToPlay){
                    firstSequencerNodeToPlay = firstSequencerNodeInFocus;
                }

                lastSequencerNodeToPlay = lastSequencerNodeInFocus.getNextNodeMatchingCondition(isAWordNodeFunction.bind(lastSequencerNodeInFocus),4);
                if(!lastSequencerNodeToPlay){
                    lastSequencerNodeToPlay = lastSequencerNodeInFocus;
                }
               

                this.trigger("playfromNode",firstSequencerNodeToPlay, 0, lastSequencerNodeToPlay, SequencerNodeUtils.getInstance().getArrayOfSequencerNodesFromStartToEnd(firstSequencerNodeInFocus, lastSequencerNodeInFocus));
            }

            this._updatePreviousAndNextSearchButtons();
            
            // Always select the nodes to show what's currently focused in search
            this.selectSequencerNodes(firstSequencerNodeInFocus, lastSequencerNodeInFocus,  true);
            
            this.focusSearchIndexLabel$el.html(this.model.getSearchWidget().getIndexOfNodeInFocus()+1);
            this.totalSearchResult$el.html(this.model.getSearchWidget().getNumberOfSearchNodesFound());
        }else{
            this._updatePreviousAndNextSearchButtons();
            this.focusSearchIndexLabel$el.html(0);
            this.totalSearchResult$el.html(0)
            //this.unselectCurrentlySelectedSequencerNodes();
        }

    },

    onSelectDeletedNode : function(deletedNode){
        if(deletedNode){
            const candidateVisibleNodes = [];
            const preferredVisibleNode = deletedNode.getNextVisibleSequencerNode
                ? deletedNode.getNextVisibleSequencerNode()
                : null;
            if(preferredVisibleNode){
                candidateVisibleNodes.push(preferredVisibleNode);
            }
            const fallbackVisibleNode = deletedNode.getPreviousVisibleSequencerNode
                ? deletedNode.getPreviousVisibleSequencerNode()
                : null;
            if(
                fallbackVisibleNode
                && candidateVisibleNodes.indexOf(fallbackVisibleNode) === -1
            ){
                candidateVisibleNodes.push(fallbackVisibleNode);
            }
            for(let i = 0; i < candidateVisibleNodes.length; i++){
                const nodeToKeepSelected = candidateVisibleNodes[i];
                if(this.selectAttachedSequencerNodeWithoutParagraphFlush(nodeToKeepSelected, true)){
                    const nodeViewToKeepSelected = this.getSequencerNodeViewFromSequencerNode(nodeToKeepSelected);
                    if(nodeViewToKeepSelected){
                        this.scrollToSequencerNodeIfneccessary(nodeViewToKeepSelected, false, true, true);
                    }
                    return true;
                }
            }
            if(candidateVisibleNodes.length > 0){
                const nodeToKeepSelected = candidateVisibleNodes[0];
                this._reportSelectionResolutionFailure(
                    nodeToKeepSelected.cid,
                    nodeToKeepSelected.cid,
                    this._resolveSelectionEndpoint(nodeToKeepSelected.cid),
                    this._resolveSelectionEndpoint(nodeToKeepSelected.cid)
                );
                return !!this._selectedNodeInfo;
            }
            this.unselectCurrentlySelectedSequencerNodes();
            return false;
        }
    },

    onIndexOfNodeInFocusChange : function(){
        // This method is called when the search index changes but nodesInFocus doesn't update
        // This ensures the UI counter gets updated even when auto-jump is disabled
        // The actual index value will be read by React components through useBackboneModel
    },

    onNoiseCancellationOnChange : function(){
        if(this.getModel().getSequencerSettings().isNoiseCancellationOn()){
            this.noiseCancellationBtn$el.addClass("active");
        }else{
            this.noiseCancellationBtn$el.removeClass("active");
        }
    },

    onShowIgnoredContentSettingChange : function(){
        this.$el.attr("do_not_show_ignored_content", this.getModel().getSequencerSettings().isShowIgnoredContent()?"false":"true");
    },

    onRevealDeletedContentSettingChange : function(){
        this.$el.attr("delete_node_expanded", this.getModel().getSequencerSettings().isRevealDeletedContentOn()?"true":"false");
    },

    onShowGapNodesSettingChange : function(){
        this.$el.attr("do_not_show_gap_nodes", this.getModel().getSequencerSettings().isShowGapsBetweenWords()?"false":"true");
    },

    onShowEditBoundariesSettingChange : function(){
        this.$el.attr("do_not_show_edit_boundaries", this.getModel().getSequencerSettings().isShowEditBoundaries()?"false":"true");
    },

    onShowDarkThemeChange : function(){
        if(this.getModel().getSequencerSettings().isShowDarkTheme()){
            this.$el.parents(".ui-page").addClass("lighttext transparent");
        }else{
            this.$el.parents(".ui-page").removeClass("lighttext transparent");
        }
    },

    onAutoscrollSettingChange : function(){
        //this.model.setAutoScroll(this.getModel().getSequencerSettings().isAutoscroll(), true);
    },


    onCorrectTranscriptBtnClicked: function(){
        if(!this.hasMutationAccess()){
            return false;
        }
        this.model.correctTextOnSequencerNodes(this.getArrayOfWordSequencerNodesSelected(this.getSelectionNode()), this.getCorrectectTextFromTextCorrectionContextMenuInput());
        return true;
    },


    onAudioRenderingStarted : function(){
        this.$el.attr("rendering_status","started");
    },

    onDeletionNodeInterruptedBecauseOfWrapOrphanNode : function(){
        window.alertUserErrorMessage(window.getI18n(ti18n,"YOUR_SELECTION_CANNOT_BE_DELETED_BECAUSE_ORPHAN_WRAP_NODE"));
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Deletion failed because selection contained orphan node ", "Deletion failed because selection contained orphan node ");
        }
    },

    onSelectedNodeNeedToBeNextToEachotherError : function(){
        window.alertErrorMessage(window.getI18n(ti18n,"YOUR_SELECTED_ELEMENTS_NEEDS_TO_BE_NEXT_TO_EACHOTHER"));
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "The elements you've selected need to be next to each other", "The elements you've selected need to be next to each other");
        }
    },


    onCopySelectionCommandeInterruptedBecauseOfWrapOrphanNode  : function(){
        window.alertUserErrorMessage(window.getI18n(ti18n,"YOUR_SELECTION_CANNOT_BE_COPIED_BECAUSE_ORPHAN_WRAP_NODE"));
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "copy selection failed because selection contained orphan node ", "copy selection failed because selection contained orphan node");
        }
    },

    onAudioRenderingCompleted : function(){
        this.$el.attr("rendering_status","completed");
    },

    onAudioRenderingFailed : function(error){
        this.$el.attr("rendering_status","failed");
        this.onRenderingBeingCreatedChange();
        window.alertErrorMessage(error);

    },

    onUndoShortcutKeyPressed : function(){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            //this.unselectCurrentlySelectedSequencerNodes();
            this.reselectCurrentlySelectedSequencerNodes();
            this._destroyContextMenuDisplayed();
            this.trigger("undo");
        }
    },

    onRedoShortcutKeyPressed : function(){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            //this.unselectCurrentlySelectedSequencerNodes();
            this.reselectCurrentlySelectedSequencerNodes();
            this._destroyContextMenuDisplayed();
            this.trigger("redo");
        }
    },

    selectSequencerNode : function(sequencerNode, doNotClearBrowserSelectionToNotLooseFocus){
        if(sequencerNode){
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(sequencerNode.cid), doNotClearBrowserSelectionToNotLooseFocus);
        }
    },

    selectSequencerNodes : function(firstSequencerNodeToSelect, lastSequencerNodeToSelect, doNotClearBrowserSelectionToNotLooseFocus){
        if(firstSequencerNodeToSelect && lastSequencerNodeToSelect){
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(firstSequencerNodeToSelect.cid, lastSequencerNodeToSelect.cid), doNotClearBrowserSelectionToNotLooseFocus);
        }
    },

    // Fast-path for "stay near the edit" flows such as delete. Reuse an already-live
    // neighboring node view if it's still attached to the current paragraph DOM, instead
    // of routing through `_resolveSelectionRange`, which intentionally flushes pending
    // paragraph rebuilds to make freshly-added nodes selectable.
    selectAttachedSequencerNodeWithoutParagraphFlush : function(sequencerNode, doNotClearBrowserSelectionToNotLooseFocus){
        if(!sequencerNode){
            return null;
        }
        const selectionInfo = this._collapseSelectionToLiveEndpoint(sequencerNode.cid, sequencerNode.cid);
        if(!selectionInfo){
            return null;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        this._selectedNodeInfo = selectionInfo;
        this._onSelectionChange();
        this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(selectionInfo, doNotClearBrowserSelectionToNotLooseFocus);
        return selectionInfo;
    },

    _isTranscriptWordNodeForAutomation: function(sequencerNode){
        return !!(sequencerNode && Utils.getInstance().isWordSequencerNodeInstance(sequencerNode));
    },

    _getVisibleTranscriptWordEntriesForAutomation: function(){
        const entries = [];
        let currentNode = this.model && typeof this.model.getFirstNode === "function"
            ? this.model.getFirstNode()
            : null;

        while(currentNode){
            if(this._isTranscriptWordNodeForAutomation(currentNode)){
                const nodeView = this.getSequencerNodeViewFromSequencerNode(currentNode);
                const isVisible = !this.model || typeof this.model.isSequencerNodeVisible !== "function"
                    ? !!nodeView
                    : this.model.isSequencerNodeVisible(currentNode);

                if(nodeView && isVisible){
                    const rawText = typeof currentNode.getContent === "function"
                        ? currentNode.getContent(false)
                        : "";
                    const normalizedText = normalizeAutomationTranscriptText(rawText);
                    const paragraphContainerView = typeof nodeView.getParagraphContainerView === "function"
                        ? nodeView.getParagraphContainerView()
                        : null;

                    entries.push({
                        wordIndex: entries.length,
                        cid: currentNode.cid,
                        node: currentNode,
                        nodeView,
                        text: typeof rawText === "string" ? rawText : "",
                        normalizedText,
                        paragraphIndex: paragraphContainerView
                            ? this._arrayOfParagraphContainerViews.indexOf(paragraphContainerView)
                            : -1
                    });
                }
            }

            currentNode = typeof currentNode.getNext === "function"
                ? currentNode.getNext()
                : null;
        }

        return entries;
    },

    _serializeSelectionInfoForAutomation: function(selectionInfo, visibleWordEntries){
        if(!selectionInfo || !selectionInfo.startSequencerNodeModel || !selectionInfo.endSequencerNodeModel){
            return null;
        }

        const entries = visibleWordEntries || this._getVisibleTranscriptWordEntriesForAutomation();
        const startCid = selectionInfo.startSequencerNodeModel.cid;
        const endCid = selectionInfo.endSequencerNodeModel.cid;
        const startWordEntry = entries.find((entry) => entry.cid === startCid) || null;
        const endWordEntry = entries.find((entry) => entry.cid === endCid) || null;

        return {
            startCid,
            endCid,
            startType: selectionInfo.startSequencerNodeModel.getConstructor
                ? selectionInfo.startSequencerNodeModel.getConstructor().CLASSNAME
                : null,
            endType: selectionInfo.endSequencerNodeModel.getConstructor
                ? selectionInfo.endSequencerNodeModel.getConstructor().CLASSNAME
                : null,
            startText: typeof selectionInfo.startSequencerNodeModel.getContent === "function"
                ? selectionInfo.startSequencerNodeModel.getContent(false)
                : null,
            endText: typeof selectionInfo.endSequencerNodeModel.getContent === "function"
                ? selectionInfo.endSequencerNodeModel.getContent(false)
                : null,
            startWordIndex: startWordEntry ? startWordEntry.wordIndex : null,
            endWordIndex: endWordEntry ? endWordEntry.wordIndex : null,
            isSingleNodeSelection: startCid === endCid
        };
    },

    getAutomationTranscriptSnapshot: function(){
        const visibleWordEntries = this._getVisibleTranscriptWordEntriesForAutomation();

        return {
            wordCount: visibleWordEntries.length,
            transcriptText: visibleWordEntries.map((entry) => entry.text).join(" ").replace(/\s+/g, " ").trim(),
            words: visibleWordEntries.map((entry) => ({
                wordIndex: entry.wordIndex,
                cid: entry.cid,
                text: entry.text,
                normalizedText: entry.normalizedText,
                paragraphIndex: entry.paragraphIndex,
                domSelector: `[data-sequencer-node-cid="${entry.cid}"]`
            })),
            selection: this._serializeSelectionInfoForAutomation(this.getSelectionNode(), visibleWordEntries)
        };
    },

    getAutomationSelectionSnapshot: function(){
        return this._serializeSelectionInfoForAutomation(this.getSelectionNode());
    },

    getAutomationParagraphSnapshot: function(){
        this._paragraphLayoutAnalysis = null;
        const paragraphLayoutAnalysis = this._getCurrentParagraphLayoutAnalysis();
        const paragraphLayout = paragraphLayoutAnalysis && Array.isArray(paragraphLayoutAnalysis.paragraphLayout)
            ? paragraphLayoutAnalysis.paragraphLayout
            : [];

        const paragraphs = paragraphLayout.map((paragraphDescriptor, paragraphIndex) => {
            const speakerInfo = paragraphDescriptor.speakerInfo || null;
            const speakerId = speakerInfo && speakerInfo.getSpeakerId ? speakerInfo.getSpeakerId() : null;
            const speakerLabel = speakerInfo && speakerInfo.getSpeakerLabel ? speakerInfo.getSpeakerLabel() : null;
            const nodes = Array.isArray(paragraphDescriptor.sequencerNodes)
                ? paragraphDescriptor.sequencerNodes
                : [];
            const visibleNodes = nodes.filter((sequencerNode) => {
                return this.model && this.model.isSequencerNodeVisible
                    ? this.model.isSequencerNodeVisible(sequencerNode)
                    : true;
            });
            const words = visibleNodes.map((sequencerNode) => ({
                cid: sequencerNode.cid || null,
                type: getAutomationNodeType(sequencerNode),
                text: getAutomationNodeText(sequencerNode),
            }));
            const text = words.map((word) => word.text).filter(Boolean).join(" ").replace(/\s+/g, " ").trim();

            return {
                paragraphIndex,
                kind: paragraphDescriptor.kind || null,
                speakerId,
                speakerLabel,
                text,
                words,
            };
        });

        return {
            paragraphCount: paragraphs.length,
            paragraphs,
            signature: paragraphs.map((paragraph) => {
                return `${paragraph.speakerLabel || paragraph.speakerId || "unlabelled"}:${paragraph.text}`;
            }).join(" | "),
        };
    },

    applyAutomationParagraphBoundaryAction: function(actionName){
        switch(actionName){
            case "break-before":
                return this.breakParagraphBeforeSelection();
            case "break-after":
                return this.breakParagraphAfterSelection();
            case "merge-previous":
                return this.mergeSelectionWithPreviousParagraph();
            case "merge-next":
                return this.mergeSelectionWithNextParagraph();
            default:
                return false;
        }
    },

    assignAutomationSpeakerToSelection: function(options){
        const speakerChangeTarget = this._getSpeakerChangeTargetForSelection();
        if(!speakerChangeTarget){
            return {
                didChange: false,
                reason: "speaker-change-unavailable",
            };
        }

        const speakerInfoOptions = this._getSpeakerInfoOptionsForTarget(speakerChangeTarget);
        if(!speakerInfoOptions.length){
            return {
                didChange: false,
                reason: "no-speaker-options",
            };
        }

        const requestedSpeakerId = options && options.speakerId;
        const requestedSpeakerLabel = options && options.speakerLabel;
        let speakerInfo = null;
        if(requestedSpeakerId || requestedSpeakerLabel){
            speakerInfo = speakerInfoOptions.find((candidateSpeakerInfo) => {
                const speakerId = candidateSpeakerInfo && candidateSpeakerInfo.getSpeakerId
                    ? candidateSpeakerInfo.getSpeakerId()
                    : null;
                const speakerLabel = candidateSpeakerInfo && candidateSpeakerInfo.getSpeakerLabel
                    ? candidateSpeakerInfo.getSpeakerLabel()
                    : null;
                return (requestedSpeakerId && speakerId === requestedSpeakerId)
                    || (requestedSpeakerLabel && speakerLabel === requestedSpeakerLabel);
            }) || null;
        }
        if(!speakerInfo){
            speakerInfo = speakerInfoOptions[0];
        }

        const didChange = this._assignSpeakerToTarget(speakerChangeTarget, speakerInfo);
        return {
            didChange: !!didChange,
            speakerId: speakerInfo && speakerInfo.getSpeakerId ? speakerInfo.getSpeakerId() : null,
            speakerLabel: speakerInfo && speakerInfo.getSpeakerLabel ? speakerInfo.getSpeakerLabel() : null,
        };
    },

    correctAutomationTextOnSelection: function(options){
        const selectionInfo = this.getSelectionNode();
        const newText = options && options.newText;
        if(!newText || !newText.trim()){
            return {
                didChange: false,
                reason: "missing-text",
            };
        }

        const selectedWordNodes = this.getArrayOfWordSequencerNodesSelected(selectionInfo);
        if(!selectedWordNodes || selectedWordNodes.length !== 1){
            return {
                didChange: false,
                reason: "single-word-selection-required",
            };
        }

        const selectedWordNode = selectedWordNodes[0];
        const previousText = typeof selectedWordNode.getContent === "function"
            ? selectedWordNode.getContent(false)
            : null;

        this.model.correctTextOnSequencerNodes(selectedWordNodes, newText);

        const correctedText = typeof selectedWordNode.getContent === "function"
            ? selectedWordNode.getContent(false)
            : null;

        return {
            didChange: correctedText === newText && correctedText !== previousText,
            previousText,
            correctedText,
        };
    },

    renameAutomationSelectedSpeaker: function(options){
        const speakerChangeTarget = this._getSpeakerChangeTargetForSelection();
        if(!speakerChangeTarget || !speakerChangeTarget.currentSpeakerInfo){
            return {
                didChange: false,
                reason: "speaker-rename-unavailable",
            };
        }

        const speakerInfo = speakerChangeTarget.currentSpeakerInfo;
        if(speakerInfo.isEditable && !speakerInfo.isEditable()){
            return {
                didChange: false,
                reason: "speaker-not-editable",
            };
        }

        const nextSpeakerLabel = options && options.speakerLabel;
        if(!nextSpeakerLabel){
            return {
                didChange: false,
                reason: "missing-speaker-label",
            };
        }

        const previousSpeakerLabel = speakerInfo.getSpeakerLabel ? speakerInfo.getSpeakerLabel() : null;
        const didChange = this.model.renameSpeakerInfo(speakerInfo, nextSpeakerLabel);
        return {
            didChange: !!didChange,
            previousSpeakerLabel,
            speakerId: speakerInfo && speakerInfo.getSpeakerId ? speakerInfo.getSpeakerId() : null,
            speakerLabel: speakerInfo && speakerInfo.getSpeakerLabel ? speakerInfo.getSpeakerLabel() : nextSpeakerLabel,
        };
    },

    createAutomationNewSpeakerAndAssignToSelection: function(options){
        const speakerChangeTarget = this._getSpeakerChangeTargetForSelection();
        if(!speakerChangeTarget){
            return {
                didChange: false,
                reason: "speaker-create-unavailable",
            };
        }

        const speakerLabel = options && options.speakerLabel;
        if(!speakerLabel){
            return {
                didChange: false,
                reason: "missing-speaker-label",
            };
        }

        const speakerInfo = this.model.createNewSpeakerInfoAndAssign(
            speakerLabel,
            speakerChangeTarget.paragraphContainerView,
            speakerChangeTarget.startSequencerNodeModel,
            speakerChangeTarget.endSequencerNodeModel,
            speakerChangeTarget.arrayOfSequencerNodeModelsToChange,
        );

        return {
            didChange: !!speakerInfo,
            speakerId: speakerInfo && speakerInfo.getSpeakerId ? speakerInfo.getSpeakerId() : null,
            speakerLabel: speakerInfo && speakerInfo.getSpeakerLabel ? speakerInfo.getSpeakerLabel() : speakerLabel,
        };
    },

    findAutomationVisibleWordRangeByText: function(queryText, options){
        const queryTokens = tokenizeAutomationTranscriptText(queryText);
        if(queryTokens.length === 0){
            return null;
        }

        const visibleWordEntries = this._getVisibleTranscriptWordEntriesForAutomation();
        const requestedOccurrenceIndex = options && Number.isInteger(options.occurrenceIndex)
            ? Math.max(options.occurrenceIndex, 0)
            : options && Number.isInteger(options.occurrence)
                ? Math.max(options.occurrence - 1, 0)
                : 0;

        let currentOccurrenceIndex = 0;
        for(let startIndex = 0; startIndex <= visibleWordEntries.length - queryTokens.length; startIndex++){
            let isMatch = true;

            for(let tokenIndex = 0; tokenIndex < queryTokens.length; tokenIndex++){
                if(visibleWordEntries[startIndex + tokenIndex].normalizedText !== queryTokens[tokenIndex]){
                    isMatch = false;
                    break;
                }
            }

            if(!isMatch){
                continue;
            }

            if(currentOccurrenceIndex !== requestedOccurrenceIndex){
                currentOccurrenceIndex++;
                continue;
            }

            const startEntry = visibleWordEntries[startIndex];
            const endEntry = visibleWordEntries[startIndex + queryTokens.length - 1];

            return {
                queryText,
                occurrenceIndex: requestedOccurrenceIndex,
                startWordIndex: startEntry.wordIndex,
                endWordIndex: endEntry.wordIndex,
                startCid: startEntry.cid,
                endCid: endEntry.cid,
                matchedText: visibleWordEntries
                    .slice(startIndex, startIndex + queryTokens.length)
                    .map((entry) => entry.text)
                    .join(" ")
                    .replace(/\s+/g, " ")
                    .trim()
            };
        }

        return null;
    },

    getRandomAutomationVisibleWordRange: function(options){
        const visibleWordEntries = this._getVisibleTranscriptWordEntriesForAutomation();
        if(visibleWordEntries.length === 0){
            return null;
        }

        const currentSelection = this._serializeSelectionInfoForAutomation(this.getSelectionNode(), visibleWordEntries);
        const minWords = Math.max(1, normalizeAutomationRandomInteger(options && options.minWords, 1));
        const defaultMaxWords = Math.min(8, visibleWordEntries.length);
        const maxWords = Math.max(
            minWords,
            Math.min(
                visibleWordEntries.length,
                normalizeAutomationRandomInteger(options && options.maxWords, defaultMaxWords)
            )
        );
        const sameParagraphOnly = options && options.sameParagraphOnly === false ? false : true;
        const paragraphIndex = options && Number.isInteger(options.paragraphIndex)
            ? options.paragraphIndex
            : normalizeAutomationRandomInteger(options && options.paragraphIndex, null);
        const excludeCurrentSelection = !!(options && options.excludeCurrentSelection);
        const randomGenerator = createAutomationRandomGenerator(options && Object.prototype.hasOwnProperty.call(options, "seed")
            ? options.seed
            : null);
        const candidateRanges = [];

        for(let startIndex = 0; startIndex < visibleWordEntries.length; startIndex++){
            const startEntry = visibleWordEntries[startIndex];

            if(paragraphIndex !== null && startEntry.paragraphIndex !== paragraphIndex){
                continue;
            }

            for(let wordCount = minWords; wordCount <= maxWords; wordCount++){
                const endIndex = startIndex + wordCount - 1;
                if(endIndex >= visibleWordEntries.length){
                    break;
                }

                const endEntry = visibleWordEntries[endIndex];
                if(paragraphIndex !== null && endEntry.paragraphIndex !== paragraphIndex){
                    continue;
                }

                if(sameParagraphOnly && startEntry.paragraphIndex !== endEntry.paragraphIndex){
                    continue;
                }

                if(
                    excludeCurrentSelection &&
                    currentSelection &&
                    currentSelection.startWordIndex === startEntry.wordIndex &&
                    currentSelection.endWordIndex === endEntry.wordIndex
                ){
                    continue;
                }

                candidateRanges.push({
                    startWordIndex: startEntry.wordIndex,
                    endWordIndex: endEntry.wordIndex,
                    startCid: startEntry.cid,
                    endCid: endEntry.cid,
                    paragraphIndex: startEntry.paragraphIndex,
                    wordCount,
                    matchedText: visibleWordEntries
                        .slice(startIndex, endIndex + 1)
                        .map((entry) => entry.text)
                        .join(" ")
                        .replace(/\s+/g, " ")
                        .trim()
                });
            }
        }

        if(candidateRanges.length === 0){
            return null;
        }

        const candidateIndex = Math.min(
            candidateRanges.length - 1,
            Math.floor(randomGenerator() * candidateRanges.length)
        );
        const selectedRange = candidateRanges[candidateIndex];

        return Object.assign({}, selectedRange, {
            candidateCount: candidateRanges.length,
            candidateIndex,
            sameParagraphOnly,
            seed: options && Object.prototype.hasOwnProperty.call(options, "seed")
                ? options.seed
                : null
        });
    },

    selectAutomationVisibleWordRange: function(startWordIndex, endWordIndex, doNotClearBrowserSelectionToNotLooseFocus){
        const visibleWordEntries = this._getVisibleTranscriptWordEntriesForAutomation();
        const normalizedStartIndex = Math.min(startWordIndex, endWordIndex);
        const normalizedEndIndex = Math.max(startWordIndex, endWordIndex);
        const startEntry = visibleWordEntries[normalizedStartIndex];
        const endEntry = visibleWordEntries[normalizedEndIndex];

        if(!startEntry || !endEntry){
            return null;
        }

        this.selectSequencerNodes(
            startEntry.node,
            endEntry.node,
            doNotClearBrowserSelectionToNotLooseFocus
        );

        return this._serializeSelectionInfoForAutomation(this.getSelectionNode(), visibleWordEntries);
    },

    selectAutomationText: function(queryText, options){
        const match = this.findAutomationVisibleWordRangeByText(queryText, options);
        if(!match){
            return null;
        }

        return this.selectAutomationVisibleWordRange(
            match.startWordIndex,
            match.endWordIndex,
            options ? options.doNotClearBrowserSelectionToNotLooseFocus : undefined
        );
    },

    selectRandomAutomationVisibleWordRange: function(options){
        const randomRange = this.getRandomAutomationVisibleWordRange(options);
        if(!randomRange){
            return null;
        }

        const selection = this.selectAutomationVisibleWordRange(
            randomRange.startWordIndex,
            randomRange.endWordIndex,
            options ? options.doNotClearBrowserSelectionToNotLooseFocus : undefined
        );

        return {
            randomRange,
            selection
        };
    },

    selectNextSequencerNodeUpAfterSelection : function(){
        const nextUpSequencerNode = this.getNextVisibleSequencerNodeUpAfterSelection();
        if(nextUpSequencerNode){
            this.selectSequencerNode(nextUpSequencerNode);
            this.scrollToSequencerNodeIfneccessary(this.getSequencerNodeViewFromSequencerNode(nextUpSequencerNode), false, true, true);
        }
    },

    selectNextSequencerNodeDownAfterSelection : function(){
        const nextDownSequencerNode = this.getNextVisibleSequencerNodeDownAfterSelection();
        if(nextDownSequencerNode){
            this.selectSequencerNode(nextDownSequencerNode);
            this.scrollToSequencerNodeIfneccessary(this.getSequencerNodeViewFromSequencerNode(nextDownSequencerNode), false, true, true);
        }
    },

    selectNextSequencerNodeAfterSelection : function(){
        this.selectSequencerNode(this.getNextVisibleSequencerNodeAfterSelection());
    },

    selectPreviousSequencerNodeAfterSelection : function(){
        this.selectSequencerNode(this.getPreviousVisibleSequencerNodeAfterSelection());
    },

    addNextSequencerNodeToSelection: function(){
        const currentSelectionInfo =  this.getSelectionNode();
        if(currentSelectionInfo && currentSelectionInfo.selectionEndFocusNodeView){
            const endSequencerNodeModel = currentSelectionInfo.selectionEndFocusNodeView.getModel();
            const nextSequencerNodeVisible  = endSequencerNodeModel.getNextVisibleSequencerNode();
            if(nextSequencerNodeVisible){
                if(currentSelectionInfo && currentSelectionInfo.selectionStartAnchorNodeView){
                    const startSequencerNodeModel = currentSelectionInfo.selectionStartAnchorNodeView.getModel();
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(startSequencerNodeModel.cid, nextSequencerNodeVisible.cid));
                }else{
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(nextSequencerNodeVisible.cid));
                }

            }
        }else{
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(this.model.getFirstNode().cid));
        }
    },

    addNextDownSequencerNodeToSelection: function(){
        const currentSelectionInfo =  this.getSelectionNode();
        if(currentSelectionInfo && currentSelectionInfo.selectionEndFocusNodeView){
            const endSequencerNodeModel = currentSelectionInfo.selectionEndFocusNodeView.getModel();
            const nextDownSequencerNodeVisible  = this._getClosestSequencerNodeDown(endSequencerNodeModel);
            if(nextDownSequencerNodeVisible){
                this.scrollToSequencerNodeIfneccessary(this.getSequencerNodeViewFromSequencerNode(nextDownSequencerNodeVisible), false, true, true);
                if(currentSelectionInfo && currentSelectionInfo.selectionStartAnchorNodeView){
                    const startSequencerNodeModel = currentSelectionInfo.selectionStartAnchorNodeView.getModel();
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(startSequencerNodeModel.cid, nextDownSequencerNodeVisible.cid));
                }else{
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(nextDownSequencerNodeVisible.cid));
                }

            }
        }else{
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(this.model.getFirstNode().cid));
        }
    },

    removeLastSequencerNodeFromSelection: function(){
        const currentSelectionInfo =  this.getSelectionNode();
        if(currentSelectionInfo && currentSelectionInfo.selectionEndFocusNodeView){
            const endSequencerNodeModel = currentSelectionInfo.selectionEndFocusNodeView.getModel();
            const previousSequencerNodeVisible  = endSequencerNodeModel.getPreviousVisibleSequencerNode();
            if(previousSequencerNodeVisible){
                if(currentSelectionInfo && currentSelectionInfo.selectionStartAnchorNodeView){
                    const startSequencerNodeModel = currentSelectionInfo.selectionStartAnchorNodeView.getModel();
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(startSequencerNodeModel.cid, previousSequencerNodeVisible.cid));
                }else{
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(previousSequencerNodeVisible.cid));
                }

            }
        }else{
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(this.model.getFirstNode().cid));
        }
    },

    removeUpSequencerNodeFromSelection: function(){
        const currentSelectionInfo =  this.getSelectionNode();
        if(currentSelectionInfo && currentSelectionInfo.selectionEndFocusNodeView){
            const endSequencerNodeModel = currentSelectionInfo.selectionEndFocusNodeView.getModel();
            const nextUpSequencerNodeVisible  = this._getClosestSequencerNodeUp(endSequencerNodeModel);
            if(nextUpSequencerNodeVisible){
                this.scrollToSequencerNodeIfneccessary(this.getSequencerNodeViewFromSequencerNode(nextUpSequencerNodeVisible), false, true, true);
                if(currentSelectionInfo && currentSelectionInfo.selectionStartAnchorNodeView){
                    const startSequencerNodeModel = currentSelectionInfo.selectionStartAnchorNodeView.getModel();
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(startSequencerNodeModel.cid, nextUpSequencerNodeVisible.cid));
                }else{
                    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(nextUpSequencerNodeVisible.cid));
                }

            }
        }else{
            return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(this.model.getFirstNode().cid));
        }
    },

    onSearchTurnedOn : function(){
        if(ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR){
            //this.trigger("searchTurnedOn");
            if(SHOW_SEARCH_WIDGET_ON_LEFT_SECTION_OF_EDITOR){
                this._showEditorSearchComponentToLeftPanel();
            }else{
                this.trigger("searchTurnedOn");
            }
        }
    },

    onShowNextNodeFoundInSearch : function(){
        if(ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR){
            this.trigger("showNextNodeFoundInSearch");
        }
    },

    onShowPreviousNodeFoundInSearch : function(){
        if(ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR){
            this.trigger("showPreviousNodeFoundInSearch");
            return false;
        }
    },

    onExitCurrentMode : function(){
        if(this.isContextMenuDisplayed()){
            this._destroyContextMenuDisplayed();
        }else if(this.isCorrectTranscriptionContextMenuDisplayed()){
            this._destroyContextMenuCorrectTranscriptDisplayed();
        }else{
            this.trigger("exitCurrentMode");
            this._hideEditorSearchComponentToLeftPanel();
        }
    },


    onClearSearchInput : function(){
        if(ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR){
            this._clearBrowserSelection();
            this.searchInput$el.val("");
            this.searchInput$el.focus();
        }
    },

    _doNotFireKeyboardEventCallback: function(){
        return this._doNotFireKeyboardEventCallbackIfInSearchMode() || this._doNotFireKeyboardEventCallbackIfPopupIsOpen();
    },

    _doNotFireKeyboardEventCallbackIfInSearchMode: function(){
        if(!this.model){
            return true;
        }
        return this.model.getSearchWidget().isSearchOn() && document.activeElement && document.activeElement.nodeName === "INPUT";
    },

    _doNotFireKeyboardEventCallbackIfPopupIsOpen : function(){
        return Utils.getInstance().isJQMPopupOpen()
    },

    _listenForKeyboardEvents : function(){
        if(this._keyboardEventsSetup){
            return;
        }
        this._keyboardEventsSetup = true;

        this._undoHandlerId = Utils.getInstance().generateRandomId();
        this._redoHandlerId = Utils.getInstance().generateRandomId();
        this._playPauseHandlerId = Utils.getInstance().generateRandomId();
        this._deleteSelectedHandlerId = Utils.getInstance().generateRandomId();
        this._addNextToSelectionHandlerId =  Utils.getInstance().generateRandomId();
        this._addNextDownToSelectionHandlerId =  Utils.getInstance().generateRandomId();
        this._removeLastFromSelectionHandlerId =  Utils.getInstance().generateRandomId();
        this._removeUpFromSelectionHandlerId =  Utils.getInstance().generateRandomId();

        this._clipSelectionHandlerId =  Utils.getInstance().generateRandomId();
        this._createClipSelectionHandlerId =  Utils.getInstance().generateRandomId();
        this._downloadClipSelectionHandlerId =  Utils.getInstance().generateRandomId();
        this._copySelectionToClipboardHandlerId =  Utils.getInstance().generateRandomId();
        this._makeNextUpAsSelectionHandlerId = Utils.getInstance().generateRandomId();
        this._makeNextDownAsSelectionHandlerId = Utils.getInstance().generateRandomId();
        this._makeNextAsSelectionHandlerId = Utils.getInstance().generateRandomId();
        this._makePreviousAsSelectionHandlerId = Utils.getInstance().generateRandomId();
        this._pasteClipboardBeforeSelectionTriggeredHandlerId = Utils.getInstance().generateRandomId();
        this._cutAndCopySelectionToClipboardHandlerId = Utils.getInstance().generateRandomId();
        this._selectAlldHandlerId = Utils.getInstance().generateRandomId();
        this._searchKeywordHandlerId = Utils.getInstance().generateRandomId();
        this._showNextSearchFoundHandlerId = Utils.getInstance().generateRandomId();
        this._onDeleteAllExceptSelectedNodesHandlerId = Utils.getInstance().generateRandomId();
        this._showPreviousSearchFoundHandlerId = Utils.getInstance().generateRandomId();
        this._exitCurrentModeHandlerId = Utils.getInstance().generateRandomId();
        this._wrapWithAudioHandlerId = Utils.getInstance().generateRandomId();
        this._insertAudioHandlerId = Utils.getInstance().generateRandomId();
        this._insertVideoHandlerId = Utils.getInstance().generateRandomId();
        this._playFromHereHandlerId = Utils.getInstance().generateRandomId();
        this._deleteHandlerId = Utils.getInstance().generateRandomId();
        this._correctSingleWordId = Utils.getInstance().generateRandomId();
        this._adjustTimingHandlerId = Utils.getInstance().generateRandomId();
        this._breakParagraphBeforeHandlerId = Utils.getInstance().generateRandomId();
        this._breakParagraphAfterHandlerId = Utils.getInstance().generateRandomId();
        this._mergeWithPreviousParagraphHandlerId = Utils.getInstance().generateRandomId();
        this._mergeWithNextParagraphHandlerId = Utils.getInstance().generateRandomId();

        const doNotFireKeyboardEventCallbackIfInSearchModehandler = this._doNotFireKeyboardEventCallback.bind(this)
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['space'],this.onPlaySequencerBtnClicked.bind(this), this._playPauseHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['backspace','del'],this.onIgnoreSelectedNodesBtnClicked.bind(this), this._deleteSelectedHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['ctrl+z', 'command+z'],this.onUndoShortcutKeyPressed.bind(this), this._undoHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['ctrl+shift+z', 'command+shift+z'],this.onRedoShortcutKeyPressed.bind(this), this._redoHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['up'],this.selectNextSequencerNodeUpAfterSelection.bind(this), this._makeNextUpAsSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['down'],this.selectNextSequencerNodeDownAfterSelection.bind(this), this._makeNextDownAsSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['right'],this.selectNextSequencerNodeAfterSelection.bind(this), this._makeNextAsSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['left'],this.selectPreviousSequencerNodeAfterSelection.bind(this), this._makePreviousAsSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['shift+up'],this.removeUpSequencerNodeFromSelection.bind(this), this._addNextDownToSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['shift+down'],this.addNextDownSequencerNodeToSelection.bind(this), this._removeUpFromSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['shift+right'],this.addNextSequencerNodeToSelection.bind(this), this._addNextToSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['shift+left'],this.removeLastSequencerNodeFromSelection.bind(this), this._removeLastFromSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+shift+c','ctrl+shift+c'],this.onSaveAsClipButtonCliked.bind(this), this._clipSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['shift+c','shift+c'],this.onCreateClipButtonCliked.bind(this), this._createClipSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+shift+d','ctrl+shift+d'],this.onDownloadClipButtonClicked.bind(this), this._downloadClipSelectionHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+c','ctrl+c'],this.onCopySelectionToClipboardTriggered.bind(this), this._copySelectionToClipboardHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+v','ctrl+v'],this.onPasteClipboardBeforeSelectionTriggered.bind(this), this._pasteClipboardBeforeSelectionTriggeredHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+x','ctrl+x'],this.onCutAndCopySelectionToClipboardTriggered.bind(this), this._cutAndCopySelectionToClipboardHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+a','ctrl+a'],this.onSelectAllTriggered.bind(this), this._selectAlldHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+f','ctrl+f'],this.onSearchTurnedOn.bind(this), this._searchKeywordHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+g','ctrl+g'],this.onShowNextNodeFoundInSearch.bind(this), this._showNextSearchFoundHandlerId);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+k','ctrl+k'],this.onDeleteAllExceptSelectedNodesButtonClicked.bind(this), this._onDeleteAllExceptSelectedNodesHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['w'],this.onWrapWithMusicBtnClicked.bind(this), this._wrapWithAudioHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['i'],this.onInsertButtonClicked.bind(this), this._insertAudioHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['v'],this.onInsertVideoButtonClicked.bind(this), this._insertVideoHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['d'],this.onDeleteButtonClicked.bind(this), this._deleteHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['e'],this.showContextMenuForCorrectingTranscriptsIfApplicable.bind(this), this._correctSingleWordId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['t'],this.showAdjustTimingPopupIfAvailable.bind(this), this._adjustTimingHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        //KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['option+space','alt+space'],this.onPlayFromBtnClicked.bind(this), this._playFromHereHandlerId);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+shift+g','ctrl+shift+g'],this.onShowPreviousNodeFoundInSearch.bind(this), this._showPreviousSearchFoundHandlerId);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['esc','escape'],this.onExitCurrentMode.bind(this), this._exitCurrentModeHandlerId);
        // Paragraph boundary shortcuts — no-op (return false) when the guards
        // inside each method reject, so they stay safely inert outside the
        // transcript editing context.
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+enter','ctrl+enter'], this.breakParagraphBeforeSelection.bind(this), this._breakParagraphBeforeHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+shift+enter','ctrl+shift+enter'], this.breakParagraphAfterSelection.bind(this), this._breakParagraphAfterHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+shift+m','ctrl+shift+m'], this.mergeSelectionWithPreviousParagraph.bind(this), this._mergeWithPreviousParagraphHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);
        KeyboardKeyHandlerHelper.getInstance().registerForKeyboardEvent(['command+alt+m','ctrl+alt+m'], this.mergeSelectionWithNextParagraph.bind(this), this._mergeWithNextParagraphHandlerId, doNotFireKeyboardEventCallbackIfInSearchModehandler);

    },

    _stopListeningForKeyboardEvents: function(){
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['space'], this._playPauseHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['backspace','del'], this._deleteSelectedHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['ctrl+z', 'command+z'], this._undoHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['ctrl+shift+z', 'command+shift+z'], this._redoHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['up'], this._makeNextUpAsSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['down'], this._makeNextDownAsSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['right'], this._makeNextAsSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['left'], this._makePreviousAsSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['shift+up'],this._addNextDownToSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['shift+down'], this._removeUpFromSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['shift+right'], this._addNextToSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['shift+left'], this._removeLastFromSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+shift+c','ctrl+shift+c'], this._clipSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['shift+c','shift+c'], this._createClipSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+shift+d','ctrl+shift+d'], this._downloadClipSelectionHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+c','ctrl+c'], this._copySelectionToClipboardHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+v','ctrl+v'], this._pasteClipboardBeforeSelectionTriggeredHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+x','ctrl+x'], this._cutAndCopySelectionToClipboardHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+a','ctrl+a'], this._selectAlldHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+f','ctrl+f'], this._searchKeywordHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+g','ctrl+g'],this._showNextSearchFoundHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+k','ctrl+k'],this._onDeleteAllExceptSelectedNodesHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['w'], this._wrapWithAudioHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['i'], this._insertAudioHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['v'], this._insertVideoHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['d'], this._deleteHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['e'], this._correctSingleWordId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['t'], this._adjustTimingHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+shift+g','ctrl+shift+g'],this._showPreviousSearchFoundHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['esc','escape'], this._exitCurrentModeHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+enter','ctrl+enter'], this._breakParagraphBeforeHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+shift+enter','ctrl+shift+enter'], this._breakParagraphAfterHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+shift+m','ctrl+shift+m'], this._mergeWithPreviousParagraphHandlerId);
        KeyboardKeyHandlerHelper.getInstance().unregisterForKeyboardEventByHandlerId(['command+alt+m','ctrl+alt+m'], this._mergeWithNextParagraphHandlerId);
        this._keyboardEventsSetup = false;
    },

    stopListening : function(obj, name, callback){
        Backbone.View.prototype.stopListening.apply(this, arguments);
        // Only tear down keyboard shortcuts on a full view teardown
        // (stopListening() with no args). Targeted stopListening(model, event,
        // handler) calls — like the one in _teardownActiveVideoRenderer
        // (line 430) added in #1483 — must not wipe out every keyboard
        // handler the view registered at setup time.
        if(arguments.length === 0){
            this._stopListeningForKeyboardEvents();
        }
    },

    _getArrayOfSequencerNodesInOrder : function(){
        const arrayOfSequencerNodes = [];
        if(this.model && this.model.getFirstNode){
            let currentNode = this.model.getFirstNode();
            while(currentNode){
                arrayOfSequencerNodes.push(currentNode);
                currentNode = currentNode.getNext();
            }
        }
        return arrayOfSequencerNodes;
    },

    _getOrCreateSequencerNodeView : function(sequencerNode){
        let sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(sequencerNode);
        if(!sequencerNodeView){
            sequencerNodeView = this._createAndRenderSequencerNodeView(sequencerNode);
        }
        this._listenToEventsOnNodeView(sequencerNodeView);
        sequencerNodeView.delegateEvents();
        return sequencerNodeView;
    },

    _disposeDetachedSequencerNodeView : function(sequencerNodeOrCid, sequencerNodeView){
        const nodeCid = typeof sequencerNodeOrCid === "string"
            ? sequencerNodeOrCid
            : sequencerNodeOrCid && sequencerNodeOrCid.cid
                ? sequencerNodeOrCid.cid
                : null;
        const detachedSequencerNodeView = sequencerNodeView || (nodeCid ? this._sequencerNodeCidToSequencerNodeViewMap[nodeCid] : null);
        if(!detachedSequencerNodeView){
            if(nodeCid && this._sequencerNodeCidToSequencerNodeViewMap[nodeCid]){
                delete this._sequencerNodeCidToSequencerNodeViewMap[nodeCid];
                return true;
            }
            return false;
        }
        this._stoplisteningToEventsOnNodeView(detachedSequencerNodeView);
        if(nodeCid && this._sequencerNodeCidToSequencerNodeViewMap[nodeCid] === detachedSequencerNodeView){
            delete this._sequencerNodeCidToSequencerNodeViewMap[nodeCid];
        }
        if(detachedSequencerNodeView.setParagraphContainerView){
            detachedSequencerNodeView.setParagraphContainerView(null);
        }
        if(detachedSequencerNodeView.remove){
            detachedSequencerNodeView.remove();
        }else{
            if(detachedSequencerNodeView.$el && detachedSequencerNodeView.$el.remove){
                detachedSequencerNodeView.$el.remove();
            }
        }
        return true;
    },

    _createParagraphContainerViewFromLayout : function(paragraphDescriptor){
        let paragraphContainerView = null;
        if(paragraphDescriptor && paragraphDescriptor.kind === ParagraphLayoutBuilder.PARAGRAPH_KIND.SPEAKER){
            paragraphContainerView = new SpeakerParagraphContainerView({model: paragraphDescriptor.speakerInfo, sequencer: this.getModel()});
        }else{
            paragraphContainerView = new UnlabelledParagraphContainerView();
        }
        paragraphContainerView.render();
        return paragraphContainerView;
    },

    _appendParagraphContainerView : function(paragraphContainerView){
        this._arrayOfParagraphContainerViews.push(paragraphContainerView);
        this.sequencerNodeContainer$el.append(paragraphContainerView.$el);
        this._listenToEventsOnParagraphContainerView(paragraphContainerView);
    },

    _appendSequencerNodeViewToParagraph : function(paragraphContainerView, sequencerNodeView){
        if(!paragraphContainerView || !sequencerNodeView){
            return false;
        }
        if(paragraphContainerView.appendSequencerNodeViewWithoutValidation){
            return paragraphContainerView.appendSequencerNodeViewWithoutValidation(sequencerNodeView);
        }
        throw "something went wrong rebuilding paragraph layout";
    },

    _teardownParagraphLayout : function(){
        const paragraphContainerViewsToDestroy = this._arrayOfParagraphContainerViews.slice();
        for(let i = 0; i < paragraphContainerViewsToDestroy.length; i++){
            const paragraphContainerView = paragraphContainerViewsToDestroy[i];
            const sequencerNodeViews = paragraphContainerView && paragraphContainerView.getSequencerNodeViewArray ? paragraphContainerView.getSequencerNodeViewArray().slice() : [];
            for(let j = 0; j < sequencerNodeViews.length; j++){
                paragraphContainerView.removeSequencerNodeView(sequencerNodeViews[j], true);
            }
            this._destroyParagraphContainerView(paragraphContainerView);
        }
        if(this.sequencerNodeContainer$el){
            this.sequencerNodeContainer$el.find(".sequencer_paragraph").remove();
        }
    },

    _getParagraphLayoutBuildOptions : function(orderedSequencerNodes){
        return Object.assign({
            sequencerNodes: orderedSequencerNodes,
            totalNumberOfSpeakerInfo: this.model.getTotalNumberOfSpeakerInfo(),
            unknownSpeakerInfo: this.model.getUnknownSpeakerInfo(),
            paragraphBoundaryPolicy: this._getParagraphBoundaryPolicy(),
        }, PARAGRAPH_LAYOUT_RULES);
    },

    _getParagraphBoundaryPolicy : function(){
        return DEFAULT_PARAGRAPH_BOUNDARY_POLICY_FOR_SEQUENCER;
    },

    _getCurrentParagraphLayoutAnalysis : function(){
        if(this._paragraphLayoutAnalysis){
            return this._paragraphLayoutAnalysis;
        }
        const orderedSequencerNodes = this._getArrayOfSequencerNodesInOrder();
        this._paragraphLayoutAnalysis = ParagraphLayoutBuilder.analyze(this._getParagraphLayoutBuildOptions(orderedSequencerNodes));
        return this._paragraphLayoutAnalysis;
    },

    _getBoundaryDecisionBeforeSequencerNode : function(paragraphLayoutAnalysis, sequencerNode){
        if(
            !paragraphLayoutAnalysis
            || !paragraphLayoutAnalysis.boundaryBeforeNodeCidMap
            || !sequencerNode
            || !sequencerNode.cid
        ){
            return {
                shouldBreak: false,
                reason: null,
                strength: null,
            };
        }
        return paragraphLayoutAnalysis.boundaryBeforeNodeCidMap[sequencerNode.cid] || {
            shouldBreak: false,
            reason: null,
            strength: null,
        };
    },

    _getParagraphDescriptorForSequencerNode : function(paragraphLayoutAnalysis, sequencerNode){
        if(
            !paragraphLayoutAnalysis
            || !paragraphLayoutAnalysis.paragraphIndexByNodeCidMap
            || !paragraphLayoutAnalysis.paragraphLayout
            || !sequencerNode
            || !sequencerNode.cid
        ){
            return null;
        }
        const paragraphIndex = paragraphLayoutAnalysis.paragraphIndexByNodeCidMap[sequencerNode.cid];
        return Number.isFinite(paragraphIndex) ? paragraphLayoutAnalysis.paragraphLayout[paragraphIndex] || null : null;
    },

    _isParagraphDescriptorLockedForManualBoundaryEdits : function(paragraphDescriptor){
        if(!paragraphDescriptor || !Array.isArray(paragraphDescriptor.sequencerNodes)){
            return false;
        }
        const utils = Utils.getInstance();
        return paragraphDescriptor.sequencerNodes.some((sequencerNode)=>{
            const constructor = sequencerNode && sequencerNode.getConstructor ? sequencerNode.getConstructor() : sequencerNode && sequencerNode.constructor;
            const nodeType = constructor && constructor.CLASSNAME
                ? constructor.CLASSNAME
                : sequencerNode && sequencerNode.type
                    ? sequencerNode.type
                    : sequencerNode && sequencerNode.get
                        ? sequencerNode.get("type")
                        : null;
            const isStartLayoutWrapNode = typeof utils.isStartLayoutWrapSequencerNodeInstance === "function"
                ? utils.isStartLayoutWrapSequencerNodeInstance(sequencerNode)
                : nodeType === "StartLayoutWrapSequencerNode";
            const isEndLayoutWrapNode = typeof utils.isEndLayoutWrapSequencerNodeInstance === "function"
                ? utils.isEndLayoutWrapSequencerNodeInstance(sequencerNode)
                : nodeType === "EndLayoutWrapSequencerNode";
            return isStartLayoutWrapNode || isEndLayoutWrapNode;
        });
    },

    rebuildParagraphLayout : function(){
        if(!this.model || !this.sequencerNodeContainer$el){
            return false;
        }
        this._cancelStandaloneRemoveParagraphLayoutRefresh();

        if(this._paragraphContainerViewsPendingCleanup){
            this._paragraphContainerViewsPendingCleanup.clear();
        }
        this._paragraphContainerCleanupScheduled = false;

        const orderedSequencerNodes = this._getArrayOfSequencerNodesInOrder();
        const paragraphLayoutAnalysis = ParagraphLayoutBuilder.analyze(this._getParagraphLayoutBuildOptions(orderedSequencerNodes));
        const paragraphLayout = paragraphLayoutAnalysis.paragraphLayout;
        const orderedNodeCidMap = orderedSequencerNodes.reduce((nodeCidMap, sequencerNode)=>{
            if(sequencerNode && sequencerNode.cid){
                nodeCidMap[sequencerNode.cid] = true;
            }
            return nodeCidMap;
        }, {});
        this._paragraphLayoutAnalysis = paragraphLayoutAnalysis;

        this._teardownParagraphLayout();
        for(let nodeCid in this._sequencerNodeCidToSequencerNodeViewMap){
            if(!orderedNodeCidMap[nodeCid]){
                this._disposeDetachedSequencerNodeView(nodeCid, this._sequencerNodeCidToSequencerNodeViewMap[nodeCid]);
            }
        }

        for(let i = 0; i < paragraphLayout.length; i++){
            const paragraphDescriptor = paragraphLayout[i];
            const paragraphContainerView = this._createParagraphContainerViewFromLayout(paragraphDescriptor);
            this._appendParagraphContainerView(paragraphContainerView);
            for(let j = 0; j < paragraphDescriptor.sequencerNodes.length; j++){
                const sequencerNodeView = this._getOrCreateSequencerNodeView(paragraphDescriptor.sequencerNodes[j]);
                this._appendSequencerNodeViewToParagraph(paragraphContainerView, sequencerNodeView);
            }
        }

        this._sequencerNodeElArray = orderedSequencerNodes.reduce((sequencerNodeElArray, sequencerNode)=>{
            const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(sequencerNode);
            if(sequencerNodeView && sequencerNodeView.$el){
                sequencerNodeElArray.push(sequencerNodeView.$el.get(0));
            }
            return sequencerNodeElArray;
        }, []);
        this._rebuildNodeElIndexMap();
        this._lastViewMapRebuildAt = Date.now();
        this._reconcileSelectionAfterParagraphRebuild();

        return true;
    },

    _flushParagraphLayoutRebuild : function(){
        if(this._paragraphLayoutRebuildPending && this.model && this.sequencerNodeContainer$el){
            this._paragraphLayoutRebuildPending = false;
            this.rebuildParagraphLayout();
            return true;
        }
        return false;
    },

    _scheduleParagraphLayoutRebuild : function(){
        this._cancelStandaloneRemoveParagraphLayoutRefresh();
        this._paragraphLayoutRebuildPending = true;
        this._paragraphLayoutAnalysis = null;
        if(this._paragraphLayoutRebuildScheduled){
            return;
        }
        this._paragraphLayoutRebuildScheduled = true;
        scheduleMicrotaskOrFallback((function(){
            this._paragraphLayoutRebuildScheduled = false;
            this._flushParagraphLayoutRebuild();
        }).bind(this));
    },

    _cancelStandaloneRemoveParagraphLayoutRefresh : function(){
        this._paragraphLayoutRefreshAfterStandaloneRemovePending = false;
        return true;
    },

    _scheduleStandaloneRemoveParagraphLayoutRefresh : function(){
        if(this._paragraphLayoutRebuildPending){
            return false;
        }
        this._paragraphLayoutRefreshAfterStandaloneRemovePending = true;
        if(this._paragraphLayoutRefreshAfterStandaloneRemoveScheduled){
            return true;
        }
        this._paragraphLayoutRefreshAfterStandaloneRemoveScheduled = true;
        scheduleMicrotaskOrFallback((function(){
            this._paragraphLayoutRefreshAfterStandaloneRemoveScheduled = false;
            if(
                !this._paragraphLayoutRefreshAfterStandaloneRemovePending
                || this._paragraphLayoutRebuildPending
            ){
                return;
            }
            this._paragraphLayoutRefreshAfterStandaloneRemovePending = false;
            this._scheduleParagraphLayoutRebuild();
        }).bind(this));
        return true;
    },

    _shouldRefreshParagraphLayoutAfterIncrementalRemove : function(previousNode, nextNode){
        if(
            !previousNode
            || !nextNode
            || typeof this._getNearestAttachedParagraphAnchor !== "function"
        ){
            return false;
        }
        const previousAnchor = this._getNearestAttachedParagraphAnchor(previousNode, "previous");
        const nextAnchor = this._getNearestAttachedParagraphAnchor(nextNode, "next");
        return !!(
            previousAnchor
            && previousAnchor.paragraph
            && nextAnchor
            && nextAnchor.paragraph
            && previousAnchor.paragraph !== nextAnchor.paragraph
        );
    },

    _markParagraphContainerViewForCleanup : function(paragraphContainerView){
        if(!paragraphContainerView){
            return false;
        }
        this._paragraphContainerViewsPendingCleanup.add(paragraphContainerView);
        this._schedulePendingParagraphCleanup();
        return true;
    },

    _unmarkParagraphContainerViewForCleanup : function(paragraphContainerView){
        if(!paragraphContainerView || !this._paragraphContainerViewsPendingCleanup){
            return false;
        }
        return this._paragraphContainerViewsPendingCleanup.delete(paragraphContainerView);
    },

    _schedulePendingParagraphCleanup : function(){
        if(this._paragraphContainerCleanupScheduled || this._paragraphLayoutRebuildPending){
            return false;
        }
        this._paragraphContainerCleanupScheduled = true;
        scheduleMicrotaskOrFallback((function(){
            this._paragraphContainerCleanupScheduled = false;
            this._flushPendingParagraphCleanup();
        }).bind(this));
        return true;
    },

    _flushPendingParagraphCleanup : function(){
        if(!this._paragraphContainerViewsPendingCleanup || this._paragraphContainerViewsPendingCleanup.size === 0){
            return false;
        }
        const paragraphContainerViewsToCleanup = Array.from(this._paragraphContainerViewsPendingCleanup);
        this._paragraphContainerViewsPendingCleanup.clear();
        let cleanedUp = false;
        for(let i = 0; i < paragraphContainerViewsToCleanup.length; i++){
            const paragraphContainerView = paragraphContainerViewsToCleanup[i];
            if(
                paragraphContainerView
                && paragraphContainerView.isEmpty
                && paragraphContainerView.isEmpty()
                && this._arrayOfParagraphContainerViews.indexOf(paragraphContainerView) > -1
            ){
                cleanedUp = this._destroyParagraphContainerView(paragraphContainerView) || cleanedUp;
            }
        }
        return cleanedUp;
    },

    // Incremental add/remove flows must anchor against the live paragraph DOM, not
    // only the immediate linked-list neighbors. Boundary helpers such as layout
    // wraps can sit between the replacement node and the nearest rendered word,
    // so walk outward until we find the closest attached node view that still
    // owns a paragraph container.
    _getNearestAttachedParagraphAnchor : function(sequencerNode, direction){
        if(!sequencerNode){
            return {node: null, view: null, paragraph: null};
        }
        const stepMethod = direction === "previous" ? "getPrevious" : "getNext";
        let nodeToInspect = sequencerNode;
        while(nodeToInspect){
            const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(nodeToInspect);
            const paragraphContainerView = sequencerNodeView && sequencerNodeView.getParagraphContainerView
                ? sequencerNodeView.getParagraphContainerView()
                : null;
            const nodeEl = sequencerNodeView && sequencerNodeView.$el && sequencerNodeView.$el.get
                ? sequencerNodeView.$el.get(0)
                : null;
            const nodeElIndex = nodeEl && this._sequencerNodeElToIndexMap
                ? (this._sequencerNodeElToIndexMap.get(nodeEl) ?? -1)
                : -1;
            if(sequencerNodeView && paragraphContainerView && nodeElIndex > -1){
                return {
                    node: nodeToInspect,
                    view: sequencerNodeView,
                    paragraph: paragraphContainerView,
                };
            }
            nodeToInspect = typeof nodeToInspect[stepMethod] === "function"
                ? nodeToInspect[stepMethod]()
                : null;
        }
        return {node: null, view: null, paragraph: null};
    },
    _getReusableEmptyParagraphContainerView : function(previousParagraph, nextParagraph){
        if(
            !this._paragraphContainerViewsPendingCleanup
            || this._paragraphContainerViewsPendingCleanup.size !== 1
        ){
            return null;
        }

        const reusableParagraphContainerView = Array.from(this._paragraphContainerViewsPendingCleanup)[0];
        if(
            !reusableParagraphContainerView
            || !reusableParagraphContainerView.isEmpty
            || !reusableParagraphContainerView.isEmpty()
        ){
            return null;
        }

        const reusableParagraphIndex = this._arrayOfParagraphContainerViews.indexOf(reusableParagraphContainerView);
        if(reusableParagraphIndex === -1){
            return null;
        }

        const previousParagraphIndex = previousParagraph
            ? this._arrayOfParagraphContainerViews.indexOf(previousParagraph)
            : -1;
        const nextParagraphIndex = nextParagraph
            ? this._arrayOfParagraphContainerViews.indexOf(nextParagraph)
            : -1;

        const isOnlyRemainingParagraph =
            !previousParagraph
            && !nextParagraph
            && this._arrayOfParagraphContainerViews.length === 1;
        const isBetweenParagraphNeighbors =
            previousParagraphIndex > -1
            && nextParagraphIndex > -1
            && reusableParagraphIndex === previousParagraphIndex + 1
            && reusableParagraphIndex === nextParagraphIndex - 1;
        const isImmediatelyBeforeNextParagraph =
            !previousParagraph
            && nextParagraphIndex > -1
            && reusableParagraphIndex === nextParagraphIndex - 1;
        const isImmediatelyAfterPreviousParagraph =
            previousParagraphIndex > -1
            && !nextParagraph
            && reusableParagraphIndex === previousParagraphIndex + 1;

        if(
            isOnlyRemainingParagraph
            || isBetweenParagraphNeighbors
            || isImmediatelyBeforeNextParagraph
            || isImmediatelyAfterPreviousParagraph
        ){
            return reusableParagraphContainerView;
        }

        return null;
    },

    onSequencerNodeAdded : function(sequencerNodeAdded){
        this._getOrCreateSequencerNodeView(sequencerNodeAdded);
    },

    _rebuildNodeElIndexMap: function() {
        this._sequencerNodeElToIndexMap.clear();
        for (let i = 0; i < this._sequencerNodeElArray.length; i++) {
            this._sequencerNodeElToIndexMap.set(this._sequencerNodeElArray[i], i);
        }
    },

    _listenToEventsOnNodeView : function(sequencerNodeView){
        if(!this._arrayOfSequencerNodeViewCidBeingListenedTo.includes(sequencerNodeView.cid)){
            this.listenTo(sequencerNodeView, "revertDeleteNodeCreation",this._onRequestToRevertDeleteNodeCreation);
            this.listenTo(sequencerNodeView, "tapholdOnWrapNode",this._onTapholdOnWrapNode);
            this.listenTo(sequencerNodeView, "sequencerNodeBeingDroppedBefore",this._onSequencerNodeBeingDroppedBeforeSequencerNode);
            this.listenTo(sequencerNodeView, "fileDroppedBeforeNode",this._onFileBeingDroppedBeforeSequencerNode);
            this.listenTo(sequencerNodeView, "fileDroppedAfterNode",this._onFileBeingDroppedAfterSequencerNode);
            this.listenTo(sequencerNodeView, "sequencerNodeHighlightedAsPlaying",this.scrollToSequencerNodeIfneccessary);
            this._arrayOfSequencerNodeViewCidBeingListenedTo.push(sequencerNodeView.cid)
        }
        //this.listenTo(sequencerNodeView, "onHiddenValueChange",this._onSequencerNodeViewHiddenChange);
    },

    _onParagraphTitleLabelClick : function(paragraphContainerView){

    },

    _listenToEventsOnParagraphContainerView : function(paragraphContainerView){
        if(!this._arrayOfParagraphContainerViewCidBeingListenedTo.includes(paragraphContainerView.cid)){
            this.listenTo(paragraphContainerView, "sequencerNodeBeingDroppedAtTheEndOfParagraph", this._onSequencerNodeBeingDroppedAtTheEndOfParagraph);
            this.listenTo(paragraphContainerView, "fileDroppedAtTheEndOfParagraph", this._onFileBeingDroppedAtTheEndOfParagraph);
            this.listenTo(paragraphContainerView, "onSpeakerLabelClick", this._onSpeakerLabelClick);
            this.listenTo(paragraphContainerView, "onParagraphTitleLabelClick", this._onParagraphTitleLabelClick);
            
            this._arrayOfParagraphContainerViewCidBeingListenedTo.push(paragraphContainerView.cid)
            this._paragraphViewCidToParagraphView[paragraphContainerView.cid]=  paragraphContainerView;
            if(USE_PARAGRAPH_SUMMARY_TO_INCREASE_RENDERING_SPEED){
                this._paragraphObserver.observe(paragraphContainerView.$el.get(0));
            }
        }
    },

    _destroyParagraphContainerView : function(paragraphContainerView){
        if(!paragraphContainerView){
            return false;
        }
        this._unmarkParagraphContainerViewForCleanup(paragraphContainerView);
        if(paragraphContainerView.cleanup){
            paragraphContainerView.cleanup();
        }else{
            paragraphContainerView.remove();
        }
        this._stoplisteningToEventsOnParagraphContainerView(paragraphContainerView);
        const paragraphContainerViewIndex = this._arrayOfParagraphContainerViews.indexOf(paragraphContainerView);
        if(paragraphContainerViewIndex > -1){
            this._arrayOfParagraphContainerViews.splice(paragraphContainerViewIndex, 1);
            return true;
        }
        return false;
    },



    _getSpeakerInfoId : function(speakerInfo){
        return speakerInfo && speakerInfo.getSpeakerId ? speakerInfo.getSpeakerId() : null;
    },

    _getSpeakerChangeTargetForParagraph : function(paragraphContainerView){
        if(!paragraphContainerView){
            return null;
        }
        const firstSequencerNodeView = paragraphContainerView.getFirstSequencerNodeView ? paragraphContainerView.getFirstSequencerNodeView() : null;
        const lastSequencerNodeView = paragraphContainerView.getLastSequencerNodeView ? paragraphContainerView.getLastSequencerNodeView() : null;
        if(!firstSequencerNodeView || !lastSequencerNodeView){
            return null;
        }
        return {
            paragraphContainerView,
            startSequencerNodeModel: firstSequencerNodeView.getModel(),
            endSequencerNodeModel: lastSequencerNodeView.getModel(),
            currentSpeakerInfo: paragraphContainerView.getModel ? paragraphContainerView.getModel() : null,
            triggerEl: paragraphContainerView.getSpeakerLabelContainer$el ? paragraphContainerView.getSpeakerLabelContainer$el().get(0) : null,
        };
    },

    _isVisibleSequencerNodeEligibleForSelectionSpeakerChange : function(sequencerNode){
        return SelectionSpeakerChangeHelper.isVisibleSequencerNodeEligibleForSpeakerChange(sequencerNode, {
            isWordSequencerNode: Utils.getInstance().isWordSequencerNodeInstance.bind(Utils.getInstance()),
            isPauseSequencerNode: Utils.getInstance().isPauseSequencerNodeInstance.bind(Utils.getInstance()),
            isAudioEventSequencerNode: Utils.getInstance().isAudioEventSequencerNodeInstance.bind(Utils.getInstance()),
            isDeletedSequencerNode: Utils.getInstance().isDeletedSequencerNodeInstance.bind(Utils.getInstance()),
        });
    },

    _getEffectiveSpeakerInfoForSequencerNode : function(sequencerNode){
        return SelectionSpeakerChangeHelper.getEffectiveSpeakerInfoForSequencerNode(sequencerNode, {
            getParagraphContainerView: (currentSequencerNode)=>{
                const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(currentSequencerNode);
                return sequencerNodeView && sequencerNodeView.getParagraphContainerView ? sequencerNodeView.getParagraphContainerView() : null;
            },
            isSpeakerParagraphContainerView: (paragraphContainerView)=>{
                return paragraphContainerView instanceof SpeakerParagraphContainerView;
            },
        });
    },

    _getUniformEffectiveSpeakerInfoForSequencerNodes : function(arrayOfSequencerNodes){
        return SelectionSpeakerChangeHelper.getUniformEffectiveSpeakerInfoForSequencerNodes(arrayOfSequencerNodes, {
            getParagraphContainerView: (currentSequencerNode)=>{
                const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(currentSequencerNode);
                return sequencerNodeView && sequencerNodeView.getParagraphContainerView ? sequencerNodeView.getParagraphContainerView() : null;
            },
            isSpeakerParagraphContainerView: (paragraphContainerView)=>{
                return paragraphContainerView instanceof SpeakerParagraphContainerView;
            },
            getSpeakerInfoId: this._getSpeakerInfoId.bind(this),
        });
    },

    _canSpeakerBeChangedForSequencerNode : function(sequencerNode){
        return SelectionSpeakerChangeHelper.canSpeakerBeChangedForSequencerNode(sequencerNode);
    },

    _getVisibleSequencerNodesSelected : function(arrayOfSequencerNodes){
        return SelectionSpeakerChangeHelper.getVisibleSequencerNodesSelected(arrayOfSequencerNodes, {
            isSequencerNodeVisible: (sequencerNode)=>{
                return this.model && this.model.isSequencerNodeVisible ? this.model.isSequencerNodeVisible(sequencerNode) : true;
            },
        });
    },

    _selectionContainsEligibleSpeakerChangeAnchor : function(arrayOfSequencerNodes){
        return SelectionSpeakerChangeHelper.selectionContainsEligibleSpeakerChangeAnchor(arrayOfSequencerNodes, {
            getParagraphContainerView: (currentSequencerNode)=>{
                const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(currentSequencerNode);
                return sequencerNodeView && sequencerNodeView.getParagraphContainerView ? sequencerNodeView.getParagraphContainerView() : null;
            },
            isSpeakerParagraphContainerView: (paragraphContainerView)=>{
                return paragraphContainerView instanceof SpeakerParagraphContainerView;
            },
        });
    },

    _isSpeakerChangeForSelectionAvailableForNodes : function(arrayOfSequencerNodes){
        return SelectionSpeakerChangeHelper.isSpeakerChangeForSelectionAvailableForNodes(arrayOfSequencerNodes, {
            isWordSequencerNode: Utils.getInstance().isWordSequencerNodeInstance.bind(Utils.getInstance()),
            isPauseSequencerNode: Utils.getInstance().isPauseSequencerNodeInstance.bind(Utils.getInstance()),
            isAudioEventSequencerNode: Utils.getInstance().isAudioEventSequencerNodeInstance.bind(Utils.getInstance()),
            isDeletedSequencerNode: Utils.getInstance().isDeletedSequencerNodeInstance.bind(Utils.getInstance()),
            isSequencerNodeVisible: (sequencerNode)=>{
                return this.model && this.model.isSequencerNodeVisible ? this.model.isSequencerNodeVisible(sequencerNode) : true;
            },
            getParagraphContainerView: (currentSequencerNode)=>{
                const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(currentSequencerNode);
                return sequencerNodeView && sequencerNodeView.getParagraphContainerView ? sequencerNodeView.getParagraphContainerView() : null;
            },
            isSpeakerParagraphContainerView: (paragraphContainerView)=>{
                return paragraphContainerView instanceof SpeakerParagraphContainerView;
            },
        });
    },

    _getSpeakerChangeTargetForSelection : function(anchorEl){
        const selectionInfo = this.getSelectionNode();
        if(!selectionInfo){
            return null;
        }
        const arrayOfSequencerNodesSelected = this._getArrayOfSequencerNodesSelected(selectionInfo);
        const visibleSequencerNodesSelected = this._getVisibleSequencerNodesSelected(arrayOfSequencerNodesSelected);
        if(
            visibleSequencerNodesSelected.length === 0
            || !this._isSpeakerChangeForSelectionAvailableForNodes(arrayOfSequencerNodesSelected)
        ){
            return null;
        }
        const selectionEndFocusNodeView = selectionInfo.selectionEndFocusNodeView || selectionInfo.endSequencerNodeView || selectionInfo.startSequencerNodeView;
        const resolvedAnchorEl = anchorEl && anchorEl.jquery ? anchorEl.get(0) : anchorEl;
        return {
            paragraphContainerView: null,
            startSequencerNodeModel: visibleSequencerNodesSelected[0],
            endSequencerNodeModel: visibleSequencerNodesSelected[visibleSequencerNodesSelected.length - 1],
            arrayOfSequencerNodeModelsToChange: visibleSequencerNodesSelected,
            currentSpeakerInfo: this._getUniformEffectiveSpeakerInfoForSequencerNodes(visibleSequencerNodesSelected),
            triggerEl: resolvedAnchorEl || (selectionEndFocusNodeView ? selectionEndFocusNodeView.$el.get(0) : null),
        };
    },

    _getLastVisibleSelectedSequencerNodeAnchorEl : function(selectionInfo){
        if(!selectionInfo){
            return null;
        }
        const arrayOfSequencerNodesSelected = this._getArrayOfSequencerNodesSelected(selectionInfo);
        const visibleSequencerNodesSelected = this._getVisibleSequencerNodesSelected(arrayOfSequencerNodesSelected);
        for(let i = visibleSequencerNodesSelected.length - 1; i >= 0; i--){
            const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(visibleSequencerNodesSelected[i]);
            const sequencerNodeEl = sequencerNodeView && sequencerNodeView.$el ? sequencerNodeView.$el.get(0) : null;
            if(sequencerNodeEl && typeof document !== "undefined" && document.documentElement && document.documentElement.contains(sequencerNodeEl)){
                return sequencerNodeEl;
            }
        }
        return null;
    },

    _getParagraphActionContextForSelection : function(){
        const selectionInfo = this.getSelectionNode();
        if(!selectionInfo){
            return null;
        }
        const arrayOfSequencerNodesSelected = this._getArrayOfSequencerNodesSelected(selectionInfo);
        const visibleSequencerNodesSelected = this._getVisibleSequencerNodesSelected(arrayOfSequencerNodesSelected);
        if(visibleSequencerNodesSelected.length === 0){
            return null;
        }

        const paragraphLayoutAnalysis = this._getCurrentParagraphLayoutAnalysis();
        const firstVisibleSequencerNode = visibleSequencerNodesSelected[0];
        const lastVisibleSequencerNode = visibleSequencerNodesSelected[visibleSequencerNodesSelected.length - 1];
        const currentParagraphDescriptor = this._getParagraphDescriptorForSequencerNode(paragraphLayoutAnalysis, firstVisibleSequencerNode);
        const endingParagraphDescriptor = this._getParagraphDescriptorForSequencerNode(paragraphLayoutAnalysis, lastVisibleSequencerNode);
        const selectionStaysWithinSingleParagraph = !!(
            currentParagraphDescriptor
            && endingParagraphDescriptor
            && currentParagraphDescriptor === endingParagraphDescriptor
        );
        const previousVisibleSequencerNode = firstVisibleSequencerNode && firstVisibleSequencerNode.getPreviousVisibleSequencerNode
            ? firstVisibleSequencerNode.getPreviousVisibleSequencerNode()
            : null;
        const nextVisibleSequencerNode = lastVisibleSequencerNode && lastVisibleSequencerNode.getNextVisibleSequencerNode
            ? lastVisibleSequencerNode.getNextVisibleSequencerNode()
            : null;
        const previousParagraphDescriptor = previousVisibleSequencerNode
            ? this._getParagraphDescriptorForSequencerNode(paragraphLayoutAnalysis, previousVisibleSequencerNode)
            : null;
        const nextParagraphDescriptor = nextVisibleSequencerNode
            ? this._getParagraphDescriptorForSequencerNode(paragraphLayoutAnalysis, nextVisibleSequencerNode)
            : null;
        const boundaryBeforeSelection = this._getBoundaryDecisionBeforeSequencerNode(paragraphLayoutAnalysis, firstVisibleSequencerNode);
        const boundaryAfterSelection = this._getBoundaryDecisionBeforeSequencerNode(paragraphLayoutAnalysis, nextVisibleSequencerNode);
        const paragraphLockedForManualBoundaryEdits = this._isParagraphDescriptorLockedForManualBoundaryEdits(currentParagraphDescriptor);
        const previousParagraphLockedForManualBoundaryEdits = this._isParagraphDescriptorLockedForManualBoundaryEdits(previousParagraphDescriptor);
        const nextParagraphLockedForManualBoundaryEdits = this._isParagraphDescriptorLockedForManualBoundaryEdits(nextParagraphDescriptor);
        const canUseParagraphActions = !this._editingLocked && selectionStaysWithinSingleParagraph && !paragraphLockedForManualBoundaryEdits;

        return {
            selectionInfo: selectionInfo,
            arrayOfSequencerNodesSelected: arrayOfSequencerNodesSelected,
            visibleSequencerNodesSelected: visibleSequencerNodesSelected,
            paragraphLayoutAnalysis: paragraphLayoutAnalysis,
            firstVisibleSequencerNode: firstVisibleSequencerNode,
            lastVisibleSequencerNode: lastVisibleSequencerNode,
            currentParagraphDescriptor: currentParagraphDescriptor,
            previousVisibleSequencerNode: previousVisibleSequencerNode,
            nextVisibleSequencerNode: nextVisibleSequencerNode,
            boundaryBeforeSelection: boundaryBeforeSelection,
            boundaryAfterSelection: boundaryAfterSelection,
            selectionStaysWithinSingleParagraph: selectionStaysWithinSingleParagraph,
            paragraphLockedForManualBoundaryEdits: paragraphLockedForManualBoundaryEdits,
            canBreakBefore: !!(
                canUseParagraphActions
                && previousVisibleSequencerNode
                && !boundaryBeforeSelection.shouldBreak
            ),
            canBreakAfter: !!(
                canUseParagraphActions
                && nextVisibleSequencerNode
                && nextParagraphDescriptor === currentParagraphDescriptor
                && !boundaryAfterSelection.shouldBreak
            ),
            canMergeWithPrevious: !!(
                canUseParagraphActions
                && previousVisibleSequencerNode
                && previousParagraphDescriptor
                && previousParagraphDescriptor !== currentParagraphDescriptor
                && !previousParagraphLockedForManualBoundaryEdits
                && boundaryBeforeSelection.shouldBreak
                && boundaryBeforeSelection.strength !== "hard"
            ),
            canMergeWithNext: !!(
                canUseParagraphActions
                && nextVisibleSequencerNode
                && nextParagraphDescriptor
                && nextParagraphDescriptor !== currentParagraphDescriptor
                && !nextParagraphLockedForManualBoundaryEdits
                && boundaryAfterSelection.shouldBreak
                && boundaryAfterSelection.strength !== "hard"
            ),
        };
    },

    _applyParagraphBoundaryPreferenceForSequencerNode : function(sequencerNode, paragraphBoundaryPreference){
        if(this._editingLocked || !sequencerNode){
            return false;
        }
        const didChangeParagraphBoundary = this.model.changeParagraphBoundaryPreference(
            sequencerNode,
            paragraphBoundaryPreference,
        );
        if(didChangeParagraphBoundary){
            this._destroyContextMenuDisplayed();
        }
        return !!didChangeParagraphBoundary;
    },

    breakParagraphBeforeSelection : function(){
        const paragraphActionContext = this._getParagraphActionContextForSelection();
        if(!paragraphActionContext || !paragraphActionContext.canBreakBefore){
            return false;
        }
        return this._applyParagraphBoundaryPreferenceForSequencerNode(
            paragraphActionContext.firstVisibleSequencerNode,
            ParagraphBoundaryPreference.VALUES.BREAK_BEFORE,
        );
    },

    breakParagraphAfterSelection : function(){
        const paragraphActionContext = this._getParagraphActionContextForSelection();
        if(!paragraphActionContext || !paragraphActionContext.canBreakAfter){
            return false;
        }
        return this._applyParagraphBoundaryPreferenceForSequencerNode(
            paragraphActionContext.nextVisibleSequencerNode,
            ParagraphBoundaryPreference.VALUES.BREAK_BEFORE,
        );
    },

    mergeSelectionWithPreviousParagraph : function(){
        const paragraphActionContext = this._getParagraphActionContextForSelection();
        if(!paragraphActionContext || !paragraphActionContext.canMergeWithPrevious){
            return false;
        }
        return this._applyParagraphBoundaryPreferenceForSequencerNode(
            paragraphActionContext.firstVisibleSequencerNode,
            ParagraphBoundaryPreference.VALUES.JOIN_WITH_PREVIOUS,
        );
    },

    mergeSelectionWithNextParagraph : function(){
        const paragraphActionContext = this._getParagraphActionContextForSelection();
        if(!paragraphActionContext || !paragraphActionContext.canMergeWithNext){
            return false;
        }
        return this._applyParagraphBoundaryPreferenceForSequencerNode(
            paragraphActionContext.nextVisibleSequencerNode,
            ParagraphBoundaryPreference.VALUES.JOIN_WITH_PREVIOUS,
        );
    },

    _getSpeakerInfoOptionsForTarget : function(speakerChangeTarget){
        return SelectionSpeakerChangeHelper.getSpeakerInfoOptionsForTarget(
            speakerChangeTarget,
            this.getModel().getAllSpeakerInfo(),
            {
                getSpeakerInfoId: this._getSpeakerInfoId.bind(this),
            },
        );
    },

    _assignSpeakerToTarget : function(speakerChangeTarget, speakerInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this._destroySpeakerContextMenuIfApplicable();
            return false;
        }
        if(this._editingLocked){
            return false;
        }
        if(!speakerChangeTarget || !speakerInfo){
            return false;
        }
        this.model.changeSpeakerParagraph(
            speakerChangeTarget.paragraphContainerView,
            speakerInfo,
            speakerChangeTarget.startSequencerNodeModel,
            speakerChangeTarget.endSequencerNodeModel,
            speakerChangeTarget.arrayOfSequencerNodeModelsToChange,
        );
        this._destroySpeakerContextMenuIfApplicable();
        return true;
    },

    _showSpeakerActionsContextMenuForTarget : function(speakerChangeTarget, options){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return false;
        }
        if(this._editingLocked){
            return false;
        }
        if(!speakerChangeTarget || !speakerChangeTarget.triggerEl){
            return false;
        }
        const menuPlacement = options && options.menuPlacement ? options.menuPlacement : "bottom-start";
        const includeRenameAction = !!(options && options.includeRenameAction);
        const speakerInfoOptions = this._getSpeakerInfoOptionsForTarget(speakerChangeTarget);
        const menuInfoArray = [];
        if(speakerInfoOptions.length > 0){
            menuInfoArray.push(
                Utils.getInstance().createMenuInfoItem(
                    "selectOtherSpeaker",
                    window.getI18n(ti18n,"SELECT_OTHER_SPEAKER"),
                    (e)=>{this._onChangeSpeakerContextMenuClicked(speakerChangeTarget, e);},
                ),
            );
        }
        if(includeRenameAction
            && speakerChangeTarget.paragraphContainerView
            && speakerChangeTarget.currentSpeakerInfo
            && speakerChangeTarget.currentSpeakerInfo.isEditable
            && speakerChangeTarget.currentSpeakerInfo.isEditable()){
            menuInfoArray.push(
                Utils.getInstance().createMenuInfoItem(
                    "renameCurrentSpeaker",
                    window.getI18n(ti18n,"RENAME_CURRENT_SPEAKER"),
                    ()=>{this._onRenameSpeakerSpeakerContextMenuClicked(speakerChangeTarget.paragraphContainerView);},
                ),
            );
        }
        menuInfoArray.push(
            Utils.getInstance().createMenuInfoItem(
                "createNewSpeaker",
                window.getI18n(ti18n,"CREATE_NEW_SPEAKER"),
                ()=>{this._onCreateNewSpeakerContextMenuClicked(speakerChangeTarget);},
            ),
        );
        const contextMenuTippyJSInstance = Utils.getInstance().createContextMenu(
            menuInfoArray,
            speakerChangeTarget.triggerEl,
            this.sequencerNodeContainer$el.get(0),
            menuPlacement,
            true,
        );
        this._initializeTippyJsTooltips($(contextMenuTippyJSInstance.popper));
        this._speakerContextMenuTippyJSInstanceDisplayed = contextMenuTippyJSInstance;
        return true;
    },

    _onChangeSpeakerContextMenuClicked :function(speakerChangeTarget, e){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this._destroySpeakerContextMenuIfApplicable();
            return false;
        }
        if(this._editingLocked){
            return false;
        }
        if(!speakerChangeTarget || !e || !e.currentTarget || !this._speakerContextMenuTippyJSInstanceDisplayed){
            return false;
        }
        if(this._speakerContextMenuTippyJSInstanceDisplayed.subMenu){
            this._speakerContextMenuTippyJSInstanceDisplayed.subMenu.destroy();
        }
        const speakerInfoOptions = this._getSpeakerInfoOptionsForTarget(speakerChangeTarget);
        if(speakerInfoOptions.length === 0){
            return false;
        }
        const contextMenuTippyJSInstance = Utils.getInstance().createContextMenu(
            speakerInfoOptions.map((speakerInfo)=>{
                return Utils.getInstance().createMenuInfoItem(
                    `speakerMenu_${Utils.getInstance().generateRandomId()}`,
                    speakerInfo.getSpeakerLabel(),
                    ()=>{this._assignSpeakerToTarget(speakerChangeTarget, speakerInfo);},
                    null,
                );
            }),
            e.currentTarget,
            this.sequencerNodeContainer$el.get(0),
            "right",
            true,
        );
        this._initializeTippyJsTooltips($(contextMenuTippyJSInstance.popper));
        this._speakerContextMenuTippyJSInstanceDisplayed.subMenu = contextMenuTippyJSInstance;
        return true;
    },

    _onCreateNewSpeakerContextMenuClicked :function(speakerChangeTarget){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this._destroySpeakerContextMenuIfApplicable();
            return false;
        }
        if(this._editingLocked){
            return false;
        }
        if(!speakerChangeTarget || !speakerChangeTarget.triggerEl){
            return false;
        }
        this._destroySpeakerContextMenuIfApplicable();
        const onCreateButtonClicked = (newSpeakerName)=>{
            if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
                this._destroyContextMenuCorrectTranscriptDisplayed();
                return false;
            }
            try{
                const newSpeakerInfo = this.model.createNewSpeakerInfoAndAssign(
                    newSpeakerName,
                    speakerChangeTarget.paragraphContainerView,
                    speakerChangeTarget.startSequencerNodeModel,
                    speakerChangeTarget.endSequencerNodeModel,
                    speakerChangeTarget.arrayOfSequencerNodeModelsToChange,
                );
                if(newSpeakerInfo){
                    this._destroySpeakerContextMenuIfApplicable();
                    return true;
                }else{
                    return false;
                }
            }catch(error){
                window.alertUserErrorMessage(error);
            }
        };
        this._showCorrectTranscriptContextMenuInstance(
            speakerChangeTarget.triggerEl,
            this.sequencerNodeContainer$el.get(0),
            "",
            onCreateButtonClicked,
            window.getI18n(ti18n,"CREATE"),
        );
        return true;
    },


    _onRenameSpeakerSpeakerContextMenuClicked :function(paragraphContainerView){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this._destroySpeakerContextMenuIfApplicable();
            return false;
        }
        if(this._editingLocked){
            return false;
        }
        this._destroySpeakerContextMenuIfApplicable();
        const onRenameButtonClicked = (newSpeakerName)=>{
            if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
                this._destroyContextMenuCorrectTranscriptDisplayed();
                return false;
            }
            try{
                const speakerWasRenamed = this.model.renameSpeakerInfo(paragraphContainerView.getModel(), newSpeakerName);
                if(speakerWasRenamed){
                    this._destroySpeakerContextMenuIfApplicable();
                }
                return speakerWasRenamed;
            }catch(error){
                window.alertUserErrorMessage(error);
            }
        }
        this._showCorrectTranscriptContextMenuInstance(paragraphContainerView.getSpeakerLabelContainer$el().get(0), this.sequencerNodeContainer$el.get(0), paragraphContainerView.getModel().getSpeakerLabel(), onRenameButtonClicked, window.getI18n(ti18n,"RENAME"));
    },

    _destroySpeakerContextMenuIfApplicable: function(){
        if(this._speakerContextMenuTippyJSInstanceDisplayed){
            if(this._speakerContextMenuTippyJSInstanceDisplayed.subMenu){
                this._speakerContextMenuTippyJSInstanceDisplayed.subMenu.destroy();
            }
            this._speakerContextMenuTippyJSInstanceDisplayed.destroy();
            this._speakerContextMenuTippyJSInstanceDisplayed = null;
        }
    },

    _onSpeakerLabelClick : function(paragraphContainerView){
        if(this._editingLocked){
            return false;
        }
        this._destroyContextMenuDisplayed();
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return false;
        }
        const speakerChangeTarget = this._getSpeakerChangeTargetForParagraph(paragraphContainerView);
        return this._showSpeakerActionsContextMenuForTarget(speakerChangeTarget, {"menuPlacement": "bottom-start", "includeRenameAction": true});
    },

    _stoplisteningToEventsOnNodeView :function(sequencerNodeView){
        const index = this._arrayOfSequencerNodeViewCidBeingListenedTo.indexOf(sequencerNodeView.cid);
        if(index > -1){
            this._arrayOfSequencerNodeViewCidBeingListenedTo.splice(index, 1);
        }
        Backbone.View.prototype.stopListening.call(this, sequencerNodeView);
    },

    _stoplisteningToEventsOnParagraphContainerView :function(paragraphContainerView){
        const index = this._arrayOfParagraphContainerViewCidBeingListenedTo.indexOf(paragraphContainerView.cid);
        if(index > -1){
            this._arrayOfParagraphContainerViewCidBeingListenedTo.splice(index, 1);
            delete this._paragraphViewCidToParagraphView[paragraphContainerView.cid];
            if(USE_PARAGRAPH_SUMMARY_TO_INCREASE_RENDERING_SPEED){
                this._paragraphObserver.unobserve(paragraphContainerView.$el.get(0));
            }
        }
        Backbone.View.prototype.stopListening.call(this, paragraphContainerView);
    },

    _isSequencerNodeViewInSequencerNodeContainerViewPort : function(sequencerNodeView, respectTopMargin){
        let isVisibleInViewPort =  true;
        if(sequencerNodeView && sequencerNodeView.$el.get(0).clientWidth !=0 &&  sequencerNodeView.$el.get(0).clientHeight != 0){
            //make sure the element is visible
            const el = sequencerNodeView.$el.get(0);
            const parentEl = this.sequencerNodeContainer$el.get(0);
            //const elemntRelativePosition = Utils.getInstance().getElementRelativePositionFromParent(el);
            const elemntRelativePosition = this._getSequencerNoveViewPositionInContainer(sequencerNodeView);
            if(elemntRelativePosition && (elemntRelativePosition.top >= parentEl.scrollTop && elemntRelativePosition.top < (parentEl.clientHeight + parentEl.scrollTop))){
                //Element is visible
                if(respectTopMargin){
                    if(elemntRelativePosition.top >= (parentEl.clientHeight + parentEl.scrollTop - MARGIN_TOP_WHEN_AUTO_SCROLLING)){
                        isVisibleInViewPort = false;
                    }
                }else{
                    if(elemntRelativePosition.top >= (parentEl.clientHeight + parentEl.scrollTop)){
                        isVisibleInViewPort = false;
                    }
                }
            }else{
                //element is not visible
                isVisibleInViewPort = false;
            }
        }
        return isVisibleInViewPort;
    },


    scrollToSequencerNodeIfneccessary : function(sequencerNodeView, forceScrolling, noAnimation, forceScrollingOnlyIfNotVisible){
        this._sequencerNodeViewCurrentlyHighlightedAsPlaying = sequencerNodeView;
        if(forceScrolling || this.getModel().getAutoScroll()){
            // Throttle scroll-into-view during playback to reduce layout thrashing.
            // Reading element positions forces layout recalculation which, combined
            // with the class add/remove from word highlighting, causes frame drops
            // in the video player. Scroll at most every 300ms during playback.
            if(!forceScrolling && this.getModel().isPlaying()){
                var now = performance.now();
                var SCROLL_THROTTLE_MS = 300;
                if(this._lastPlaybackScrollTime && (now - this._lastPlaybackScrollTime < SCROLL_THROTTLE_MS)){
                    // Stash the latest view so the next throttled tick scrolls to it
                    this._pendingPlaybackScrollNodeView = sequencerNodeView;
                    if(!this._pendingPlaybackScrollTimerId){
                        this._pendingPlaybackScrollTimerId = setTimeout((function(){
                            this._pendingPlaybackScrollTimerId = null;
                            if(this._pendingPlaybackScrollNodeView){
                                this._lastPlaybackScrollTime = performance.now();
                                this._scrollToSequencerNode(this._pendingPlaybackScrollNodeView, this._isUserManuallyScrolling? false: true, false, noAnimation, forceScrollingOnlyIfNotVisible);
                                this._pendingPlaybackScrollNodeView = null;
                            }
                        }).bind(this), SCROLL_THROTTLE_MS);
                    }
                    return;
                }
                // Cancel any stale delayed scroll before taking the immediate path
                if(this._pendingPlaybackScrollTimerId){
                    clearTimeout(this._pendingPlaybackScrollTimerId);
                    this._pendingPlaybackScrollTimerId = null;
                    this._pendingPlaybackScrollNodeView = null;
                }
                this._lastPlaybackScrollTime = now;
            }
            this._scrollToSequencerNode(sequencerNodeView, this._isUserManuallyScrolling && !forceScrolling? false: true, forceScrolling, noAnimation, forceScrollingOnlyIfNotVisible);
        }
    },

    _getSequencerNoveViewPositionInContainer : function(sequencerNodeView){
        const el = sequencerNodeView.$el.get(0);
        const paragraphContainerEl = sequencerNodeView.getParagraphContainerView()? sequencerNodeView.getParagraphContainerView().$el.get(0): null;
        const elemntRelativePositionFromParagraph = Utils.getInstance().getElementRelativePositionFromParent(el);
        const paragraphContainerRelativePosition = Utils.getInstance().getElementRelativePositionFromParent(paragraphContainerEl);
        const elemntRelativePosition = elemntRelativePositionFromParagraph;
        if(paragraphContainerRelativePosition && elemntRelativePositionFromParagraph){
            elemntRelativePosition.top = elemntRelativePositionFromParagraph.top + paragraphContainerRelativePosition.top;
            elemntRelativePosition.bottom = elemntRelativePositionFromParagraph.bottom + paragraphContainerRelativePosition.bottom;
            elemntRelativePosition.left = elemntRelativePositionFromParagraph.left + paragraphContainerRelativePosition.left;
            elemntRelativePosition.right = elemntRelativePositionFromParagraph.right + paragraphContainerRelativePosition.right;
        }
        return elemntRelativePosition;
    },

    _scrollToSequencerNode : function(sequencerNodeView,respectTopMargin, forceScrolling, noAnimation, forceScrollingOnlyIfNotVisible){
        this._scrollTopAnimationOnProgress = (this._scrollTopAnimationOnProgress ?this._scrollTopAnimationOnProgress : RSVP.Promise.resolve()) .then((function(){
            return new RSVP.Promise((function(resolve, reject){
                try{
                    if(forceScrolling ||(forceScrollingOnlyIfNotVisible && !this._isSequencerNodeViewInSequencerNodeContainerViewPort(sequencerNodeView, respectTopMargin))|| (this.model.isPlaying() && !this._isUserManuallyScrolling && !this._isSequencerNodeViewInSequencerNodeContainerViewPort(sequencerNodeView, respectTopMargin))){
                        const elemntRelativePosition =  this._getSequencerNoveViewPositionInContainer(sequencerNodeView);
                        if(elemntRelativePosition){
                            this._pendingScrollAnimationResolve = resolve;
                            this._pendingScrollAnimationReject = resolve;
                            const onAnimationCompleted = (function(){
                                this._pendingScrollAnimation =  false;
                                this._pendingScrollAnimationResolve();
                            }).bind(this);
                            if(elemntRelativePosition.top - MARGIN_TOP_WHEN_AUTO_SCROLLING >= 0){
                                if(noAnimation){
                                    this.sequencerNodeContainer$el.scrollTop( elemntRelativePosition.top - MARGIN_TOP_WHEN_AUTO_SCROLLING );
                                    resolve();
                                }else{
                                    this._pendingScrollAnimation =  true;
                                    this.sequencerNodeContainer$el.animate({"scrollTop": elemntRelativePosition.top - MARGIN_TOP_WHEN_AUTO_SCROLLING}, 400, "swing", onAnimationCompleted );
                                }
                            }else{
                                if(noAnimation){
                                    this.sequencerNodeContainer$el.scrollTop( 0);
                                    resolve();
                                }else{
                                    this._pendingScrollAnimation =  true;
                                    this.sequencerNodeContainer$el.animate({"scrollTop":  0}, 400, "swing", onAnimationCompleted);
                                }
                            }
                        }else{
                    //element is probably not addede to the dom
                            resolve();
                        }

                    }else{
                        resolve();
                    }
                }catch(error){
                    reject(error);
                }
            }).bind(this))
        }).bind(this))
    },

    _deactivateAutoscollOnUserManualScrollIfNecessary : function(){
        if(!this._isSequencerNodeViewInSequencerNodeContainerViewPort(this._sequencerNodeViewCurrentlyHighlightedAsPlaying, false)){
            if(this.model.getAutoScroll()){
                this.model.setAutoScroll(false);
                Utils.getInstance().showInfoNotification(`${window.getI18n(ti18n, "AUTOSCROLL_TURNED_OFF")}`);
            }
        }
    },

    _onTapholdOnWrapNode : function(evt){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        if(this._sortableInstance){
            this.sequencerNodeContainer$el.attr("move_mode", "true");
            this._sortableInstance.option("disabled", false);
            this.unselectCurrentlySelectedSequencerNodes();
            this._sortableInstance._onTapStart(evt);
        }
    },

    _onFileBeingDroppedBeforeSequencerNode : function(fileDropInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        const files = fileDropInfo.files && fileDropInfo.files.length ? fileDropInfo.files : [fileDropInfo.file];
        const file = files[0];
        if(!file){
            return;
        }
        const sequencerNodeViewTarget = fileDropInfo.sequencerNodeViewTarget;
        if(sequencerNodeViewTarget.getModel().isSelected()){
            this.trigger("uploadFileAndWrapSelection",file);
        }else if(files.length > 1){
            this.trigger("uploadFilesAndInsertBefore",files, sequencerNodeViewTarget.getModel());
        }else{
            //this.unselectCurrentlySelectedSequencerNodes();
            this.trigger("uploadFileAndInsertBefore",file, sequencerNodeViewTarget.getModel());
        }

    },

    _onFileBeingDroppedAfterSequencerNode : function(fileDropInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        const file = fileDropInfo.file;
        const sequencerNodeViewTarget = fileDropInfo.sequencerNodeViewTarget;
        if(sequencerNodeViewTarget.getModel().isSelected()){
            this.trigger("uploadFileAndWrapSelection",file);
        }else{
            //this.unselectCurrentlySelectedSequencerNodes();
            this.trigger("uploadFileAndInsertAfter",file, sequencerNodeViewTarget.getModel());
        }

    },

    _onFileBeingDroppedAtTheEndOfParagraph : function(fileDropInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        const file = fileDropInfo.file;
        const paragraphContainerView = fileDropInfo.paragraphContainerView;
        if(paragraphContainerView.getLastSequencerNodeView()){
            this.trigger("uploadFileAndInsertAfter",file, paragraphContainerView.getLastSequencerNodeView().getModel());
        }
    },

    _onSequencerNodeBeingDroppedBeforeSequencerNode : function(dropInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        const modelCidOfSequencerNodeBeingDrop = dropInfo.modelCidOfSequencerNodeBeingDrop;
        const sequencerNodeViewTarget = dropInfo.sequencerNodeViewTarget;
        if(modelCidOfSequencerNodeBeingDrop && sequencerNodeViewTarget){
            const sequencerNodeMovedView = this.getSequencerNodeViewFromSequencerNodeCid(modelCidOfSequencerNodeBeingDrop);
            const sequencerNodeMovedParagraphContainerView = sequencerNodeMovedView? sequencerNodeMovedView.getParagraphContainerView(): null;
            const sequencerNodeMoved = sequencerNodeMovedView? sequencerNodeMovedView.getModel(): null;
            const newNextSequencerNodeView = sequencerNodeViewTarget;
            const newNextSequencerNode = newNextSequencerNodeView? newNextSequencerNodeView.getModel(): null;
            const newNextSequencerNodeParagraphContainerView = newNextSequencerNodeView? newNextSequencerNodeView.getParagraphContainerView(): null;
            const newPreviousSequencerNode = newNextSequencerNode? newNextSequencerNode.getPrevious(): null;
            const newPreviousSequencerNodeView = newPreviousSequencerNode? this.getSequencerNodeViewFromSequencerNodeCid(newPreviousSequencerNode.cid): null;
            const oldIndexInSequencer = this._getFlattenedSequencerNodeViewIndex(sequencerNodeMovedView);
            const newIndexInSequencer = this._getFlattenedSequencerNodeViewIndex(newNextSequencerNodeView);
            const oldIndeInParagraphContainer = sequencerNodeMovedParagraphContainerView?.getSequencerNodeViewIndex(sequencerNodeMovedView) ?? -1;
            const newIndeInParagraphContainer = newNextSequencerNodeParagraphContainerView?.getSequencerNodeViewIndex(newNextSequencerNodeView) ?? -1;
            if(!(oldIndeInParagraphContainer === newIndeInParagraphContainer && oldIndexInSequencer === newIndexInSequencer) && sequencerNodeMoved){
                //this._revertToInitialPositionBeforeDrag(sequencerNodeMovedView, oldIndexInSequencer, newIndexInSequencer);
                this.executeDragSequencerNode(sequencerNodeMoved,null,  null, newPreviousSequencerNode, newNextSequencerNode);
            }
        }
    },

    _onSequencerNodeBeingDroppedAtTheEndOfParagraph : function(dropInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        const modelCidOfSequencerNodeBeingDrop = dropInfo.modelCidOfSequencerNodeBeingDrop;
        const paragraphContainerViewTarget = dropInfo.paragraphContainerView;
        if(modelCidOfSequencerNodeBeingDrop && paragraphContainerViewTarget){
            const sequencerNodeMovedView = this.getSequencerNodeViewFromSequencerNodeCid(modelCidOfSequencerNodeBeingDrop);
            if(!sequencerNodeMovedView){
                return;
            }
            const sequencerNodeMovedParagraphContainerView = sequencerNodeMovedView.getParagraphContainerView();
            const sequencerNodeMoved = sequencerNodeMovedView.getModel();
            const newPreviousSequencerNodeView = paragraphContainerViewTarget.getLastSequencerNodeView();
            if(newPreviousSequencerNodeView){
                const newPreviousSequencerNode = newPreviousSequencerNodeView? newPreviousSequencerNodeView.getModel(): null;
                const oldIndexInSequencer = this._getFlattenedSequencerNodeViewIndex(sequencerNodeMovedView);
                const newIndexInSequencer = this._getFlattenedSequencerNodeViewIndex(newPreviousSequencerNodeView);
                const oldIndeInParagraphContainer = sequencerNodeMovedParagraphContainerView?.getSequencerNodeViewIndex(sequencerNodeMovedView) ?? -1;
                const newIndeInParagraphContainer = paragraphContainerViewTarget.getSequencerNodeViewIndex(newPreviousSequencerNodeView);
                if(!(oldIndeInParagraphContainer === newIndeInParagraphContainer && oldIndexInSequencer === newIndexInSequencer) && sequencerNodeMoved){
                    //this._revertToInitialPositionBeforeDrag(sequencerNodeMovedView, oldIndexInSequencer, newIndexInSequencer);
                    this.executeDragSequencerNode(sequencerNodeMoved,null,  null, newPreviousSequencerNode, null);
                }
            }else{
                
            }
        }
    },

    _onSequencerNodeBeingDroppedAfterSequencerNode : function(dropInfo){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        const modelCidOfSequencerNodeBeingDrop = dropInfo.modelCidOfSequencerNodeBeingDrop;
        const sequencerNodeViewTarget = dropInfo.sequencerNodeViewTarget;
        if(modelCidOfSequencerNodeBeingDrop){
            const sequencerNodeMovedView = this.getSequencerNodeViewFromSequencerNodeCid(modelCidOfSequencerNodeBeingDrop);
            const sequencerNodeMoved = sequencerNodeMovedView? sequencerNodeMovedView.getModel(): null;
            //const newNextSequencerNodeView = null;
            const newNextSequencerNode = null;
            const newPreviousSequencerNode = sequencerNodeViewTarget.getModel();
            const newPreviousSequencerNodeView = sequencerNodeViewTarget;
            if(newPreviousSequencerNodeView){
                const oldIndexInSequencer = this._getFlattenedSequencerNodeViewIndex(sequencerNodeMovedView);
                const newIndexInSequencer =  this._getFlattenedSequencerNodeViewIndex(newPreviousSequencerNodeView) + 1;
                if(oldIndexInSequencer != newIndexInSequencer && sequencerNodeMoved){
                    this._revertToInitialPositionBeforeDrag(sequencerNodeMovedView, oldIndexInSequencer, newIndexInSequencer);
                    this.executeDragSequencerNode(sequencerNodeMoved,oldIndexInSequencer,  newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode);
                }
            }
        }
    },


    _onSequencerNodeBeingDroppedAtTheEnd : function(modelCidOfSequencerNodeBeingDrop){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        if(modelCidOfSequencerNodeBeingDrop){
            const sequencerNodeMovedView = this.getSequencerNodeViewFromSequencerNodeCid(modelCidOfSequencerNodeBeingDrop);
            const sequencerNodeMoved = sequencerNodeMovedView? sequencerNodeMovedView.getModel(): null;
            //const newNextSequencerNodeView = null;
            const newNextSequencerNode = null;
            const newPreviousSequencerNode = this.model.getLastNode();
            const newPreviousSequencerNodeView = newPreviousSequencerNode? this.getSequencerNodeViewFromSequencerNodeCid(newPreviousSequencerNode.cid): null;
            if(newPreviousSequencerNodeView){
                const oldIndexInSequencer = this._getFlattenedSequencerNodeViewIndex(sequencerNodeMovedView);
                const newIndexInSequencer =  this._getFlattenedSequencerNodeViewIndex(newPreviousSequencerNodeView) + 1;
                if(oldIndexInSequencer != newIndexInSequencer && sequencerNodeMoved){
                    this._revertToInitialPositionBeforeDrag(sequencerNodeMovedView, oldIndexInSequencer, newIndexInSequencer);
                    this.executeDragSequencerNode(sequencerNodeMoved,oldIndexInSequencer,  newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode);
                }
            }
        }
    },

    
    _onFileInsertedAtTheEnd : function(file){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        if(this.model.getLastNode.isSelected()){
            this.trigger("uploadFileAndWrapSelection",file);
        }else{
            this.trigger("uploadFileAndInsertAtTheEnd",file);
        }
    },

    _onSequencerNodeViewHiddenChange: function(sequencerNodeView){
        this._onSequencerNodeHiddenChange(sequencerNodeView.getModel());
    },

    _onSequencerNodeHiddenChange: function(sequencerNode){
        let sequencerNodeView =  this.getSequencerNodeViewFromSequencerNode(sequencerNode);
        if(!sequencerNodeView){
            sequencerNodeView = this._createAndRenderSequencerNodeView(sequencerNode);
        }
        this._listenToEventsOnNodeView(sequencerNodeView);
        if(sequencerNode.isHidden()){
            sequencerNodeView.$el.remove();
            const nodeIndex = this._sequencerNodeElArray.indexOf(sequencerNodeView.$el.get(0));
            this._sequencerNodeElArray.splice(nodeIndex, 1);
        }else{
            sequencerNodeView.delegateEvents();
            const previousNode = sequencerNode.getPrevious();
            const previousNodeView = this.getSequencerNodeViewFromSequencerNode(previousNode);
            if(previousNodeView){
                sequencerNodeView.$el.insertAfter(previousNodeView.$el);
                const previousNodeIndex = this._sequencerNodeElArray.indexOf(previousNodeView.$el.get(0));
                this._sequencerNodeElArray.splice(previousNodeIndex+ 1, 0, sequencerNodeView.$el.get(0));
            }else{
                //this is probably the first node
                this.sequencerNodeContainer$el.prepend(sequencerNodeView.$el);
                this._sequencerNodeElArray.splice(0, 0, sequencerNodeView.$el.get(0));
            }
        }
        this._rebuildNodeElIndexMap();
    },

    _onSequencerNodeVisible : function(entries){
        entries.forEach((function(entry){
            if(entry.isIntersecting && entry.intersectionRatio > 0){
                entry.target.style.visibility = "visible";	
            }else{
                entry.target.style.visibility = "hidden";
            }
        }).bind(this));
    },

    _onSequencerNodeNotVisible : function(entries){
        entries.forEach((function(entry){
            if(entry.isIntersecting && entry.intersectionRatio > 0){
                entry.target.style.visibility = "visible";
            }else{
                entry.target.style.visibility = "hidden";
            }
        }).bind(this));
    },

    _setupVisibilityObservers: function(){

        this._sequencerNodeVisibleObserver = new IntersectionObserver(this._onSequencerNodeVisible.bind(this), {
            root: this.sequencerNodeContainer$el.get(0),
            rootMargin: "0px",
            threshold: 1.0
        });

        this._sequencerNodeHiddenObserver = new IntersectionObserver(this._onSequencerNodeNotVisible.bind(this), {
            root: this.sequencerNodeContainer$el.get(0),
            rootMargin: "0px",
            threshold: 0
        });


    },

    _onSequencerNodeAddedToSequencer: function(sequencerNode){
        const sequencerNodeView = this._getOrCreateSequencerNodeView(sequencerNode);
        if(!ENABLE_INCREMENTAL_PARAGRAPH_UPDATES){
            this._scheduleParagraphLayoutRebuild();
            return;
        }
        if(this._tryIncrementalParagraphAppend(sequencerNode, sequencerNodeView)){
            return;
        }
        this._scheduleParagraphLayoutRebuild();
    },

    // Attempt to graft the new node view into an existing paragraph container instead of
    // tearing the whole paragraph DOM down and rebuilding it from `ParagraphLayoutBuilder`.
    // Returns true on success. Any unhandled shape returns false and the caller falls back
    // to `_scheduleParagraphLayoutRebuild`. Auto-boundary re-evaluation (e.g. a newly long
    // pause that the policy would split on) is deferred until the next structural event —
    // which is exactly how the editor behaved before the April 2026 refactor.
    _tryIncrementalParagraphAppend : function(sequencerNode, sequencerNodeView){
        if(!sequencerNodeView || !this._arrayOfParagraphContainerViews || this._arrayOfParagraphContainerViews.length === 0){
            return false;
        }
        // If the view is already parented (e.g. undo re-attaches a node), let the rebuild sort it.
        if(sequencerNodeView.getParagraphContainerView && sequencerNodeView.getParagraphContainerView()){
            return false;
        }
        const getNearestAttachedParagraphAnchor = this._getNearestAttachedParagraphAnchor
            ? this._getNearestAttachedParagraphAnchor.bind(this)
            : (neighborNode)=>{
                const neighborNodeView = neighborNode ? this.getSequencerNodeViewFromSequencerNode(neighborNode) : null;
                return {
                    node: neighborNode,
                    view: neighborNodeView,
                    paragraph: neighborNodeView && neighborNodeView.getParagraphContainerView
                        ? neighborNodeView.getParagraphContainerView()
                        : null,
                };
            };
        const previousNode = typeof sequencerNode.getPrevious === "function" ? sequencerNode.getPrevious() : null;
        const previousAnchor = getNearestAttachedParagraphAnchor(previousNode, "previous");
        const previousNodeView = previousAnchor.view;
        const previousParagraph = previousAnchor.paragraph;
        const nextNode = typeof sequencerNode.getNext === "function" ? sequencerNode.getNext() : null;
        const nextAnchor = getNearestAttachedParagraphAnchor(nextNode, "next");
        const nextNodeView = nextAnchor.view;
        const nextParagraph = nextAnchor.paragraph;
        const reusableEmptyParagraph = this._getReusableEmptyParagraphContainerView(previousParagraph, nextParagraph);
        const shouldTryNextParagraphFirst = !!(
            sequencerNodeView.shouldBeAddedToParagraphContainerOfNextNodeFirst
            && sequencerNodeView.shouldBeAddedToParagraphContainerOfNextNodeFirst()
        );
        const canAppendAcrossBoundaryIntoNextParagraph = !!(
            shouldTryNextParagraphFirst
            && previousParagraph
            && nextParagraph
            && previousParagraph !== nextParagraph
            && !reusableEmptyParagraph
        );

        // Boundary insertion: when the previous and next nodes live in different paragraphs,
        // the new node sits on a paragraph boundary and the ParagraphBoundaryPolicy has to
        // decide which side owns it. We can't guess that correctly from the view layer, so
        // fall back to a full rebuild and let `ParagraphLayoutBuilder` resolve ownership,
        // unless a replacement flow left us with a preserved empty paragraph shell to reuse.
        if(
            previousParagraph
            && nextParagraph
            && previousParagraph !== nextParagraph
            && !reusableEmptyParagraph
            && !canAppendAcrossBoundaryIntoNextParagraph
        ){
            return false;
        }

        // Naming trap: ParagraphContainerView.addSequencerNodeViewAfter(new, ref) reads
        // "ref is AFTER new" and calls insertBefore(ref) — i.e. new goes BEFORE ref.
        // addSequencerNodeViewBefore(new, ref) reads "ref is BEFORE new" and calls
        // insertAfter(ref) — i.e. new goes AFTER ref. Pass the correct reference per semantics.
        let appended = false;
        let mutatedParagraph = null;
        const tryAppendToPreviousParagraph = (function(){
            if(previousParagraph && typeof previousParagraph.addSequencerNodeViewBefore === "function"){
                try {
                    // previousNodeView is BEFORE the new node → new node goes AFTER it
                    appended = previousParagraph.addSequencerNodeViewBefore(sequencerNodeView, previousNodeView);
                    if(appended){
                        mutatedParagraph = previousParagraph;
                    }
                } catch(e){
                    appended = false;
                }
            }
        }).bind(this);
        const tryAppendToNextParagraph = (function(){
            if(nextParagraph && typeof nextParagraph.addSequencerNodeViewAfter === "function"){
                try {
                    // nextNodeView is AFTER the new node → new node goes BEFORE it
                    appended = nextParagraph.addSequencerNodeViewAfter(sequencerNodeView, nextNodeView);
                    if(appended){
                        mutatedParagraph = nextParagraph;
                    }
                } catch(e){
                    appended = false;
                }
            }
        }).bind(this);

        if(shouldTryNextParagraphFirst){
            tryAppendToNextParagraph();
            if(!appended && !canAppendAcrossBoundaryIntoNextParagraph){
                tryAppendToPreviousParagraph();
            }
        }else{
            tryAppendToPreviousParagraph();
            if(!appended){
                tryAppendToNextParagraph();
            }
        }
        if(!appended && reusableEmptyParagraph){
            try {
                appended = this._appendSequencerNodeViewToParagraph(reusableEmptyParagraph, sequencerNodeView);
                if(appended){
                    mutatedParagraph = reusableEmptyParagraph;
                }
            } catch(e){
                appended = false;
            }
        }
        if(!appended){
            return false;
        }

        if(mutatedParagraph){
            this._unmarkParagraphContainerViewForCleanup(mutatedParagraph);
            if(mutatedParagraph.$el && mutatedParagraph.$el.get(0) && mutatedParagraph.$el.get(0).style){
                mutatedParagraph.$el.get(0).style.removeProperty("contain-intrinsic-height");
            }
        }
        if(
            typeof this._cancelStandaloneRemoveParagraphLayoutRefresh === "function"
            && (
                reusableEmptyParagraph
                || (
                    previousParagraph
                    && nextParagraph
                    && previousParagraph !== nextParagraph
                )
            )
        ){
            this._cancelStandaloneRemoveParagraphLayoutRefresh();
        }

        // Keep `_sequencerNodeElArray` and its index map in lockstep with the DOM insertion.
        const newEl = sequencerNodeView.$el.get(0);
        if(previousNodeView){
            const previousIndex = this._sequencerNodeElArray.indexOf(previousNodeView.$el.get(0));
            if(previousIndex > -1){
                this._sequencerNodeElArray.splice(previousIndex + 1, 0, newEl);
            } else {
                this._sequencerNodeElArray.push(newEl);
            }
        } else if(nextNodeView){
            const nextIndex = this._sequencerNodeElArray.indexOf(nextNodeView.$el.get(0));
            if(nextIndex > -1){
                this._sequencerNodeElArray.splice(nextIndex, 0, newEl);
            } else {
                this._sequencerNodeElArray.splice(0, 0, newEl);
            }
        } else {
            this._sequencerNodeElArray.splice(0, 0, newEl);
        }
        this._rebuildNodeElIndexMap();

        // Invalidate the builder's cached analysis — the next call that needs a fresh
        // paragraph layout (structural op, selection range resolution, save) will rebuild.
        this._paragraphLayoutAnalysis = null;
        this._schedulePendingParagraphCleanup();
        return true;
    },

    _removeSequencerNodeViewFromParagraph : function(sequencerNodeView, keepAllListenersAttached, preserveEmptyParagraphUntilFlush){
        const paragraphContainerView = sequencerNodeView.getParagraphContainerView();
        if(paragraphContainerView){
            paragraphContainerView.removeSequencerNodeView(sequencerNodeView, keepAllListenersAttached);
            if(paragraphContainerView.isEmpty()){
                if(preserveEmptyParagraphUntilFlush){
                    this._markParagraphContainerViewForCleanup(paragraphContainerView);
                }else{
                    this._destroyParagraphContainerView(paragraphContainerView);
                }
            }
        }
        
    },


    _onSequencerNodeRemovedToSequencer: function(sequencerNode){
        if(!ENABLE_INCREMENTAL_PARAGRAPH_UPDATES){
            this._scheduleParagraphLayoutRebuild();
            return;
        }
        const previousNode = sequencerNode && typeof sequencerNode.getPrevious === "function"
            ? sequencerNode.getPrevious()
            : null;
        const nextNode = sequencerNode && typeof sequencerNode.getNext === "function"
            ? sequencerNode.getNext()
            : null;
        const shouldRefreshParagraphLayoutAfterRemove = ENABLE_INCREMENTAL_PARAGRAPH_UPDATES
            && this._shouldRefreshParagraphLayoutAfterIncrementalRemove(previousNode, nextNode);
        const sequencerNodeView =  this.getSequencerNodeViewFromSequencerNode(sequencerNode);
        if(sequencerNodeView){
            // Remove the node view incrementally, but preserve any paragraph shell that
            // becomes empty until the end of the tick. Replacement flows (delete placeholder,
            // undo of deletion) can then graft the incoming node back into that shell without
            // paying for a full paragraph rebuild or flashing an empty gap.
            sequencerNodeView.undelegateEvents();
            this._stoplisteningToEventsOnNodeView(sequencerNodeView);
            this._removeSequencerNodeViewFromParagraph(sequencerNodeView, true, true);
            const nodeIndex = this._sequencerNodeElArray.indexOf(sequencerNodeView.$el.get(0));
            if(nodeIndex > -1){
                this._sequencerNodeElArray.splice(nodeIndex, 1);
            }
            this._rebuildNodeElIndexMap();
        }
        if(this._arrayOfSelectedSequencerNodeModels.indexOf(sequencerNode) != -1){
            //if sequencer node being remove is being selected, clear selection
            this.unselectCurrentlySelectedSequencerNodes();
        }
        if(sequencerNodeView){
            this._disposeDetachedSequencerNodeView(sequencerNode, sequencerNodeView);
        }
        this._paragraphLayoutAnalysis = null;
        this._schedulePendingParagraphCleanup();
        if(shouldRefreshParagraphLayoutAfterRemove){
            this._scheduleStandaloneRemoveParagraphLayoutRefresh();
        }
    },

    _initPlayerSlider : function(){
        this._noUiSliderObj = noUiSlider.create(this._playerSliderEl, {
            start: 0,
            connect: [true, false],
            behaviour :"tap-drag",
            orientation: 'horizontal', // 'horizontal' or 'vertical'
            range: {
                'min': 0,
                'max': 100
            },
            tooltips: false,
            format: {
                to: this._getSliderToFormat.bind(this),
                from: this._getSliderFromFormat.bind(this)
            }
        });
        this._playerSliderEl.noUiSlider.on('change',this._onUserSliderPosition.bind(this));
        this._playerSliderEl.noUiSlider.on('start',this._onUserStartedDraggingSlider.bind(this));
        this._playerSliderEl.noUiSlider.on('slide',this._onUserStartedDraggingSlider.bind(this));
        this._playerSliderEl.noUiSlider.on('end',this._onUserStoppedDraggingSlider.bind(this));
        this._playerSliderEl.noUiSlider.on('update',this._onUserStoppedDraggingSlider.bind(this));
    },

    _onUserStartedDraggingSlider : function(){
        this._playerSliderEl._isUserDragged = true;
    },

    _onUserStoppedDraggingSlider : function(){
        this._playerSliderEl._isUserDragged = false;
    },

    _onUserSliderPosition: function(formatedValues, handleNumber, unformattedValues ){
        const newValue = unformattedValues && unformattedValues.length > 0? unformattedValues[0]: this._playerSliderEl.noUiSlider.get();
        const timeInMilliseconds  = newValue * this.model.getDurationInMilliseconds()/ 100;
        this.trigger("updatePlaybackPositionInMilliseconds", timeInMilliseconds);
    },

    _getSliderToFormat : function(value){
        if(this.model && this.model.getDurationInMilliseconds()){
            return Utils.getInstance().formatPlaybackPositionToString(value * this.model.getDurationInMilliseconds()/ 100);
        }else{
            return " ";
        }
    },

    _getSliderFromFormat : function(value){
        return parseFloat(value);
    },


    _onRequestToRevertDeleteNodeCreation : function(sequencerNodeView){
        if(sequencerNodeView && canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this.trigger("revertDeleteNodeCreated", sequencerNodeView.getModel());
        }
    },

    _destroyContextMenuDisplayed: function(destroySubMenusOnly){
        if(!destroySubMenusOnly){
            if(DO_NOT_USE_TIPPYJS_MENU){
                this._destroyContextMenuDisplayedNew();
            }else{
                if(this._currentlyDisplayedTippyInstance){
                    // Preserve scroll position before destroying menu
                    const scrollTop = this.sequencerNodeContainer$el.scrollTop();

                    this._currentlyDisplayedTippyInstance.destroy();
                    this._currentlyDisplayedTippyInstance = null;
                    this._destroyTippyTooltipDisplayed();
                    this.trigger("onContextMenuDestroyed");

                    // Restore scroll position after menu destruction
                    // This prevents any scroll jump that might occur from the menu removal
                    requestAnimationFrame(() => {
                        if(this.sequencerNodeContainer$el && Math.abs(this.sequencerNodeContainer$el.scrollTop() - scrollTop) > 1){
                            this.sequencerNodeContainer$el.scrollTop(scrollTop);
                        }
                    });
                }
            }
        }
        if(this._currentInsertElementContextMenuDisplayedInstance){
            this.destroyInsertElementContextMenuDisplayedInstance();
        }
        if(this._currentDisplayedCorrectTranscriptsContextMenuInstance){
            this._destroyContextMenuCorrectTranscriptDisplayed();
        }

        if(this._speakerContextMenuTippyJSInstanceDisplayed){
            this._destroySpeakerContextMenuIfApplicable();
        }
        // Always destroy submenu view to ensure proper cleanup when any menu action occurs
        this.setSubContextMenuView(null);
    },

    isCorrectTranscriptionContextMenuDisplayed : function(){
        return !!this._currentDisplayedCorrectTranscriptsContextMenuInstance;
    },

    _destroyContextMenuCorrectTranscriptDisplayed: function(){
        if(this._currentDisplayedCorrectTranscriptsContextMenuInstance){
            this._currentDisplayedCorrectTranscriptsContextMenuInstance.mouseTrapObj.unbind('enter');
            this._currentDisplayedCorrectTranscriptsContextMenuInstance.destroy();
            this._currentDisplayedCorrectTranscriptsContextMenuInstance = null;
            this.trigger("onCorrectTranscriptContextMenuDestroyed");

        }
    },

    isContextMenuDisplayed: function(){
        return !!this._currentlyDisplayedTippyInstance;
    },

    destroyContextMenuDisplayed: function(destroySubMenusOnly){
        this._destroyContextMenuDisplayed(destroySubMenusOnly);
    },

    _destroyContextMenuDisplayedNew: function(){
        if(this._currentlyDisplayedContextMenuInstance){
            this._currentlyDisplayedContextMenuInstance.close();
            this._currentlyDisplayedContextMenuInstance = null;
            this.trigger("onContextMenuDestroyed");
        }
    },

    isOnboardingDisplayed : function(){
        return !!Shepherd.activeTour;
    },


    onIgnoreSelectedNodesBtnClicked: function(event){
        if(canTriggerIgnoreSelectedNodes({
            hasMutationAccess: this.hasMutationAccess(),
            hasModel: !!this.model,
            isOnboardingDisplayed: this.isOnboardingDisplayed(),
            isSearchOn: this.model && this.model.getSearchWidget().isSearchOn(),
            isSearchInputFocused: this.searchInput$el && this.searchInput$el.get(0) === document.activeElement,
        })){
            this._destroyContextMenuDisplayed();
            this.trigger("ignoreSelectedNodes");
            if(event){
                event.stopPropagation();
            }
        }
    },

    setTranscribedAudioBeingAdded : function(transcribedAudioBeingAdded){
        this._transcribedAudioBeingAdded = transcribedAudioBeingAdded;
        this.$el.attr("transcribedAudioBeingAdded", transcribedAudioBeingAdded?"true": "false");
    },

    onWrapWithMusicBtnClicked: function(event){
        if(canTriggerWrapSelectedNodesWithMusic({
            hasMutationAccess: this.hasMutationAccess(),
            isWrapActionAvailable: this.isWrapWithBackgroundMusicActionAvailable(),
            isOnboardingDisplayed: this.isOnboardingDisplayed(),
        })){
            this._destroyContextMenuDisplayed();
            this.trigger("wrapSelectedNodesWithMusic");
            if(event){
                event.stopPropagation();
            }
        }
    },

    onWrapWithMuteBtnClicked: function(event){
        if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            return;
        }
        if(!this.isOnboardingDisplayed()){
            this._destroyContextMenuDisplayed();
            this.trigger("wrapSelectedNodesWithMute");
            if(event){
                event.stopPropagation();
            }
        }
    },

    onPlayFromBtnClicked: function(event){
        this._destroyContextMenuDisplayed();
        this.trigger("playFrom");
        if(event){
            event.stopPropagation();
        }
    },

    onTranscribeSequencerNodeBtnClicked: function(event){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this._destroyContextMenuDisplayed();
            this.trigger("transcribedSequencerNode");
            if(event){
                event.stopPropagation();
            }
        }
    },


    onViewSettingForMusicWrapperBtnClicked: function(event){
        this._destroyContextMenuDisplayed();
        this.trigger("showSettingsForMusicWrapper");
        if(event){
            event.stopPropagation();
        }
    },

    onDeleteMusicWrapperBtn: function(event){
        if(canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
            this._destroyContextMenuDisplayed();
            this.trigger("deleteMusicWrapper");
            if(event){
                event.stopPropagation();
            }
        }
    },

    onDeleteWrapNodeBtn: function(event){
        this._destroyContextMenuDisplayed();
        this.trigger("deleteWrapNode");
        if(event){
            event.stopPropagation();
        }
    },

    setHeightMargin : function(heightMarginInPx){
        this._heightMarginInPx =  heightMarginInPx;
        this.onOrientationChangeFunction(PersistentModels.getInstance().getRouter().getViewportHeight(), true);
    },

    unselectCurrentlySelectedSequencerNodes : function(){
        for(let i = 0; i < this._arrayOfSelectedSequencerNodeModels.length; i++){
            const selectedNode = this._arrayOfSelectedSequencerNodeModels[i];
            selectedNode.setSelected(false);
        }
        this._arrayOfSelectedSequencerNodeModels = [];
        this._selectedNodeInfo = null;
        this._currentBrowserNativeSelection = null;
        this._onSelectionChange();
        this._destroyContextMenuDisplayed();
    },

    reselectCurrentlySelectedSequencerNodes: function(){
        const sectionNode = this.getSelectionNode();
        if(sectionNode && sectionNode.selectionStartAnchorNodeView && sectionNode.selectionEndFocusNodeView){
            const selectionStartAnchorNodeView = sectionNode.selectionStartAnchorNodeView;
            const selectionEndFocusNodeView = sectionNode.selectionEndFocusNodeView;
            this.unselectCurrentlySelectedSequencerNodes();
            this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(selectionStartAnchorNodeView.model.cid, selectionEndFocusNodeView.model.cid));
            this._showContextMenuUsingSelectedSequencerNodes();
        }
    },

    _clearBrowserSelection : function(){
        if (window.getSelection) {window.getSelection().removeAllRanges();}
        else if (document.selection) {document.selection.empty();}
    },

    _getSequencerNodeEl : function(element){
        let elementToCheck  = element;
        while(elementToCheck){
            if(elementToCheck && elementToCheck.classList && elementToCheck.classList.contains('sequencer_node')){
                return elementToCheck;
            }else{
                elementToCheck = elementToCheck.parentElement;
            }
        }
        return null;
    },

    _getSelectionInfoUsingTap : function(event){
        if(!this.isClickOccuredOnContextMenu(event) && !this.isClickOccuredOnSpeakerContextMenu(event)){
            const sequencerNodeEl  = this._getSequencerNodeEl(event.target);
            if(sequencerNodeEl){
                const sequencerNodeElCid = sequencerNodeEl.getAttribute("segment_node_cid");
                const sequencerNodeView = this._sequencerNodeCidToSequencerNodeViewMap[sequencerNodeElCid];
                if(sequencerNodeView){
                    const sequencerNodeModel = sequencerNodeView.getModel();
                    return {
                        "startSequencerNodeModel": sequencerNodeModel,
                        "startSequencerNodeView":sequencerNodeView,
                        "endSequencerNodeModel":sequencerNodeModel ,
                        "endSequencerNodeView": sequencerNodeView,
                        "selectionStartAnchorNodeView":sequencerNodeView,
                        "selectionEndFocusNodeView":sequencerNodeView
                    };
                }
            }
        }
    },

    _getSequencerNodePosition : function(sequencerNodeModel){
        const sequencerNodeView = this.getSequencerNodeViewFromSequencerNode(sequencerNodeModel);
        if(sequencerNodeView){
            if(this.model.isSequencerNodeVisible(sequencerNodeModel)){
                //return Utils.getInstance().getElementRelativePositionFromParent(sequencerNodeView.$el.get(0));
                return this._getSequencerNoveViewPositionInContainer(sequencerNodeView);
            }else{
                const previousVisibleNode  = sequencerNodeModel.getPreviousNodeMatchingCondition((function(node){
                    return this.model.isSequencerNodeVisible(node);
                }).bind(this));
                if(previousVisibleNode){
                    const previousVisibleNodeView = this.getSequencerNodeViewFromSequencerNode(previousVisibleNode);
                    //return Utils.getInstance().getElementRelativePositionFromParent(previousVisibleNodeView.$el.get(0));
                    return this._getSequencerNoveViewPositionInContainer(previousVisibleNodeView);
                }else{
                    const nextVisibleNode  = sequencerNodeModel.getNextNodeMatchingCondition((function(node){
                        return this.model.isSequencerNodeVisible(node);
                    }).bind(this));
                    if(nextVisibleNode){
                        const nextVisibleNodeView = this.getSequencerNodeViewFromSequencerNode(nextVisibleNode);
                        //return Utils.getInstance().getElementRelativePositionFromParent(nextVisibleNodeView.$el.get(0));
                        return this._getSequencerNoveViewPositionInContainer(nextVisibleNodeView);
                    }
                }
            }
        }
        return null;
    },


    _getClosestSequencerNodeUp : function(sequencerNodeModel){
        const elemntRelativePosition = this._getSequencerNodePosition(sequencerNodeModel);
        const getSequencerNodeViewFromSequencerNodeFunction = this.getSequencerNodeViewFromSequencerNode.bind(this);
        const getSequencerNodePositionFunction = this._getSequencerNodePosition.bind(this);
        const errorMargin = 5;
        const lastSequencerNodeOnThePreviousLine  =	sequencerNodeModel.getPreviousNodeMatchingCondition((function(node){
            const pos = getSequencerNodePositionFunction(node);
            if(pos){
                return !this._isElementOnSameYPosition(pos, elemntRelativePosition, errorMargin);
            }
            return false;
        }).bind(this));
        const positionOfLastSequencerNodeOnThePreviousLine = this._getSequencerNodePosition(lastSequencerNodeOnThePreviousLine);
        const allSequencerNodesOnThePreviousLine =  [];
        let nodeToIterate = lastSequencerNodeOnThePreviousLine;
        let posYDifferent = false;
        while(nodeToIterate && !posYDifferent){
            const pos = this._getSequencerNodePosition(nodeToIterate);
            if(!pos || !this._isElementOnSameYPosition(pos, positionOfLastSequencerNodeOnThePreviousLine, errorMargin)){
                posYDifferent = true;
            }else{
                allSequencerNodesOnThePreviousLine.push(nodeToIterate);
                nodeToIterate = nodeToIterate.getPreviousVisibleSequencerNode();
            }
        }
        const clientX = elemntRelativePosition.left;
        const clientY = elemntRelativePosition.top;
        return this._getElementWithClosestPosition(clientX, clientY, allSequencerNodesOnThePreviousLine);
    },

    _getElementWithClosestPosition : function(clientX, clientY, arrayOfSequencerNodes){
        let closestNode =  null;
        let closestNodeDistance = null;
        if(arrayOfSequencerNodes && arrayOfSequencerNodes.length > 0){
            arrayOfSequencerNodes.map((function( node, index){
                if(node){
                    const boundingClientRect = this._getSequencerNodePosition(node)
                    if(boundingClientRect){
                        const a = boundingClientRect.left - clientX;
                        const b = boundingClientRect.top - clientY;
                        
                        const distance = Math.sqrt( a*a + b*b );
                        if(!closestNode || distance < closestNodeDistance){
                            closestNode =  node;
                            closestNodeDistance = distance;
                        }
                        
                    }
                }

            }).bind(this));
        }
        return closestNode;
    },

    _isElementOnSameYPosition : function(elPosA, elPosB, errorMargin){
        if(!elPosA || !elPosB){
            return false;
        }
        if(!errorMargin){
            errorMargin = 0
        }
        return Math.abs(elPosA.top - elPosB.top) <= errorMargin;
    },

    _getClosestSequencerNodeDown : function(sequencerNodeModel){
        const elemntRelativePosition = this._getSequencerNodePosition(sequencerNodeModel);
        if(elemntRelativePosition){
            const getSequencerNodeViewFromSequencerNodeFunction = this.getSequencerNodeViewFromSequencerNode.bind(this);
            const getSequencerNodePositionFunction = this._getSequencerNodePosition.bind(this);
            const errorMargin = 5;
            const firstSequencerNodeOnTheNextLine  =	sequencerNodeModel.getNextNodeMatchingCondition((function(node){
                const pos = getSequencerNodePositionFunction(node)
                if(pos){
                    return !this._isElementOnSameYPosition(pos, elemntRelativePosition, errorMargin);
                }
                return false;
            }).bind(this));
            const positionOfFirstSequencerNodeOnTheNextLine = this._getSequencerNodePosition(firstSequencerNodeOnTheNextLine);
            const allSequencerNodesOnTheNextLine =  [];
            let nodeToIterate = firstSequencerNodeOnTheNextLine;
            let posYDifferent = false;
            while(nodeToIterate && !posYDifferent){
                const pos = this._getSequencerNodePosition(nodeToIterate);
                if(!pos || !this._isElementOnSameYPosition(pos, positionOfFirstSequencerNodeOnTheNextLine, errorMargin)){
                    posYDifferent = true;
                }else{
                    allSequencerNodesOnTheNextLine.push(nodeToIterate);
                    nodeToIterate = nodeToIterate.getNextVisibleSequencerNode();
                }
            }

            const clientX = elemntRelativePosition.left;
            const clientY = elemntRelativePosition.top;
            const closestNodeDistance = null;
            return this._getElementWithClosestPosition(clientX, clientY, allSequencerNodesOnTheNextLine);
        }else{
            return null;
        }
    },

    getNextVisibleSequencerNodeUpAfterSelection : function(){
        if(this._selectedNodeInfo){
            const sequencerNodeModel  = this._selectedNodeInfo.endSequencerNodeModel;
            if(sequencerNodeModel){
                return this._getClosestSequencerNodeUp(sequencerNodeModel);
                
            }else{
                return null;
            }
        }else{
            return this.model.getFirstNode();
        }
    },


    getNextVisibleSequencerNodeDownAfterSelection : function(){
        if(this._selectedNodeInfo){
            const sequencerNodeModel  = this._selectedNodeInfo.endSequencerNodeModel;
            if(sequencerNodeModel){
                return this._getClosestSequencerNodeDown(sequencerNodeModel);
            }else{
                return null;
            }
        }else{
            return this.model.getFirstNode();
        }
    },

    getNextVisibleSequencerNodeAfterSelection : function(){
        if(this._selectedNodeInfo){
            const endSequencerNodeModel  = this._selectedNodeInfo.endSequencerNodeModel;
            return endSequencerNodeModel.getNextVisibleSequencerNode();
        }else{
            return this.model.getFirstNode();
        }
    },

    getPreviousVisibleSequencerNodeAfterSelection : function(){
        if(this._selectedNodeInfo){
            const startSequencerNodeModel  = this._selectedNodeInfo.startSequencerNodeModel;
            return startSequencerNodeModel.getPreviousVisibleSequencerNode();
        }else{
            return this.model.getFirstNode();
        }
    },

    _updateSelectionInfoUsingTap : function(event){
        if(!this.isClickOccuredOnContextMenu(event) && !this.isClickOccuredOnSpeakerContextMenu(event)){
            const sequencerNodeEl  = this._getSequencerNodeEl(event.target);
            if(sequencerNodeEl){
                return this._selectSequencerNodeWithCid(sequencerNodeEl.getAttribute("segment_node_cid"))
                /*this.unselectCurrentlySelectedSequencerNodes();
                const sequencerNodeElCid = sequencerNodeEl.getAttribute("segment_node_cid");
                const sequencerNodeView = this._sequencerNodeCidToSequencerNodeViewMap[sequencerNodeElCid];
                if(sequencerNodeView){
                    const sequencerNodeModel = sequencerNodeView.getModel();
                    this._selectedNodeInfo = {
                        "startSequencerNodeModel": sequencerNodeModel,
                        "startSequencerNodeView":sequencerNodeView,
                        "endSequencerNodeModel":sequencerNodeModel ,
                        "endSequencerNodeView": sequencerNodeView,
                        "selectionStartAnchorNodeView":sequencerNodeView,
                        "selectionEndFocusNodeView":sequencerNodeView
                    };
                    this._onSelectionChange();
                    return this._selectedNodeInfo;
                }*/
            }
        }
    },

    _selectSequencerNodeWithCid :function(sequencerNodeCid){
        if(!sequencerNodeCid){
            return this._selectedNodeInfo;
        }
        // Route single-node selects through the same resolver as range selects
        // so a pruned-view race during paragraph rebuild does not silently drop
        // the current selection (arrow-key / search single-node selects hit the
        // same window that was fixed for ranges).
        const selectionInfo = this._resolveSelectionRange(sequencerNodeCid, sequencerNodeCid);
        if(!selectionInfo){
            this._reportSelectionResolutionFailure(
                sequencerNodeCid,
                sequencerNodeCid,
                this._resolveSelectionEndpoint(sequencerNodeCid),
                this._resolveSelectionEndpoint(sequencerNodeCid)
            );
            return this._selectedNodeInfo;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        this._selectedNodeInfo = selectionInfo;
        this._onSelectionChange();
        return this._selectedNodeInfo;
    },

    // Resolve a single selection endpoint against both the Sequencer model
    // (stable source of truth via _cidToSegmentNodeMap) and the view registry
    // (transient, pruned on every paragraph rebuild). Used by
    // _resolveSelectionRange — callers should not assume `view` is non-null
    // even when `resolved` is true.
    _resolveSelectionEndpoint : function(sequencerNodeCid){
        if(!sequencerNodeCid){
            return {view: null, node: null, resolved: false};
        }
        const node = this.model ? this.model.getSequencerNodeByNodeCid(sequencerNodeCid) : null;
        if(!node){
            return {view: null, node: null, resolved: false};
        }
        const view = this._sequencerNodeCidToSequencerNodeViewMap[sequencerNodeCid] || null;
        return {view: view, node: node, resolved: true};
    },

    // Resolve both endpoints and build a full selectionInfo. Returns null if
    // either endpoint is unresolvable (model missing) or if the backing view
    // has been pruned from the paragraph layout — the caller must fail closed
    // and never synthesize a partial selection (would silently retarget).
    _resolveSelectionRange : function(startSequencerNodeCid, endSequencerNodeCid){
        if(!startSequencerNodeCid || !endSequencerNodeCid){
            return null;
        }
        // Flush any pending paragraph rebuild before resolving, so the view +
        // element-index maps reflect the latest ordered node list. Without
        // this, arrow-key / search / deleted-node selection silently no-ops
        // during the rebuild window (TRE-438): views exist in the cid map
        // (created eagerly by _onSequencerNodeAddedToSequencer) but are
        // missing from the element-index map (populated by
        // rebuildParagraphLayout). The flush is a cheap no-op when no rebuild
        // is pending, and cannot re-enter because _flushParagraphLayoutRebuild
        // resets the pending flag before rebuilding.
        this._flushParagraphLayoutRebuild();
        const startEndpoint = this._resolveSelectionEndpoint(startSequencerNodeCid);
        const endEndpoint = this._resolveSelectionEndpoint(endSequencerNodeCid);
        if(!startEndpoint.resolved || !endEndpoint.resolved){
            return null;
        }
        if(!startEndpoint.view || !endEndpoint.view){
            return null;
        }
        const selectionStartNodeElIndex = this._sequencerNodeElToIndexMap.get(startEndpoint.view.$el.get(0)) ?? -1;
        const selectionEndNodeElIndex = this._sequencerNodeElToIndexMap.get(endEndpoint.view.$el.get(0)) ?? -1;
        // A view that exists in the cid map but is missing from the element
        // index map has been detached from the live paragraph layout. Fail
        // closed rather than fall through to the else-branch, which would
        // otherwise silently reverse-retarget (-1 > -1 is false).
        if(selectionStartNodeElIndex === -1 || selectionEndNodeElIndex === -1){
            return null;
        }
        let startSequencerNodeModel = null;
        let endSequencerNodeModel = null;
        let startSequencerNodeViewToReturn = null;
        let endSequencerNodeViewToReturn = null;
        if(selectionEndNodeElIndex > selectionStartNodeElIndex){
            startSequencerNodeModel = startEndpoint.node;
            endSequencerNodeModel = endEndpoint.node;
            startSequencerNodeViewToReturn = startEndpoint.view;
            endSequencerNodeViewToReturn = endEndpoint.view;
        }else{
            startSequencerNodeModel = endEndpoint.node;
            endSequencerNodeModel = startEndpoint.node;
            startSequencerNodeViewToReturn = endEndpoint.view;
            endSequencerNodeViewToReturn = startEndpoint.view;
        }
        return {
            "startSequencerNodeModel": startSequencerNodeModel,
            "startSequencerNodeView": startSequencerNodeViewToReturn,
            "endSequencerNodeModel": endSequencerNodeModel,
            "endSequencerNodeView": endSequencerNodeViewToReturn,
            "selectionStartAnchorNodeView": startEndpoint.view,
            "selectionEndFocusNodeView": endEndpoint.view
        };
    },

    // Collapse a selection onto whichever endpoint is still live — model
    // resolvable, view in cid map, and view attached to the current paragraph
    // layout. Used by _reconcileSelectionAfterParagraphRebuild to preserve
    // at least one end of a multi-selection when the other end's model or
    // view is gone (TRE-437). Clearing the whole selection is a UX regression
    // from pre-#1512 behavior.
    //
    // NOT used by _selectSequencerNodeRangeWithCid: fresh range selects
    // intentionally fail closed to avoid silently retargeting a user request
    // to a narrower range (see #1512 rationale).
    _collapseSelectionToLiveEndpoint : function(startSequencerNodeCid, endSequencerNodeCid){
        const tryCollapseTo = (cid) => {
            if(!cid){
                return null;
            }
            const endpoint = this._resolveSelectionEndpoint(cid);
            if(!endpoint.resolved || !endpoint.view){
                return null;
            }
            const elIndex = this._sequencerNodeElToIndexMap.get(endpoint.view.$el.get(0)) ?? -1;
            if(elIndex === -1){
                return null;
            }
            return {
                "startSequencerNodeModel": endpoint.node,
                "startSequencerNodeView": endpoint.view,
                "endSequencerNodeModel": endpoint.node,
                "endSequencerNodeView": endpoint.view,
                "selectionStartAnchorNodeView": endpoint.view,
                "selectionEndFocusNodeView": endpoint.view
            };
        };
        // Prefer the focus (end) endpoint — that's where the user's
        // cursor-intent was last anchored. Fall back to the start.
        return tryCollapseTo(endSequencerNodeCid) || tryCollapseTo(startSequencerNodeCid);
    },

    _reportSelectionResolutionFailure : function(startCid, endCid, startEndpoint, endEndpoint){
        try {
            if(typeof window !== "undefined" && window.Rollbar && typeof window.Rollbar.info === "function"){
                window.Rollbar.info("selectionResolutionFailed", {
                    event: "selectionResolutionFailed",
                    startCid: startCid || null,
                    endCid: endCid || null,
                    startCidFound: startEndpoint ? !!startEndpoint.resolved : false,
                    endCidFound: endEndpoint ? !!endEndpoint.resolved : false,
                    startViewFound: !!(startEndpoint && startEndpoint.view),
                    endViewFound: !!(endEndpoint && endEndpoint.view),
                    timeSinceLastViewMapRebuildMs: this._lastViewMapRebuildAt
                        ? Date.now() - this._lastViewMapRebuildAt
                        : -1,
                    hasCurrentSelection: !!this._selectedNodeInfo
                });
            }
        } catch (e) { /* telemetry must never affect user path */ }
    },

    // After a paragraph-layout rebuild, _sequencerNodeCidToSequencerNodeViewMap
    // has been pruned for any node not in the current ordered list. If
    // _selectedNodeInfo was referencing views that got pruned, its view refs
    // are now stale; re-resolve against the fresh registry or clear the
    // selection so downstream consumers never dereference a detached view.
    _reconcileSelectionAfterParagraphRebuild : function(){
        if(!this._selectedNodeInfo){
            return;
        }
        const startModel = this._selectedNodeInfo.startSequencerNodeModel;
        const endModel = this._selectedNodeInfo.endSequencerNodeModel;
        const startCid = startModel ? startModel.cid : null;
        const endCid = endModel ? endModel.cid : null;
        const refreshed = this._resolveSelectionRange(startCid, endCid);
        if(refreshed){
            // Refresh view refs AND re-sync the selection caches consumers
            // read from (_arrayOfSelectedSequencerNodeModels,
            // _currentBrowserNativeSelection) so the inspector / video preview
            // do not drift against stale state until the next user action.
            this._selectedNodeInfo = refreshed;
            this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(refreshed, true);
            return;
        }
        // Full range no longer resolves. Before clearing the whole selection
        // (which is a UX regression — pre-#1512 behavior kept the still-valid
        // half alive, TRE-437), try collapsing onto the surviving endpoint.
        const collapsed = this._collapseSelectionToLiveEndpoint(startCid, endCid);
        if(collapsed){
            // Clear the stale selection first. _markCurrentlySelectedNodesAs-
            // SelectedFromSelectionInfo only *adds* nodes from the new range
            // to `_arrayOfSelectedSequencerNodeModels` and only calls
            // setSelected(true) on them — it never unsets models that were
            // selected under the old wider range. When we narrow from
            // [This, ·, is] to [This], the dropped pause would keep its
            // .selected state without this call (CodeRabbit review on #1532).
            this.unselectCurrentlySelectedSequencerNodes();
            this._selectedNodeInfo = collapsed;
            this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(collapsed, true);
            return;
        }
        // Both endpoints are unrecoverable (evicted models or all views
        // pruned) — route through the canonical unselect path so every
        // piece of derived state clears together and _onSelectionChange
        // consumers are notified.
        this.unselectCurrentlySelectedSequencerNodes();
    },

    _selectSequencerNodeRangeWithCid :function(startSequencerNodeCid, endSequencerNodeCid){
        if(!startSequencerNodeCid || !endSequencerNodeCid){
            return this._selectedNodeInfo;
        }
        const selectionInfo = this._resolveSelectionRange(startSequencerNodeCid, endSequencerNodeCid);
        if(!selectionInfo){
            // Fail closed: do not unselect or retarget to a partial range — the
            // original crash and the "silent single-node retarget" fallback are
            // both ruled out. Leave the existing selection in place and report
            // so Rollbar can surface the race window.
            this._reportSelectionResolutionFailure(
                startSequencerNodeCid,
                endSequencerNodeCid,
                this._resolveSelectionEndpoint(startSequencerNodeCid),
                this._resolveSelectionEndpoint(endSequencerNodeCid)
            );
            return this._selectedNodeInfo;
        }
        this.unselectCurrentlySelectedSequencerNodes();
        this._selectedNodeInfo = selectionInfo;
        this._onSelectionChange();
        return this._selectedNodeInfo;
    },

_resolveFirefoxSelectionRangeFromFocusNodeCid: function(focusNodeCid, selectedNodeCount, isFocusNodeLastNode){
    if(!focusNodeCid || !this.model || !selectedNodeCount){
        return null;
    }
    const utils = Utils.getInstance();
    const isSelectableFirefoxNode = function(node){
        return utils.isWordSequencerNodeInstance(node) || utils.isPauseSequencerNodeInstance(node) || utils.isAudioEventSequencerNodeInstance(node);
    };
    let boundaryModel = this.model.getSequencerNodeByNodeCid(focusNodeCid);
    if(!boundaryModel || !isSelectableFirefoxNode(boundaryModel)){
        return null;
    }
    for(let i = 0; i < selectedNodeCount - 1; i++){
        const adjacentNode = isFocusNodeLastNode
            ? boundaryModel.getPreviousNodeMatchingCondition(isSelectableFirefoxNode)
            : boundaryModel.getNextNodeMatchingCondition(isSelectableFirefoxNode);
        if(adjacentNode){
            boundaryModel = adjacentNode;
        }else{
            return null;
        }
    }

    const startCid = isFocusNodeLastNode ? (boundaryModel ? boundaryModel.cid : null) : focusNodeCid;
    const endCid = isFocusNodeLastNode ? focusNodeCid : (boundaryModel ? boundaryModel.cid : null);
    return this._resolveSelectionRange(startCid, endCid);
},

_getCurrentBrowserSelectionParsedOnFirefox: function(){
    const selection = window.getSelection();
    const focusNode = this._getSequencerNodeEl(selection.focusNode);
    const focusNodeCid = focusNode && focusNode.getAttribute ? focusNode.getAttribute("segment_node_cid") : null;
    let allSelected  = [];
    
    const wordsSelectedArray = window.getSelection().toString().match(/\b([\w'-]+)\b/gim);
    if(wordsSelectedArray && wordsSelectedArray.length > 0){
        allSelected = allSelected.concat(wordsSelectedArray);
    }
    const expliciteltDisplayedPauses = window.getSelection().toString().match(/■/gim);
    if(expliciteltDisplayedPauses && expliciteltDisplayedPauses.length  > 0){
        allSelected = allSelected.concat(expliciteltDisplayedPauses);
    }
    const nonExpliciteltDisplayedPauses = window.getSelection().toString().match(/□/gim);
    if(nonExpliciteltDisplayedPauses && nonExpliciteltDisplayedPauses.length  > 0){
        allSelected = allSelected.concat(nonExpliciteltDisplayedPauses);
    }
    
    if(!allSelected || allSelected.length === 0){
        if(selection.focusNode === selection.anchorNode){
            const selectionInfo = this._resolveSelectionRange(focusNodeCid, focusNodeCid);
            if(selectionInfo){
                return selectionInfo;
            }
        }
        return this._selectedNodeInfo;
    }
    if(focusNodeCid){
        // Firefox can report a live cid on an empty text node after the view
        // tree has shifted, so rely on cid/model resolution instead of the
        // focus node's text content.
        const isFocusNodeLastNode = selection.anchorNode === this.sequencerNodeContainer$el.get(0)? false: true; //This seems to be the way to accuretaly distinguish the direction of the selection
        const selectionInfo = this._resolveFirefoxSelectionRangeFromFocusNodeCid(
            focusNodeCid,
            allSelected.length,
            isFocusNodeLastNode,
        );
        if(selectionInfo){
            return selectionInfo;
        }
    }

    return this._selectedNodeInfo;
},

_isFirefoxBrowser : function(){
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
},


_getCurrentBrowserSelectionParsed: function(){
    if(this._isFirefoxBrowser()){
        return this._getCurrentBrowserSelectionParsedOnFirefox();
    }
    const selection = window.getSelection();
    const anchorNode = this._getSequencerNodeEl(selection ? selection.anchorNode : null);
    const focusNode = this._getSequencerNodeEl(selection ? selection.focusNode : null);
    const container = this.sequencerNodeContainer$el ? this.sequencerNodeContainer$el.get(0) : null;
    if(!selection || !anchorNode || !focusNode || !container){
        return this._selectedNodeInfo;
    }
    const utils = Utils.getInstance();
    // Both anchor AND focus must live in the sequencer container before we
    // trust the native selection parse — otherwise a stale/detached focus can
    // still feed a cid into the resolver.
    if(!utils.isAncestor(container, anchorNode) || !utils.isAncestor(container, focusNode)){
        return this._selectedNodeInfo;
    }
    const startSequencerNodeCid = anchorNode.getAttribute("segment_node_cid");
    const endSequencerNodeCid = focusNode.getAttribute("segment_node_cid");
    const selectionInfo = this._resolveSelectionRange(startSequencerNodeCid, endSequencerNodeCid);
    if(!selectionInfo){
        return this._selectedNodeInfo;
    }
    return selectionInfo;
},

_updateSelectionUsingBrowserSelection : function(latestComputedSeletionInfoForFirefox){
    if(this._isFirefoxBrowser() && latestComputedSeletionInfoForFirefox){
        // Re-resolve via model cids rather than dereferencing views that may
        // have been pruned between parse and commit.
        const firefoxSelection = window.getSelection();
        const firefoxAnchorNode = this._getSequencerNodeEl(firefoxSelection ? firefoxSelection.anchorNode : null);
        const firefoxFocusNode = this._getSequencerNodeEl(firefoxSelection ? firefoxSelection.focusNode : null);
        const firefoxContainer = this.sequencerNodeContainer$el ? this.sequencerNodeContainer$el.get(0) : null;
        if(!firefoxSelection || !firefoxAnchorNode || !firefoxFocusNode || !firefoxContainer){
            return this._selectedNodeInfo;
        }
        const firefoxUtils = Utils.getInstance();
        // A Firefox drag that escapes the editor can leave stale anchor/focus
        // nodes outside sequencerNodeContainer$el — the same liveness guard
        // we apply to the non-Firefox path must apply here before we commit.
        if(!firefoxUtils.isAncestor(firefoxContainer, firefoxAnchorNode) || !firefoxUtils.isAncestor(firefoxContainer, firefoxFocusNode)){
            return this._selectedNodeInfo;
        }
        const startModel = latestComputedSeletionInfoForFirefox.startSequencerNodeModel;
        const endModel = latestComputedSeletionInfoForFirefox.endSequencerNodeModel;
        const startCid = startModel ? startModel.cid : null;
        const endCid = endModel ? endModel.cid : null;
        return this._selectSequencerNodeRangeWithCid(startCid, endCid);
    }
    const selection = window.getSelection();
    const anchorNode = this._getSequencerNodeEl(selection ? selection.anchorNode : null);
    const focusNode = this._getSequencerNodeEl(selection ? selection.focusNode : null);
    const container = this.sequencerNodeContainer$el ? this.sequencerNodeContainer$el.get(0) : null;
    if(!selection || !anchorNode || !focusNode || !container){
        return this._selectedNodeInfo;
    }
    const utils = Utils.getInstance();
    if(!utils.isAncestor(container, anchorNode) || !utils.isAncestor(container, focusNode)){
        return this._selectedNodeInfo;
    }
    return this._selectSequencerNodeRangeWithCid(
        anchorNode.getAttribute("segment_node_cid"),
        focusNode.getAttribute("segment_node_cid")
    );
},

getSelectionNode: function(){
return this._selectedNodeInfo;
/*
const selection = window.getSelection();
const anchorNode = this._getSequencerNodeEl(selection.anchorNode);
const focusNode = this._getSequencerNodeEl(selection.focusNode);
if(selection && anchorNode  && Utils.getInstance().isAncestor(this.sequencerNodeContainer$el.get(0), anchorNode)){
    this.unselectCurrentlySelectedSequencerNodes();
    const selectionStartNodeEl = anchorNode;
    const selectionStartNodeElIndex = this._sequencerNodeElToIndexMap.get(selectionStartNodeEl) ?? -1;
    const selectionEndNodeEl = focusNode;
    const selectionEndNodeElIndex = this._sequencerNodeElToIndexMap.get(selectionEndNodeEl) ?? -1;
    const startSequencerNodeCid = selectionStartNodeEl.getAttribute("segment_node_cid");
    const endSequencerNodeCid = selectionEndNodeEl.getAttribute("segment_node_cid");
    const startSequencerNodeView = this._sequencerNodeCidToSequencerNodeViewMap[startSequencerNodeCid];
    const endSequencerNodeView = this._sequencerNodeCidToSequencerNodeViewMap[endSequencerNodeCid];
    const startSequencerNodeModel = null;
    const endSequencerNodeModel = null;
    const startSequencerNodeViewToReturn = null;
    const endSequencerNodeViewToReturn = null;
    if(selectionEndNodeElIndex > selectionStartNodeElIndex){
        endSequencerNodeModel = endSequencerNodeView.getModel();
        startSequencerNodeModel = startSequencerNodeView.getModel();
        startSequencerNodeViewToReturn = startSequencerNodeView;
        endSequencerNodeViewToReturn = endSequencerNodeView;
    }else{
        endSequencerNodeModel = startSequencerNodeView.getModel();
        startSequencerNodeModel = endSequencerNodeView.getModel();
        startSequencerNodeViewToReturn = endSequencerNodeView;
        endSequencerNodeViewToReturn = startSequencerNodeView;

    }
    this._selectedNodeInfo = {"startSequencerNodeModel": startSequencerNodeModel,
    "startSequencerNodeView":startSequencerNodeViewToReturn,
    "endSequencerNodeModel":endSequencerNodeModel ,
    "endSequencerNodeView": endSequencerNodeViewToReturn,
    "selectionStartAnchorNodeView":startSequencerNodeView,
    "selectionEndFocusNodeView":endSequencerNodeView
};
this._onSelectionChange();
return this._selectedNodeInfo;
}else{
// use the save selection
return this._selectedNodeInfo;
}*/
},

_onSelectionChange : function(newSelection){
this.trigger("onSelectionChange", this._selectedNodeInfo);
const noSelection = this._isNoSelection();
if(noSelection){
    this._setElementDisabled(".always_displayed_context_menu button", true);
    this._destroyContextMenuDisplayed();
    return;
}else{
    this._setElementDisabled("#viewSettingsForMusicWrapperBtn", !this._canViewSettingsForSelection());
    this._setElementDisabled("#ignoreSelectedNodesBtn", !this._canSelectionBeIgnored());
    this._setElementDisabled("#deleteMusicWrapperBtn", !this._canSelectedNodeBeDeletedAMusicWrap());
    this._setElementDisabled("#wrapWithMusicBtn", !this._canSelectionBeWrappedWithMusic());
    this._setElementDisabled("#wrapWithMuteBtn", !this._canSelectionBeWrappedWithMute());
    this._setElementDisabled("#playFromBtn", !this._canPlayFromSelection());
    this._setElementDisabled("#insertBtn", !this._canAudioBeInserted());
    this._setElementDisabled("#insertElementBtn", !this._canElementBeInserted());
    this._setElementDisabled("#moreOptionBtn", !this._canMoreOptionBeDisplayed());
}

},

_canMoreOptionBeDisplayed : function(){
return this.isMoreOptionAvailable() && !this._isNoSelection() && !this._isOnlyOneNodeSeletedAWrapMusicNodeSelected() && !this._isOnlyOneNodeSeletedAnAudioNodeSelected() && !this._isOnlyOneNodeSeletedAnVideoNodeSelected()
},

_isNoSelection : function(){
return !this._selectedNodeInfo || (!this._selectedNodeInfo.startSequencerNodeModel && !this._selectedNodeInfo.endSequencerNodeModel);
},

_isOnlyOneNodeSelected : function(){
return this._selectedNodeInfo && this._selectedNodeInfo.startSequencerNodeModel == this._selectedNodeInfo.endSequencerNodeModel;
},

_isOnlyOneNodeSeletedAWrapMusicNodeSelected : function(){

return this._isOnlyOneNodeSelected() && (Utils.getInstance().isStartMusicWrapSequencerNodeInstance(this._selectedNodeInfo.startSequencerNodeModel) || Utils.getInstance().isEndMusicWrapSequencerNodeInstance(this._selectedNodeInfo.startSequencerNodeModel));
},

_isOnlyOneNodeSeletedAnAudioNodeSelected : function(){
return this._isOnlyOneNodeSelected() &&  Utils.getInstance().isAudioSequencerNodeInstance(this._selectedNodeInfo.startSequencerNodeModel);
},

_isOnlyOneNodeSeletedAnVideoNodeSelected : function(){
    return this._isOnlyOneNodeSelected() &&  Utils.getInstance().isVideoSequencerNodeInstance(this._selectedNodeInfo.startSequencerNodeModel);
},


_canViewSettingsForSelection : function(){
return this._isOnlyOneNodeSelected();
},

_canSelectionBeWrappedWithMusic : function(){
return this.isWrapWithBackgroundMusicActionAvailable();
},

_canSelectionBeWrappedWithMute : function(){
    return this._canSelectionBeWrappedWithMusic();
},

_canSelectedNodeBeDeletedAMusicWrap : function(){
return this.hasMutationAccess() && this._isOnlyOneNodeSeletedAWrapMusicNodeSelected();
},

_canPlayFromSelection : function(){
return !this._isNoSelection();
},

_canSelectionBeIgnored : function(){
return this.isDeleteActionAvailable();
},

_canAudioBeInserted : function(){
return this.isInsertActionAvailable();
},

_canElementBeInserted : function(){
return this.isInsertElementAvailable();
},

_setElementDisabled : function(elementSelector, disbaled){
if(disbaled){
    this.$el.find(elementSelector).addClass("disabled");
}else{
    this.$el.find(elementSelector).removeClass("disabled");
}
},

isSelectionChange : function(oldSelection, newSelection){
if(oldSelection === newSelection){
    return false;
}
if(!oldSelection && newSelection){
    return true;
}
if(oldSelection && !newSelection){
    return true;
}
if(!oldSelection && !newSelection){
    return false;
}
const oldStartSequencerNodeModel = oldSelection.startSequencerNodeModel;
const oldEndSequencerNodeModel = oldSelection.endSequencerNodeModel;
const newStartSequencerNodeModel = newSelection.startSequencerNodeModel;
const newEndSequencerNodeModel = newSelection.endSequencerNodeModel;
return oldStartSequencerNodeModel != newStartSequencerNodeModel || oldEndSequencerNodeModel != newEndSequencerNodeModel;
},

showContextMenuIfApplicable:function(){
this._markCurrentlySelectedNodesAsSelected();
},

_onShiftClickOnSequencerNodeView : function(sequencerNodeView){
const sequencerNodeContainerEl = this.sequencerNodeContainer$el.get(0);
const sequencerNodeContainerChildrenArray =Array.from(sequencerNodeContainerEl.children);
const selectionBeforeClick  = this.getSelectionNode();
if(selectionBeforeClick){
    const currentSelectionStartIndex  = sequencerNodeContainerChildrenArray.indexOf(selectionBeforeClick.startSequencerNodeView.$el.get(0));
    const currentSelectionEndIndex  = sequencerNodeContainerChildrenArray.indexOf(selectionBeforeClick.endSequencerNodeView.$el.get(0));
    const lastSequencerNodeSelectedIndex = sequencerNodeContainerChildrenArray.indexOf(sequencerNodeView.$el.get(0));
    let lowerIndex = currentSelectionStartIndex;
    let lowerSequencerNodeView = selectionBeforeClick.startSequencerNodeView;
    //const upperIndex = currentSelectionEndIndex;
    let upperSequencerNodeView = selectionBeforeClick.endSequencerNodeView;
    if(currentSelectionStartIndex > currentSelectionEndIndex){
        lowerIndex = currentSelectionEndIndex;
        //upperIndex = currentSelectionStartIndex;
        lowerSequencerNodeView = selectionBeforeClick.endSequencerNodeView;
        upperSequencerNodeView = selectionBeforeClick.startSequencerNodeView;
    }
    if(lastSequencerNodeSelectedIndex < lowerIndex){
//this.scrollToSequencerNodeIfneccessary(sequencerNodeView, false, true, true);
        return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(sequencerNodeView.getModel().cid, upperSequencerNodeView.getModel().cid));
    }else{
//this.scrollToSequencerNodeIfneccessary(sequencerNodeView, false, true, true);
        return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(lowerSequencerNodeView.getModel().cid, sequencerNodeView.getModel().cid));
    }
}else{
    return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeRangeWithCid(sequencerNodeView.getModel().cid, sequencerNodeView.getModel().cid));
}
},

_markCurrentlySelectedNodesAsSelected : function(event){
try{
    if(!this.isClickOccuredOnContextMenu(event) && !this.isClickOccuredOnSpeakerContextMenu(event)){

        const latestSelectionInfo = event && event.type == "tap"?  this._getSelectionInfoUsingTap(event) : this._getCurrentBrowserSelectionParsed();
        if(event && event.shiftKey && latestSelectionInfo && latestSelectionInfo.startSequencerNodeView &&  latestSelectionInfo.startSequencerNodeView === latestSelectionInfo.endSequencerNodeView){
            return this._onShiftClickOnSequencerNodeView(latestSelectionInfo.startSequencerNodeView );
        }
        if(this.isSelectionChange(this._currentBrowserNativeSelection,latestSelectionInfo)){
            const selectionInfo = event && event.type == "tap"?  this._updateSelectionInfoUsingTap(event) : this._updateSelectionUsingBrowserSelection(latestSelectionInfo);
            if(event && event.altKey){
        //play from selection
                this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(selectionInfo);
                return this.onPlayFromBtnClicked();
            }else{
                return this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(selectionInfo);
            }
        }else{
            if(event && event.altKey){
                return this.onPlayFromBtnClicked();
            }
        }
    }
}catch(error){
    window.alertErrorMessage(error);
}
},

_markCurrentlySelectedNodesAsSelectedFromSelectionInfo : function(selectionInfo, doNotClearBrowserSelectionToNotLooseFocus, scheduleSelection){
this._currentBrowserNativeSelection = selectionInfo;
this.trigger("onNativeBrowserSelectionChange", selectionInfo);
if(selectionInfo){
    const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
    const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
    const startSequencerNodeView = selectionInfo.startSequencerNodeView;
    const endSequencerNodeView = selectionInfo.endSequencerNodeView;
    const selectionEndFocusNodeView = selectionInfo.selectionEndFocusNodeView;
    this._arrayOfSelectedSequencerNodeModels = [];
    let toMarkAsSelected = startSequencerNodeModel;
    while(toMarkAsSelected){
        if(scheduleSelection){
            setTimeout((function(){
                this.toMarkAsSelected.setSelected(true);
            }).bind({"toMarkAsSelected":toMarkAsSelected}), 0)
        }else{
            toMarkAsSelected.setSelected(true);
        }
        this._arrayOfSelectedSequencerNodeModels.push(toMarkAsSelected);
        if(toMarkAsSelected  == endSequencerNodeModel){
            toMarkAsSelected = null;
        }else{
            toMarkAsSelected = toMarkAsSelected.getNext();
        }
    }

    if(!doNotClearBrowserSelectionToNotLooseFocus){
        this._clearBrowserSelection();
    }
    return this._showContextMenuUsingSelectedSequencerNodes();
}
},

getNumberOfElementsSelected : function(){
if(!this._selectedNodeInfo){
    return 0;
}
const selectionInfo = this._selectedNodeInfo;
let numberOfElementsSelected = 0;
const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
let toCountAsSelected = startSequencerNodeModel;
while(toCountAsSelected){
    if(this.model.isSequencerNodeVisible(toCountAsSelected)){
        numberOfElementsSelected = numberOfElementsSelected + 1;
    }
    if(toCountAsSelected  == endSequencerNodeModel){
        toCountAsSelected = null;
    }else{
        toCountAsSelected = toCountAsSelected.getNext();
    }
}
return numberOfElementsSelected;
},

showContextMenuForCorrectingTranscriptsIfApplicable : function(){
if(canTriggerTranscriptCorrection({
    hasMutationAccess: this.hasMutationAccess(),
    isTranscriptCorrectionAvailable: this._isTranscriptCorrectionSelectionAvailable(),
})){
    return this.showContextMenuForCorrectingTranscripts();
}else if(this.hasMutationAccess()){
    Utils.getInstance().showErrorNotification(window.getI18n(ti18n, "CANNOT_CORRECT_TRANSCRIPT_OF_SELECTION_WITH_NO_WORD"));
}
},

showContextMenuForCorrectingTranscripts : function(){
if(!this.hasMutationAccess()){
    return;
}
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
    const arrayOfSequencerNodeWordModelSelected = this.getArrayOfWordSequencerNodesSelected(selectionInfo);
    if(arrayOfSequencerNodeWordModelSelected && arrayOfSequencerNodeWordModelSelected.length > 0){
        const firstSequencerNodeWordModelSelected  = arrayOfSequencerNodeWordModelSelected[0];
        this._destroyContextMenuDisplayed();
        this._markCurrentlySelectedNodesAsSelectedFromSelectionInfo(this._selectSequencerNodeWithCid(firstSequencerNodeWordModelSelected.cid));
        this._destroyContextMenuDisplayed();
        const updatedSelectionInfo = this.getSelectionNode();
        const selectionStartAnchorNodeView = updatedSelectionInfo.selectionStartAnchorNodeView;
        if(this.shouldContextMenuDisplayed(updatedSelectionInfo)){
            this._showCorrectTranscriptContextMenuInstance(selectionStartAnchorNodeView.$el.get(0), this.sequencerNodeContainer$el.get(0), this.getSelectedNodesTextContent(selectionInfo), ()=>{return this.onCorrectTranscriptBtnClicked()});
        }
    }
}

},

_showCorrectTranscriptContextMenuInstance : function(triggerEl, appendToEl, currentText, onChangesConfirmed, buttonLabel){
    this._destroyContextMenuCorrectTranscriptDisplayed();
    this._currentDisplayedCorrectTranscriptsContextMenuInstance = TippyJS(triggerEl, {appendTo: appendToEl, allowHTML : true,  animation:null, popperOptions: {strategy: 'fixed'},showOnCreate:true, content: this._getCorrectTranscriptContextMenuContent(currentText, buttonLabel) ,interactive :true, ignoreAttributes:true,theme: 'light', maxWidth:	450,onHidden: function(instance){instance.destroy()},trigger: "click", hideOnClick: false});
    this._currentDisplayedCorrectTranscriptsContextMenuInstance.dateCreated = new Date();
    $(this._currentDisplayedCorrectTranscriptsContextMenuInstance.popper).find("input").select();
    const onButtonClick = (event)=>{
        if(onChangesConfirmed){
            let newText =  this.getCorrectectTextFromTextCorrectionContextMenuInput();
            const changedApplied =  onChangesConfirmed(newText, currentText);
            if(changedApplied){
                this._destroyContextMenuCorrectTranscriptDisplayed();
            }
        }
    }
    $(this._currentDisplayedCorrectTranscriptsContextMenuInstance.popper).on("click", "#correctBtn:not(.disable)", onButtonClick);
    this._currentDisplayedCorrectTranscriptsContextMenuInstance.mouseTrapObj = Mousetrap(this._currentDisplayedCorrectTranscriptsContextMenuInstance.popper).bind('enter', (function(e, combo) {
        onButtonClick();
    }).bind(this));
},

getCorrectectTextFromTextCorrectionContextMenuInput : function(){
if(this._currentDisplayedCorrectTranscriptsContextMenuInstance){
    return $(this._currentDisplayedCorrectTranscriptsContextMenuInstance.popper).find("input").val();	
}
},

_showContextMenuUsingSelectedSequencerNodes : function(){
if(DO_NOT_USE_TIPPYJS_MENU){
    return this._showContextMenuUsingSelectedSequencerNodesNew();
}else{
    const selectionInfo = this.getSelectionNode();
    if(selectionInfo){
        const selectionEndFocusNodeView = selectionInfo.selectionEndFocusNodeView;
        if(this.shouldContextMenuDisplayed(selectionInfo)){
            if(this._currentlyDisplayedTippyInstance){
                this._destroyContextMenuDisplayed();
            }
            if(!window.isMobileBrowser){
                this._currentlyDisplayedTippyInstance = TippyJS(selectionEndFocusNodeView.$el.get(0), {allowHTML : true, animation:null, appendTo:this.mainSection$el.get(0),  popperOptions: {strategy: 'fixed'},showOnCreate:true, content: this._getContextMenuContent(selectionInfo) ,interactive :true, ignoreAttributes:true,theme: 'light',followCursor: 'initial', placement: 'bottom', maxWidth: 450,onHidden: function(instance){instance.destroy()},trigger: "click", hideOnClick: false});
                this._initializeTippyJsTooltips($(this._currentlyDisplayedTippyInstance.popper));
                this._currentlyDisplayedTippyInstance.dateCreated = new Date();
            }
        }
    }
}
},

_showContextMenuUsingSelectedSequencerNodesNew : function(){
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
    const selectionEndFocusNodeView = selectionInfo.selectionEndFocusNodeView;
    if(this.shouldContextMenuDisplayed(selectionInfo)){
        if(this._currentlyDisplayedContextMenuInstance){
            this._destroyContextMenuDisplayed();
        }
        if(!window.isMobileBrowser){
            const onMenuClose = (function(){
                this._currentlyDisplayedContextMenuInstance = null;
            }).bind(this)
            return PersistentModels.getInstance().getRouter().showSequencerNodeBasicContextMenuOption(this._sequencerController, selectionEndFocusNodeView.$el, onMenuClose).then((function(contextMenuController){
                this._currentlyDisplayedContextMenuInstance = contextMenuController;
                this._currentlyDisplayedContextMenuInstance.dateCreated = new Date();
            }).bind(this))
        //this._currentlyDisplayedTippyInstance = TippyJS(selectionEndFocusNodeView.$el.get(0), {allowHTML : true, showOnCreate:true, content: this._getContextMenuContent(selectionInfo) ,interactive :true, ignoreAttributes:true,theme: 'light', maxWidth:	450,onHidden: function(instance){instance.destroy()},trigger: "click", hideOnClick: false})
        //this._currentlyDisplayedTippyInstance.dateCreated = new Date();
        }
    }
}
},



isSelectedNodeAStartOrEndWrapNode : function(){
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
    const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
    const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
    if(startSequencerNodeModel == endSequencerNodeModel){
        // Check if it's ANY type of wrap node (music, B-roll overlays, etc.)
        if(startSequencerNodeModel instanceof StartWrapSequencerNode ||
           startSequencerNodeModel instanceof EndWrapSequencerNode){
            return true;
        }
    }
}
return false;
},

isSelectedNodeAnAudioNode : function(){
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
const startSequencerNodeView = selectionInfo.startSequencerNodeView;
const endSequencerNodeView = selectionInfo.endSequencerNodeView;
if(startSequencerNodeModel == endSequencerNodeModel){
    if(Utils.getInstance().isAudioSequencerNodeInstance(startSequencerNodeModel)){
        return true;
    }
    
}
}
return false;
},

isSelectedNodeAnVideoNode : function(){
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
const startSequencerNodeView = selectionInfo.startSequencerNodeView;
const endSequencerNodeView = selectionInfo.endSequencerNodeView;
if(startSequencerNodeModel == endSequencerNodeModel){
    if(Utils.getInstance().isVideoSequencerNodeInstance(startSequencerNodeModel)){
        return true;
    }
    
}
}
return false;
},


_getContextMenuContent : function(selectionInfo){
if(selectionInfo){
const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
const startSequencerNodeView = selectionInfo.startSequencerNodeView;
const endSequencerNodeView = selectionInfo.endSequencerNodeView;
if(startSequencerNodeModel == endSequencerNodeModel){
    // Context menu for wrap nodes. Only Music wraps have a dedicated template
    // on master/dev — the other wrap types (FloatingOverlay / Layout / Title /
    // ZoomEffect / DynamicCaption / Component) are experimental-only and their
    // templates were not ported. For legacy project data that still contains
    // those wrap types, fall through to the generic context menu so a user
    // can still select / delete the nodes rather than crashing or getting a
    // Music-specific menu whose handlers don't apply.
    const wrapType = WrapNodeTypes.getWrapNodeTypeForSequencerNode(startSequencerNodeModel);
    if (wrapType === WrapNodeTypes.MUSIC) {
        return this.compiledMusicWrapperContextMenuTemplate({"ti18n": ti18n, "getTooltip": this._getTooltipFunction() });
    }
    if(Utils.getInstance().isAudioSequencerNodeInstance(startSequencerNodeModel)){
        return this.compiledAudioSequencerNodeContextMenuTemplate({"ti18n": ti18n,"moreOptionAvailable": this.isMoreOptionAvailable(),  "getTooltip": this._getTooltipFunction()});
    }
    if(Utils.getInstance().isVideoSequencerNodeInstance(startSequencerNodeModel)){
        return this.compiledVideoSequencerNodeContextMenuTemplate({"ti18n": ti18n,"moreOptionAvailable": this.isMoreOptionAvailable(),  "getTooltip": this._getTooltipFunction()});
    }
    if(Utils.getInstance().isDeletedSequencerNodeInstance(startSequencerNodeModel)){
        return this.compiledSequencerDeletedNodeContextMenuTemplate({"ti18n": ti18n, "getTooltip": this._getTooltipFunction()});
    }
}
}
const curentLoggedInUserIsNotAVisitor = LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor();
return this.compiledContextMenuTemplate({
"deleteAvailable": this.isDeleteActionAvailable(),
"wrapWithBackgroundMusicAvailable":this.isWrapWithBackgroundMusicActionAvailable(), 
"playFromHereAvailable": this.isPlayFromHereActionAvailable(),
"insertAvailable": this.isInsertActionAvailable(), 
"insertElementAvailable": this.isInsertElementAvailable(),
"clippingAvailable": this.isClippingActionAvailable(), 
"moreOptionAvailable": this.isMoreOptionAvailable(),
"getTooltip": this._getTooltipFunction(),
"editTranscriptionAvailable": this.isEditTranscriptionAvailable(),
"downloadClipAvailable": this.isDownloadClipAvailable(),
"createClipAvailble": this.isCreateClipActionAvailable(),
"ti18n": ti18n})
},

_getArrayOfSequencerNodesSelected : function(selectionInfo){
const startSequencerNodeModel = selectionInfo ? selectionInfo.startSequencerNodeModel : null;
const endSequencerNodeModel = selectionInfo ? selectionInfo.endSequencerNodeModel : null;
if(startSequencerNodeModel && endSequencerNodeModel){
    return SequencerNodeUtils.getInstance().getArrayOfSequencerNodesFromStartToEnd(startSequencerNodeModel, endSequencerNodeModel);
}
return [];
},

getArrayOfVisibleSequencerNodesSelected : function(selectionInfo){
const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
const endSequencerNodeModel =  selectionInfo.endSequencerNodeModel;
const nodesToReturn= [];
if(startSequencerNodeModel){
    let nodeToIterate = startSequencerNodeModel;
while(nodeToIterate){
    nodesToReturn.push(nodeToIterate);
    if(nodeToIterate === endSequencerNodeModel){
        nodeToIterate = null;
    }else{
        nodeToIterate =  nodeToIterate.getNextVisibleSequencerNode();
    }
}

}
return nodesToReturn;
},

getArrayOfWordSequencerNodesSelected : function(selectionInfo){
const startSequencerNodeModel = selectionInfo? selectionInfo.startSequencerNodeModel: null;
const endSequencerNodeModel =  selectionInfo? selectionInfo.endSequencerNodeModel: null;
const nodesToReturn= [];
if(startSequencerNodeModel){
    let nodeToIterate = startSequencerNodeModel;
while(nodeToIterate){
    if(Utils.getInstance().isWordSequencerNodeInstance(nodeToIterate)){
        nodesToReturn.push(nodeToIterate);
    }
    if(nodeToIterate === endSequencerNodeModel){
        nodeToIterate = null;
    }else{
        nodeToIterate =  nodeToIterate.getNextVisibleSequencerNode();
    }
}

}
return nodesToReturn;
},



getSelectedNodesTextContent : function(selectionInfo){
    let textContent = "";
if(selectionInfo){
const wordSequencerNodesArray = this.getArrayOfWordSequencerNodesSelected(selectionInfo);
wordSequencerNodesArray.map((function(wordSequencerNode, index){
    if(index === 0){
        textContent = wordSequencerNode.getAudioSegment().getContent();
    }else{
        textContent =  textContent + " " + wordSequencerNode.getAudioSegment().getContent();
    }

}).bind(this));
}
return textContent;
},

_getCorrectTranscriptContextMenuContentOld :function(selectionInfo){
return this.compiledCorrectTranscriptContextMenuTemplate({"ti18n": ti18n, "currentText": this.getSelectedNodesTextContent(selectionInfo)})
},

_getCorrectTranscriptContextMenuContent :function(currentText, buttonLabel){
    return this.compiledCorrectTranscriptContextMenuTemplate({"ti18n": ti18n, currentText, buttonLabel})
    },

isMoreOptionAvailable : function(){
return canDisplayMoreOptionMenu({
    hasMutationAccess: this.hasMutationAccess(),
    hasClipboardFeature: CUT_COPY_PASTE_FEATURE_AVAILABLE,
    hasClippingFeature: ALLOW_USER_TO_CLIP_SELECTION && LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor(),
    hasCopyActionAvailable: this.isCopyActionAvailable(),
    hasDownloadClipAvailable: this.isDownloadClipAvailable(),
});
},

isDeleteActionAvailable : function(){
return this.hasMutationAccess() && this.getNumberOfElementsSelected() > 0;
},

isWrapWithBackgroundMusicActionAvailable : function(){
	return this.hasMutationAccess() && !this.isSelectedNodeAStartOrEndWrapNode() && !this.isSelectedNodeAnAudioNode() && !this.isSelectedNodeAnVideoNode();
},

isPlayFromHereActionAvailable : function(){
return true;
},

isEditTranscriptionAvailable: function(){
return this.hasMutationAccess();
},

isDownloadClipAvailable: function(){
return true;
},


isInsertActionAvailable : function(){
	return this.hasMutationAccess() && !this.isSelectedNodeAStartOrEndWrapNode() && !this.isSelectedNodeAnAudioNode() && !this.isSelectedNodeAnVideoNode();
},


isInsertElementAvailable : function(){
    return this.isWrapWithBackgroundMusicActionAvailable() || this.isInsertActionAvailable();
},
    


isClippingActionAvailable : function(){
return this.hasMutationAccess() && this.getNumberOfElementsSelected() > 0 && ALLOW_USER_TO_CLIP_SELECTION &&  LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor();
},

isCreateClipActionAvailable : function(){
    return this.hasMutationAccess() && this.model.getHasVideoSegment() && this.getNumberOfElementsSelected() > 0 && ALLOW_USER_TO_CLIP_SELECTION &&  LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor();
},

isCutActionAvailable : function(){
return this.hasMutationAccess() && this.getNumberOfElementsSelected() > 0 && CUT_COPY_PASTE_FEATURE_AVAILABLE;
},

isCopyActionAvailable : function(){
return this.getNumberOfElementsSelected() > 0 && CUT_COPY_PASTE_FEATURE_AVAILABLE;
},

isPasteActionAvailable : function(){
	const hasMutationAccess = typeof this.hasMutationAccess === "function" ? this.hasMutationAccess() : true;
	return hasMutationAccess && !this._editingLocked && !this.model.isClipboardEmpty()  && CUT_COPY_PASTE_FEATURE_AVAILABLE;
},

isTranscriptCorrectionAvailable : function(){
const wordSequencerNodes = this.getArrayOfWordSequencerNodesSelected(this.getSelectionNode());
return this.hasMutationAccess() && wordSequencerNodes && wordSequencerNodes.length > 0;
},

_isTranscriptCorrectionSelectionAvailable : function(){
const wordSequencerNodes = this.getArrayOfWordSequencerNodesSelected(this.getSelectionNode());
return wordSequencerNodes && wordSequencerNodes.length > 0;
},

isAdjustTimingAvailable : function(){
if(!this.hasMutationAccess()){
    return false;
}
return this._isAdjustTimingSelectionAvailable();
},

_isAdjustTimingSelectionAvailable : function(){
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
    const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
    const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
    // Check if exactly one node is selected
    if(startSequencerNodeModel == endSequencerNodeModel){
        // Must have an audio segment to adjust
        const seg = startSequencerNodeModel.getAudioSegment && startSequencerNodeModel.getAudioSegment();
        if(!seg || typeof seg.getStartTime !== 'function' || typeof seg.getEndTime !== 'function'){
          return false;
        }
        // Check node types that support timing
        if(Utils.getInstance().isWordSequencerNodeInstance(startSequencerNodeModel) ||
           Utils.getInstance().isPunctuationSequencerNodeInstance(startSequencerNodeModel) ||
           Utils.getInstance().isPauseSequencerNodeInstance(startSequencerNodeModel) ||
           Utils.getInstance().isAudioEventSequencerNodeInstance(startSequencerNodeModel) ||
           Utils.getInstance().isAudioSequencerNodeInstance(startSequencerNodeModel) ||
           Utils.getInstance().isVideoSequencerNodeInstance(startSequencerNodeModel)){
            return true;
        }
    }
}
return false;
},

isChangeSpeakerForSelectionAvailable : function(){
if(!this.hasMutationAccess()){
    return false;
}
if(this._editingLocked){
    return false;
}
const selectionInfo = this.getSelectionNode();
const arrayOfSequencerNodesSelected = this._getArrayOfSequencerNodesSelected(selectionInfo);
return this._isSpeakerChangeForSelectionAvailableForNodes(arrayOfSequencerNodesSelected);
},

isBreakParagraphBeforeSelectionAvailable : function(){
const paragraphActionContext = this._getParagraphActionContextForSelection();
return !!(paragraphActionContext && paragraphActionContext.canBreakBefore);
},

isBreakParagraphAfterSelectionAvailable : function(){
const paragraphActionContext = this._getParagraphActionContextForSelection();
return !!(paragraphActionContext && paragraphActionContext.canBreakAfter);
},

isMergeWithPreviousParagraphAvailable : function(){
const paragraphActionContext = this._getParagraphActionContextForSelection();
return !!(paragraphActionContext && paragraphActionContext.canMergeWithPrevious);
},

isMergeWithNextParagraphAvailable : function(){
const paragraphActionContext = this._getParagraphActionContextForSelection();
return !!(paragraphActionContext && paragraphActionContext.canMergeWithNext);
},

showAdjustTimingPopup : function(){
if(!this.hasMutationAccess()){
    return;
}
const selectionInfo = this.getSelectionNode();
if(selectionInfo){
    const selectedNodeModel = selectionInfo.startSequencerNodeModel;
    const audioSegment = selectedNodeModel.getAudioSegment();

    const params = {
        "startTime": audioSegment.getStartTime(),
        "endTime": audioSegment.getEndTime(),
        "audioUrl": audioSegment.getAudioUrl()
    };

    const onAudioSegmentRegionChanged = (function(newStartTime, newEndTime){
        // Update the node with new timing
        audioSegment.setStartTime(newStartTime);
        audioSegment.setEndTime(newEndTime);
    }).bind(this);

    const onAudioSegmentRegionNotChanged = (function(){
        // Do nothing if cancelled
    }).bind(this);

    const audioType = Utils.getInstance().getAudioTypes().INSERT;
    const sequencerSettings = this.model.getSequencerSettings();

    return PersistentModels.getInstance().getRouter().showSelectAudioRegion(
        params,
        onAudioSegmentRegionChanged,
        onAudioSegmentRegionNotChanged,
        audioSegment.getAudioUrl(),
        audioType,
        sequencerSettings,
        selectedNodeModel  // Pass the sequencer node for word label rendering
    );
}
},

showChangeSpeakerSelectionMenu : function(anchorEl){
    if(!this.hasMutationAccess()){
        return false;
    }
    if(this._editingLocked){
        return false;
    }
    const selectionInfo = this.getSelectionNode();
    const normalizedAnchorEl = anchorEl && anchorEl.jquery ? anchorEl.get(0) : anchorEl;
    const anchorWillBeDestroyed = !!(
        normalizedAnchorEl
        && this._currentlyDisplayedTippyInstance
        && this._currentlyDisplayedTippyInstance.popper
        && $.contains(this._currentlyDisplayedTippyInstance.popper, normalizedAnchorEl)
    );
    this._destroyContextMenuDisplayed();
    const fallbackAnchorEl = anchorWillBeDestroyed
        ? this._getLastVisibleSelectedSequencerNodeAnchorEl(selectionInfo)
        : normalizedAnchorEl;
    const speakerChangeTarget = this._getSpeakerChangeTargetForSelection(fallbackAnchorEl);
    if(!speakerChangeTarget){
        return false;
    }
    return this._showSpeakerActionsContextMenuForTarget(speakerChangeTarget, {"menuPlacement": "bottom-start"});
},

showAdjustTimingPopupIfAvailable : function(){
    if(canTriggerAdjustTiming({
        hasMutationAccess: this.hasMutationAccess(),
        isAdjustTimingAvailable: this._isAdjustTimingSelectionAvailable(),
    })){
        return this.showAdjustTimingPopup();
    }else if(this.hasMutationAccess()){
        Utils.getInstance().showErrorNotification(window.getI18n(ti18n, "CANNOT_ADJUST_TIMING_FOR_SELECTION"));
    }
},

shouldContextMenuDisplayed : function(selectionInfo){
if(selectionInfo){
const startSequencerNodeModel = selectionInfo.startSequencerNodeModel;
const endSequencerNodeModel = selectionInfo.endSequencerNodeModel;
const startSequencerNodeView = selectionInfo.startSequencerNodeView;
const endSequencerNodeView = selectionInfo.endSequencerNodeView;
if(startSequencerNodeModel == endSequencerNodeModel){
    if(Utils.getInstance().isUnsupportedAudioSequencerNodeInstance(startSequencerNodeModel) ||
        Utils.getInstance().isPunctuationSequencerNodeInstance(startSequencerNodeModel) /*||
        Utils.getInstance().isDeletedSequencerNodeInstance(startSequencerNodeModel)*/){
        return false;
}
/*if(Utils.getInstance().isPauseSequencerNodeInstance(startSequencerNodeModel) && 
    (startSequencerNodeModel.getAudioSegment() == null || startSequencerNodeModel.getAudioSegment().getDuration() == 0)){
    return false;
}*/
}
return true;
}else{
return false;
}
},

getSequencerNodeViewFromSequencerNode : function(sequencerNode){
return sequencerNode? this.getSequencerNodeViewFromSequencerNodeCid(sequencerNode.cid): null;
},

getSequencerNodeViewFromSequencerNodeCid : function(cid){
return cid? this._sequencerNodeCidToSequencerNodeViewMap[cid]: null;
},

_createAndRenderSequencerNodeView : function(sequencerNode){
const params = {"model": sequencerNode};
const audioSegment = sequencerNode.getAudioSegment();
let s = null;
if(Utils.getInstance().isWordSequencerNodeInstance(sequencerNode)){
s = new SequencerWordNodeView(params);
this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
s.render();
return s;
}
if(Utils.getInstance().isAudioEventSequencerNodeInstance(sequencerNode)){
    s = new SequencerAudioEventNodeView(params);
    this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
    s.render();
    return s;
}
if(Utils.getInstance().isPauseSequencerNodeInstance(sequencerNode)){
s = new SequencerPauseNodeView(params);
this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
s.render();
return s;
}
if(Utils.getInstance().isPunctuationSequencerNodeInstance(sequencerNode)){
s = new SequencerPunctuationNodeView(params);
this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
s.render();
return s;
}
if(Utils.getInstance().isDeletedSequencerNodeInstance(sequencerNode)){
s = new SequencerDeletedNodeView(params);
this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
s.render();
return s;
}
// Use centralized factory map for all wrap node types
        const wrapType = WrapNodeTypes.getWrapNodeTypeForSequencerNode(sequencerNode);
        if (wrapType) {
            const wrapViewMapEntry = WRAP_TYPE_TO_VIEW_MAP[wrapType];
            if (wrapViewMapEntry) {
                // Start nodes have createEndWrapSequencerNode method, End nodes don't
                const isStartNode = typeof sequencerNode.createEndWrapSequencerNode === 'function';
                const ViewClass = isStartNode
                    ? wrapViewMapEntry.Start
                    : wrapViewMapEntry.End;
                if (ViewClass) {
                    s = new ViewClass(params);
                    this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
                    s.render();
                    return s;
                }
            }
            s = new SequencerUnsupportedNodeView(params);
            this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
            s.render();
            return s;
        }
        if(Utils.getInstance().isAudioSequencerNodeInstance(sequencerNode)){
            s = new SequencerAudioNodeView(params);
this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
s.render();
return s;
}
if(Utils.getInstance().isVideoSequencerNodeInstance(sequencerNode)){
    s = new SequencerVideoNodeView(params);
    this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
    s.render();
    return s;
}
if(Utils.getInstance().isUnsupportedAudioSegmentInstance(audioSegment)){
s = new SequencerUnsupportedNodeView(params);
this._sequencerNodeCidToSequencerNodeViewMap[sequencerNode.cid] = s;
s.render();
return s;
}

},

isClickOccuredOnContextMenu : function(event){
return event && this._currentlyDisplayedTippyInstance && this._currentlyDisplayedTippyInstance.popper && (this._currentlyDisplayedTippyInstance.popper == event.target || $.contains(this._currentlyDisplayedTippyInstance.popper, event.target));
},

isClickOccuredOnSpeakerContextMenu : function(event){
    return event && this._speakerContextMenuTippyJSInstanceDisplayed && this._speakerContextMenuTippyJSInstanceDisplayed.popper && (this._speakerContextMenuTippyJSInstanceDisplayed.popper == event.target || $.contains(this._speakerContextMenuTippyJSInstanceDisplayed.popper, event.target));
},


isClickOccuredOnSequencerView: function(event){
return event && (this.$el.get(0) == event.target || $.contains(this.$el.get(0), event.target));
},

isClickOccuredOnSequencerContainerView: function(event){
return event && (this.sequencerNodeContainer$el.get(0) == event.target || $.contains(this.sequencerNodeContainer$el.get(0), event.target));
},

isClickOccuredOnSequencerInspectorContainerView: function(event){
return event && (this._sequencer_node_inspector_container$el.get(0) == event.target || $.contains(this._sequencer_node_inspector_container$el.get(0), event.target));
},

isClickOccuredOnSequencerSettingsContainerView: function(event){
return event && (this._sequencer_settings_container$el.get(0) == event.target || $.contains(this._sequencer_settings_container$el.get(0), event.target));
},

isClickOccuredOnSequencerBottomBarView: function(event){
return event && (this.bottomBar$el.get(0) == event.target || $.contains(this.bottomBar$el.get(0), event.target));
},

isClickOccuredOnSequencerTopHeaderBarView: function(event){
return event && (this.headerBar$el.get(0) == event.target || $.contains(this.headerBar$el.get(0), event.target));
},

isClickOccuredOnFloatingSearchContextSearchResultMenuView: function(event){
return event && this.searchWidgetFloatingMenu$el.get(0) && (this.searchWidgetFloatingMenu$el.get(0) == event.target || $.contains(this.searchWidgetFloatingMenu$el.get(0), event.target));
},



_initRenderOfSequencer : function(){
const arrayOfSequencerNodes = this._getArrayOfSequencerNodesInOrder();
for(let i = 0; i < arrayOfSequencerNodes.length; i++){
    this.onSequencerNodeAdded(arrayOfSequencerNodes[i]);
}
this._paragraphLayoutRebuildPending = true;
this._flushParagraphLayoutRebuild();
},

initSequencerNodeInspectorView : function(sequencerNodeInspectorView){
this._sequencerNodeInspectorView = sequencerNodeInspectorView;
this._sequencer_node_inspector_container$el.append(this._sequencerNodeInspectorView.$el)
},

initSequencerSettingsView: function(sequencerSettingsView){
this._sequencerSettingsView = sequencerSettingsView;
this._sequencer_settings_container$el.append(this._sequencerSettingsView.$el)
},

executeDragSequencerNode : function(sequencerNodeToMove,oldIndexInSequencer, newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode){
if(!canTriggerSequencerMutation({ hasMutationAccess: this.hasMutationAccess() })){
return;
}
this.unselectCurrentlySelectedSequencerNodes();
if(Utils.getInstance().isAudioSequencerNodeInstance(sequencerNodeToMove)){
return this.model.moveNode(sequencerNodeToMove, newPreviousSequencerNode, newNextSequencerNode);
}
if(Utils.getInstance().isVideoSequencerNodeInstance(sequencerNodeToMove)){
    return this.model.moveNode(sequencerNodeToMove, newPreviousSequencerNode, newNextSequencerNode);
}
if(sequencerNodeToMove.isWrapNode && sequencerNodeToMove.isWrapNode()){
    return this.model.moveWrapNode(sequencerNodeToMove, oldIndexInSequencer, newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode);
}

},

executeDragAudioSequencerNode : function(sequencerNodeToMove, newPreviousSequencerNode, newNextSequencerNode){
this.unselectCurrentlySelectedSequencerNodes();

},

// Drag/drop now operates against paragraph-nested DOM, so direct container
// children are paragraph wrappers rather than the sequencer nodes themselves.
_getFlattenedSequencerNodeViewIndex : function(sequencerNodeView){
if(!sequencerNodeView || !this._sequencerNodeElToIndexMap){
    return -1;
}
const nodeEl = sequencerNodeView.$el && sequencerNodeView.$el.get ? sequencerNodeView.$el.get(0) : null;
return nodeEl ? (this._sequencerNodeElToIndexMap.get(nodeEl) ?? -1) : -1;
},

_getSequencerNodeViewAtFlattenedIndex : function(index){
if(index < 0 || !this._sequencerNodeElArray || this._sequencerNodeElArray.length <= index){
    return null;
}
return this._getSequencerNodeViewFromEl(this._sequencerNodeElArray[index]);
},

_getFlattenedSequencerNodeElsFromContainer : function(sequencerNodeContainerEl){
if(!sequencerNodeContainerEl || !sequencerNodeContainerEl.querySelectorAll){
    return [];
}
return Array.from(sequencerNodeContainerEl.querySelectorAll(".sequencer_node[segment_node_cid]"));
},

getSequencerNodeViewAtIndexOrLower : function(sequencerNodeContainerEl, index){
if(index < 0){
    return null;
}
const flattenedSequencerNodeEls = this._getFlattenedSequencerNodeElsFromContainer(sequencerNodeContainerEl);
for(let currentIndex = index; currentIndex >= 0; currentIndex--){
    const sequencerNodeView = this._getSequencerNodeViewFromEl(flattenedSequencerNodeEls[currentIndex]);
    if(sequencerNodeView){
        return sequencerNodeView;
    }
}
return null;
},

getSequencerNodeViewAtIndexOrHigher : function(sequencerNodeContainerEl, index){
if(index < 0){
return null;
}
const flattenedSequencerNodeEls = this._getFlattenedSequencerNodeElsFromContainer(sequencerNodeContainerEl);
const maxIndex = flattenedSequencerNodeEls.length;
for(let currentIndex = index; currentIndex < maxIndex; currentIndex++){
    const sequencerNodeView = this._getSequencerNodeViewFromEl(flattenedSequencerNodeEls[currentIndex]);
    if(sequencerNodeView){
        return sequencerNodeView;
    }
}
return null;
},

_revertToInitialPositionBeforeDrag : function(sequencerNodeMovedView, oldIndexInSequencer, newIndexInSequencer){
const sequencerNodeContainerEl = this.sequencerNodeContainer$el.get(0);
if(newIndexInSequencer < oldIndexInSequencer){
if(oldIndexInSequencer + 1 < sequencerNodeContainerEl.children.length){
    sequencerNodeContainerEl.insertBefore(sequencerNodeMovedView.$el.get(0), sequencerNodeContainerEl.children[oldIndexInSequencer + 1]);
}else{
    sequencerNodeContainerEl.appendChild(sequencerNodeMovedView.$el.get(0));
}
}else{
sequencerNodeContainerEl.insertBefore(sequencerNodeMovedView.$el.get(0), sequencerNodeContainerEl.children[oldIndexInSequencer]);
}
},

_onDragStart : function(evt){
const sequencerNodeContainerEl = this.sequencerNodeContainer$el.get(0);
if(evt.oldIndex  < sequencerNodeContainerEl.children.length){
const sequencerNodeBeingMovedEl = sequencerNodeContainerEl.children[evt.oldIndex];
const sequencerNodeBeingMovedView = this.getSequencerNodeViewFromSequencerNodeCid(sequencerNodeBeingMovedEl.getAttribute("segment_node_cid"));
if(sequencerNodeBeingMovedView){
    const sequencerNodeBeingMoved = sequencerNodeBeingMovedView.getModel();
    if(Utils.getInstance().isWrapSequencerNodeInstance(sequencerNodeBeingMoved)){
        sequencerNodeBeingMoved.setAllNodesHoverHighlighted(false);
        }
    }
}
return false;
},

_onDragEnd : function(evt){
if(this._sortableInstance){
this.sequencerNodeContainer$el.attr("move_mode", "false");
this._sortableInstance.option("disabled", true);
if(evt.item.getAttribute("segment_node_cid")){
    const sequencerNodeContainerEl = this.sequencerNodeContainer$el.get(0);
    const oldIndexInSequencer = evt.oldIndex;
    const newIndexInSequencer = evt.newIndex;
    const sequencerNodeMovedView = this.getSequencerNodeViewFromSequencerNodeCid(evt.item.getAttribute("segment_node_cid"));
    const sequencerNodeMovedParagraphContainerView = sequencerNodeMovedView? sequencerNodeMovedView.getParagraphContainerView(): null;
    const sequencerNodeMoved = sequencerNodeMovedView? sequencerNodeMovedView.getModel(): null;
    const newPreviousSequencerNodeView = this.getSequencerNodeViewAtIndexOrLower(sequencerNodeContainerEl, newIndexInSequencer - 1);
    const newPreviousSequencerNodeParagraphContainerView = newPreviousSequencerNodeView? newPreviousSequencerNodeView.getParagraphContainerView(): null;
    const newPreviousSequencerNode = newPreviousSequencerNodeView? newPreviousSequencerNodeView.getModel(): null;
    const newNextSequencerNodeView = this.getSequencerNodeViewAtIndexOrHigher(sequencerNodeContainerEl, newIndexInSequencer + 1);
    const newNextSequencerNodeParagraphContainerView = newNextSequencerNodeView? newNextSequencerNodeView.getParagraphContainerView(): null;
    const newNextSequencerNode = newNextSequencerNodeView? newNextSequencerNodeView.getModel(): null;
    if(oldIndexInSequencer != newIndexInSequencer && sequencerNodeMoved){
        this._revertToInitialPositionBeforeDrag(sequencerNodeMovedView, oldIndexInSequencer, newIndexInSequencer);
        this.executeDragSequencerNode(sequencerNodeMoved,oldIndexInSequencer,  newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode);
    }
}
}

},

remove : function(){
this._enableContextMenuForiOS();
// Clean up video container ResizeObserver
if (this._videoContainerResizeObserver) {
    this._videoContainerResizeObserver.disconnect();
    this._videoContainerResizeObserver = null;
}
Backbone.View.prototype.remove.call(this);
this.stopListening();
if(this._toggleBottomBarVisibilityOnAndroidMobileOnSelectionChangeListener){
document.removeEventListener('selectionchange', this._toggleBottomBarVisibilityOnAndroidMobileOnSelectionChangeListener);
}
},

_disableContextMenuForiOS : function(){
if(window.waitForCordovaToLoad && window.ContextMenuState){
try{
    //make sure to enable to context menu on ios
    window.ContextMenuState.setVisible(false);
}catch(error){
    console.error(error);
}
}
},


_enableContextMenuForiOS : function(){
if(window.waitForCordovaToLoad && window.ContextMenuState){
try{
    //make sure to enable to context menu on ios
    window.ContextMenuState.setVisible(true);
}catch(error){
    console.error(error);
}
}
},



_makeSequencerNodesMovable: function(){
const sortableOptions = {
"animation": 400,
"disabled":true,
"filter":".not_movable",
"draggable":".sequencer_node",
"dataIdAttr":"segment_node_cid",
"onUpdate": this._onDragEnd.bind(this),
"onStart": this._onDragStart.bind(this)
};
this._sortableInstance = new Sortable(this.sequencerNodeContainer$el.get(0), sortableOptions);
},

_forceSequencerNodeContainerBrowserRepaintOnMobile:function(){
//this function is called because on mobile android chrome the browser make mistake in the rendering when there is a selection
if(window.isMobileBrowser){
this.sequencerNodeContainer$el.get(0).style.display = "none";
this.sequencerNodeContainer$el.get(0).style.display = "";
}
},
_onSequencerNodeContainerScrollingStart : function(){
this._isSequencerNodeContainerScrolling = true;
//this._destroyContextMenuDisplayed();
},

_onSequencerNodeContainerScrollingEnd : function(){
this._isSequencerNodeContainerScrolling = false;
//this._showContextMenuUsingSelectedSequencerNodes();
},

_listenForScrollEventOnSequencerNodeContainer: function(){
    let isScrolling = null;
    let scrollingEndFunc = null;
    this.sequencerNodeContainer$el.scroll((function ( event ) {
    if(DESTROY_CONTEXT_MENU_ON_SCROLL){
        if(!this._isSequencerNodeContainerScrolling){
            this._onSequencerNodeContainerScrollingStart();
        }
        window.clearTimeout( scrollingEndFunc );
        scrollingEndFunc = setTimeout((function() {
            this._onSequencerNodeContainerScrollingEnd();
        }).bind(this), 500);
    }
    if(this._isUserManuallyScrolling){
        if(this.model.isPlaying()){
            if(this._pendingScrollAnimation){
                this._pendingScrollAnimationResolve();
                this._pendingScrollAnimationResolve = null;
                this._pendingScrollAnimationReject = null;
                this._pendingScrollAnimation = false;
                this.sequencerNodeContainer$el.stop();
            }
            window.clearTimeout( isScrolling );
            isScrolling = setTimeout((function() {
                this._deactivateAutoscollOnUserManualScrollIfNecessary();
                this._isUserManuallyScrolling = false;
                //this._forceSequencerNodeContainerBrowserRepaintOnMobile();
            }).bind(this), 2000);
        }else{
            this._isUserManuallyScrolling = false;
        }
    }
    }).bind(this))
},

_listenToSelectionChange: function(evt){
if(this._isSelectionChangingTimeoutFunctionId){
window.clearTimeout( this._isSelectionChangingTimeoutFunctionId );
this._isSelectionChangingTimeoutFunctionId = null;
}
this._isSelectionChangingTimeoutFunctionId = setTimeout((function() {
this._markCurrentlySelectedNodesAsSelected(evt);
this._isSelectionChangingTimeoutFunctionId = null;
}).bind(this), 1000);
},

_onTapOnAndroidChrome : function(event){
if(this._isSelectionChangingTimeoutFunctionId){
window.clearTimeout( this._isSelectionChangingTimeoutFunctionId );
this._isSelectionChangingTimeoutFunctionId = null;
}
this._markCurrentlySelectedNodesAsSelected(event);
},



_hideHeaderOrBottomBarVisibilityOnAndroidMobileOnSelectionChange : function(e){

if(window.isMobileBrowser && !window.isSafariBrowser){
if(window.getSelection() && window.getSelection().anchorNode != window.getSelection().focusNode){
    //more than one node selected


    const selection  = window.getSelection()
    const anchorNode = this._getSequencerNodeEl(selection.anchorNode);
    const focusNode = this._getSequencerNodeEl(selection.focusNode);
    if(anchorNode && focusNode){
        const anchorNodeIndex = this._sequencerNodeElToIndexMap.get(anchorNode) ?? -1;
        const focusNodeIndex = this._sequencerNodeElToIndexMap.get(focusNode) ?? -1;
        this._lastTimeSelectionChange = (new Date()).getTime();
        if(anchorNodeIndex < focusNodeIndex){
            this._bottomToolbarVisibilityIsHidden =  true;
            this._headerToolbarVisibilityIsHidden =  false;
            this.bottomBar$el.css("visibility", "hidden");
            this.headerBar$el.css("display", "");
            this.sequencerNodeContainer$el.css("margin-top","0px");
        }else{
            this._headerToolbarVisibilityIsHidden =  true;
            this._bottomToolbarVisibilityIsHidden =  false;
            this.headerBar$el.css("display", "none");
            this.bottomBar$el.css("visibility", "visible");
            this.sequencerNodeContainer$el.css("margin-top","56px");
        }
    }
    

}
}
},

_showHeaderOrBottomBarVisibilityOnAndroidMobileOnSelectionChange : function(event){
if(window.isMobileBrowser && !window.isSafariBrowser && (this._headerToolbarVisibilityIsHidden || this._bottomToolbarVisibilityIsHidden)){
if(this._headerToolbarVisibilityIsHidden){
    this._headerToolbarVisibilityIsHidden = false;
    this.headerBar$el.css("display", "");
    this.sequencerNodeContainer$el.css("margin-top","0px");

}else{
    this._bottomToolbarVisibilityIsHidden = false;
    this.bottomBar$el.css("visibility", "visible");
}
this._markCurrentlySelectedNodesAsSelected(event);
}
},

setJqueryPageElWhereSequencerWillBeAdded : function(jqueryEl){
this._jqueryPageElWhereSequencerWillBeAdded$el = jqueryEl;
this._pageContextMenuHandler = (function(event){
event.preventDefault();
event.stopPropagation(); // not necessary in my case, could leave in case stopImmediateProp isn't available? 
event.stopImmediatePropagation();
//this._showHeaderOrBottomBarVisibilityOnAndroidMobileOnSelectionChange(event);
try{
    if(!window.isMobileBrowser){
        this.showContextMenuIfApplicable();
    }
}catch(error){
    console.error(error)
}
return false;
}).bind(this);
this._outsideSequencerClickHandler = this._onUserClickedOutsideOfTheSequencerEditorContainer.bind(this)
this._jqueryPageElWhereSequencerWillBeAdded$el.contextmenu(this._pageContextMenuHandler);

this._jqueryPageElWhereSequencerWillBeAdded$el.on("click", this._outsideSequencerClickHandler)
},

_onUserClickedOutsideOfTheSequencerEditorContainer : function(event){
if(!this.isClickOccuredOnSequencerContainerView(event) && !this.isClickOccuredOnContextMenu(event) && !this.isClickOccuredOnSpeakerContextMenu(event)  && !this.isClickOccuredOnSequencerInspectorContainerView(event) && !this.isClickOccuredOnSequencerSettingsContainerView(event)  && !this.isClickOccuredOnSequencerBottomBarView(event) && !this.isClickOccuredOnSequencerTopHeaderBarView(event) && !this.isClickOccuredOnFloatingSearchContextSearchResultMenuView(event)){
const wasContextMenuCreatedInLessThanHundredMilliseconds = this._currentlyDisplayedTippyInstance && this._currentlyDisplayedTippyInstance.dateCreated && ((new Date()).getTime() - this._currentlyDisplayedTippyInstance.dateCreated.getTime() < 100)
const wasCorrectContextMenuCreatedInLessThanHundredMilliseconds = this._currentDisplayedCorrectTranscriptsContextMenuInstance && this._currentDisplayedCorrectTranscriptsContextMenuInstance.dateCreated && ((new Date()).getTime() - this._currentDisplayedCorrectTranscriptsContextMenuInstance.dateCreated.getTime() < 100)
if(!wasContextMenuCreatedInLessThanHundredMilliseconds && !wasCorrectContextMenuCreatedInLessThanHundredMilliseconds){
        //this._destroyContextMenuDisplayed();
    this.unselectCurrentlySelectedSequencerNodes();
}
}
},

getSearchInput: function(){
return this.searchInput$el.val()
},

onSearchInputChange : function(){
if(this._pendingSearchQueryId)
{
clearTimeout(this._pendingSearchQueryId);
}
this._pendingSearchQueryId = setTimeout((function(){
this.trigger("searchInputChange")
}).bind(this), DELAY_FOR_EXECUTING_SEARCH_QUERY_IN_MILLISECONDS);
},


_getTooltipFunction(){
return (function(tooltipMessage, arrayOfKeys){
return this.compiledTippyTooltipTemplate({"tooltip":tooltipMessage, "shortcut_keys": arrayOfKeys});
}).bind(this);
},

_destroyTippyTooltipDisplayed: function(){
this._onTippyContextMenuTooltipCreated(null);
},

_onTippyContextMenuTooltipCreated : function(tooltipTippyInstance){
if(this._currentlyDisplayedTooltipTippyInstance){
this._currentlyDisplayedTooltipTippyInstance.destroy();
this._currentlyDisplayedTooltipTippyInstance = null;
}
this._currentlyDisplayedTooltipTippyInstance = tooltipTippyInstance;
},

_initializeTippyJsTooltips : function(el$, noOffset){
if(!window.isMobileBrowser){
const tippjsParams = {"allowHTML": true, 
offset: noOffset?[0,0]: [0, 16], 
arrow: true,
theme: 'tippy-trebble-tooltip',  
placement: 'bottom'};
this._onTippyContextMenuTooltipCreated(createSingleton(TippyJS(el$.find("[data-tippy-content]").toArray(),tippjsParams),tippjsParams ));
}
},

_createTourStepForSelectAudioToModify: function(tour){
return {
title: window.getI18n(ti18n, "ONBOARD_STEP_1_TITLE_EDIT_AUDIO_BY_TEXT"),
text:  window.getI18n(ti18n, "ONBOARD_STEP_1_DESC_EDIT_AUDIO_BY_TEXT"),
attachTo: {
        //element: this.$el.find(".sequencer_node_container").get(0),//this._currentlyDisplayedTippyInstance.popper,//this.$el.find(".sequencer_node_default_context_menu").get(0),
    on: 'auto'
},
arrow: true,
modalOverlayOpeningPadding: 0,
buttons: [
{
    action() {
        return tour.cancel();
    },
    classes: 'shepherd-button-secondary',
    text: window.getI18n(ti18n, "SKIP_TOUR")
},
{
    action : (function(){
        this._selectFourLinesOfTextIfContextMenuIsNotDisplayed();
        setTimeout((function(){
            if(this.$el.is(":visible")){
                tour.addStep(this._createTourStepForDeletingAudio(tour));
                return tour.next();
            }else{
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
                }
            }
        }).bind(this), 200);

    }).bind(this),
    text: window.getI18n(ti18n, "NEXT")
}
],
id: 'onboarding_select_and_modify_audio_step'
};
},

_createTourStepForDeletingAudio: function(tour){
return {
title: window.getI18n(ti18n, "ONBOARD_STEP_2_TITLE_DELETE_AUDIO"),
text:  window.getI18n(ti18n, "ONBOARD_STEP_2_DESC_DELETE_AUDIO"),
attachTo: {
    element: this.$el.find("#ignoreSelectedNodesBtn").get(0),
    on: 'top'
},
arrow: true,
modalOverlayOpeningPadding: 10,
buttons: [
{
    action() {
        return tour.cancel();
    },
    classes: 'shepherd-button-secondary',
    text: window.getI18n(ti18n, "SKIP_TOUR")
},
{
    action : (function(){
            //this._selectFourLinesOfTextIfContextMenuIsNotDisplayed();
        setTimeout((function(){
            if(this.$el.is(":visible")){
                tour.addStep(this._createTourStepAddBackgroundAudio(tour));
                return tour.next();
            }else{
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
                }
            }
        }).bind(this), 200);

    }).bind(this),
    text: window.getI18n(ti18n, "NEXT")
}
],
id: 'onboarding_delete_audio_step'
};
},

_createTourStepAddBackgroundAudio: function(tour){
return {
title: window.getI18n(ti18n, "ONBOARD_STEP_3_TITLE_ADD_BACKGROUND_AUDIO"),
text:  window.getI18n(ti18n, "ONBOARD_STEP_3_DESC_ADD_BACKGROUND_AUDIO"),
attachTo: {
    element: this.$el.find("#insertElementBtn").get(0),
    on: 'top'
},
arrow: true,
modalOverlayOpeningPadding: 10,
buttons: [
{
    action() {
        return tour.cancel();
    },
    classes: 'shepherd-button-secondary',
    text: window.getI18n(ti18n, "SKIP_TOUR")
},
{
    action : (function(){
        if(this.$el.is(":visible")){
            //tour.addStep(this._createTourStepForNoiseReduction(tour));
            tour.addStep(this._createTourStepForAutomatedActionsConfig(tour));
            return tour.next();
        }else{
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
            }
        }
    }).bind(this),
    text: window.getI18n(ti18n, "NEXT")
}
],
id: 'onboarding_add_background_audio_step'
};
},

_createTourStepForNoiseReduction: function(tour){
return {
title: window.getI18n(ti18n, "ONBOARD_STEP_4_TITLE_REMOVE_BACKGROUND_NOISE"),
text:  window.getI18n(ti18n, "ONBOARD_STEP_4_DESC_REMOVE_BACKGROUND_NOISE"),
attachTo: {
    element: this.$el.find("#noiseCancellationBtn").get(0),
    on: 'auto'
},
arrow: true,
buttons: [
{
    action() {
        return tour.cancel();
    },
    classes: 'shepherd-button-secondary',
    text: window.getI18n(ti18n, "SKIP_TOUR")
},
{
    action : (function(){
        if(this.$el.is(":visible")){
            tour.addStep(this._createTourStepForMagicSoundEnhancerConfig(tour));
            return tour.next();
        }else{
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
            }
        }
    }).bind(this),
    text: window.getI18n(ti18n, "NEXT")
}
],
id: 'onboarding_noise_reduction_step'
};
},

_createTourStepForMagicSoundEnhancerConfig: function(tour){
return {
title: window.getI18n(ti18n, "ONBOARD_STEP_5_TITLE_ENHANCE_SOUND"),
text:  window.getI18n(ti18n, "ONBOARD_STEP_5_DESC_ENHANCE_SOUND"),
attachTo: {
    element: this.$el.find("#showBeatifyMenuBtn").get(0),
    on: 'auto'
},
arrow: true,
buttons: [

{
    action: (function(){
        if(this.$el.is(":visible")){
            return tour.next();
        }else{
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
            }
        }
    }).bind(this),
    text: window.getI18n(ti18n, "GOT_IT")
}
],
id: 'onboarding_magic_sound_enhancer_step'
};
},

_createTourStepForAutomatedActionsConfig: function(tour){
return {
title: window.getI18n(ti18n, "ONBOARD_STEP_4_TITLE_AUTOMATED_ACTIONS"),
text:  window.getI18n(ti18n, "ONBOARD_STEP_4_DESC_AUTOMATED_ACTIONS"),
attachTo: {
    element: this.$el.find("#showAutomatedOperationsMenuBtn").get(0),
    on: 'bottom'
},
arrow: true,
buttons: [

{
    action: (function(){
        if(this.$el.is(":visible")){
            return tour.next();
        }else{
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
            }
        }
    }).bind(this),
    text: window.getI18n(ti18n, "GOT_IT")
}
],
id: 'onboarding_automated_actions_step'
};
},


_selectFourLinesOfTextIfContextMenuIsNotDisplayed : function(){
this.unselectCurrentlySelectedSequencerNodes();
this.addNextDownSequencerNodeToSelection();
this.addNextDownSequencerNodeToSelection();
this.addNextDownSequencerNodeToSelection();
this.addNextDownSequencerNodeToSelection();
this.addNextDownSequencerNodeToSelection();
},

getOnboardingCurrentStepIdDisplayed:function(){
return this._onboardingTour &&  this._onboardingTour.getCurrentStep()? this._onboardingTour.getCurrentStep().id:null;
},

showOnboardingInstruction:function(){
if(this.model && typeof this.model.getFirstNode === "function" && this.model.getFirstNode()){
setTimeout((function(){
    if(!this._onboardingTour && this.$el.is(":visible")){
        try{
            this._stopListeningForKeyboardEvents();
            const tour = new Shepherd.Tour({
                useModalOverlay: true,
                keyboardNavigation:false,
                defaultStepOptions: {
                    cancelIcon: {
                        enabled: false
                    },

                    classes: 'sequencer-onboarding-popup',
                    scrollTo: { behavior: 'smooth', block: 'center' }
                }
            });
                //this._selectFourLinesOfTextIfContextMenuIsNotDisplayed();
            tour.addStep(this._createTourStepForSelectAudioToModify(tour));


            tour.start();
            this._onboardingTour = tour;
            tour.once("start", (function(){
                this.trigger("onboardingTourStarted");
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "EditorOnboardingStarted", "Editor Onboarding Started ");
                }
            }.bind(this)))
            tour.once("complete", (function(){
                this.trigger("onboardingTourCompleted");
                this._onboardingTour = null;
                this._listenForKeyboardEvents();
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "EditorOnboardingCompleted", "Editor Onboarding Completed ");
                }
            }.bind(this)))
            tour.once("cancel", (function(){
                this.trigger("onboardingTourCancelled");
                this._onboardingTour = null;
                this._listenForKeyboardEvents();
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "EditorOnboardingCancelled", "Editor Onboarding Cancelled ");
                }
            }.bind(this)))

            tour.on("show", (function(){
                this.trigger("onOnboardingStepDisplayed");
                const stepDisplayedId = this.getOnboardingCurrentStepIdDisplayed();
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "EditorOnboardingStepDisplayed", "Editor Onboarding Step Displayed ", null, {"stepDisplayedId": stepDisplayedId});
                }
            }.bind(this)))

        }catch(error){
            console.error(error);
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "FailedToCreateAudioEditorOnboarding", "Failed to create audio editor onboarding ", null, {"error": error});
            }
        }
    }else{
        if(!this._onboardingTour && window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "sequencerNotVisibleToContinueOnboarding", "Sequencer not visible to continue onboarding");
        }
    }
}).bind(this), 200);
}
},

_showWarningToSwitchToChromeIfApplicable: function(){
if(USE_SCRIPT_PROCESSOR_IN_SAFARI && (window.isSafariBrowser || window.isIOSMobileDevice)){
this.$el.attr("show_switch_to_chrome_warning", "true");
if(window.isIOSMobileDevice){
    this.$el.find("#warning_trebble_works_best_in_other_browsers").attr("show_action_link","false");
}
}
},

_hideEditorSearchComponentToLeftPanel : function(){
    if(this._searchEditorPanelReactRoot){
        this.$el.find(".left_section").css("display","none");
        this.$el.attr("left_section_displayed","false");
        this._searchEditorPanelReactRoot.unmount();
        this._searchEditorPanelReactRoot = null;
    }
},
_showEditorSearchComponentToLeftPanel : async function(){
    if(!this._searchEditorPanelReactRoot){
        const onPanelOpen =()=>{
            this.$el.find(".left_section").css("display","block");
            this.$el.attr("left_section_displayed","true");
            this.trigger("searchTurnedOn");
        }
        const onPanelCloseButtonClick =()=>{
            this.onExitCurrentMode();
        }
        const root = createRoot(this.$el.find(".sequencer_settings_container").get(0));
        
        const props =  {
            searchDisplayTitle: window.getI18n(ti18n, "RESULTS"),
            searchWidgetModel: this.model.getSearchWidget(),
            title: window.getI18n(ti18n, "SEARCH")?.toUpperCase(),
            onPanelOpen: onPanelOpen,
            onPanelCloseButtonClick: onPanelCloseButtonClick,
            listHeightOffset: 244,
            sequencer: this.model
        }
        root.render(<EditorSearchPanel {...props}  />);
        this._searchEditorPanelReactRoot = root;
    }else{
        if(this.model.getSearchWidget().getSearchType() !== this.model.getSearchWidget().SEARCH_TYPE.TEXT_SEARCH){
            this.model.clearSearch();
            await this.model.getSearchWidget().applyTextSearch("");
            this.model.setSearchOn(true);
        }
    }
    
},

onRemovedFromPage: function(){
this.undelegateEvents();
this.$el.removeData().unbind();
// Invalidate the active Timeloom init attempt before page teardown clears
// the React root. Late async callbacks from the removed page must no-op.
this._timeloomRendererInitAttemptId = (this._timeloomRendererInitAttemptId || 0) + 1;
try {
    PersistentModels.getInstance().getRouter().unRegisterForViewportHeightChange(this.cid);
} catch (e) {
    console.debug('[SequencerView] Failed to unregister viewport listener:', e && e.message);
}

if(this._isSelectionChangingTimeoutFunctionId){
    window.clearTimeout(this._isSelectionChangingTimeoutFunctionId);
    this._isSelectionChangingTimeoutFunctionId = null;
}
if(this._pendingSearchQueryId){
    window.clearTimeout(this._pendingSearchQueryId);
    this._pendingSearchQueryId = null;
}
if(this._paragraphContainerViewsPendingCleanup){
    this._paragraphContainerViewsPendingCleanup.clear();
}
this._paragraphContainerCleanupScheduled = false;
if(this._pendingScrollAnimation){
    if(this._pendingScrollAnimationResolve){
        this._pendingScrollAnimationResolve();
    }
    this._pendingScrollAnimationResolve = null;
    this._pendingScrollAnimationReject = null;
    this._pendingScrollAnimation = false;
}
// Clear playback scroll throttle timer (TRE-171)
if(this._pendingPlaybackScrollTimerId){
    clearTimeout(this._pendingPlaybackScrollTimerId);
    this._pendingPlaybackScrollTimerId = null;
    this._pendingPlaybackScrollNodeView = null;
}
// Clear rAF playback loop if still running
this._stopFunctionToUpdatePlaybackProgress();

// Remove global listeners to avoid memory leaks
if (this._listenToSelectionChangeListener) {
    try {
        document.removeEventListener('selectionchange', this._listenToSelectionChangeListener);
    } catch (e) {
        console.error('[SequencerView] Error removing selectionchange listener:', e);
    }
    this._listenToSelectionChangeListener = null;
}

this.stopListening();
this._clearTimeloomRendererReadyWatchdog();

// Clean up click handler to prevent memory leak
if(this._bodyClickHandler){
    if(this.sequencerNodeContainer$el && this.sequencerNodeContainer$el.get(0)){
        this.sequencerNodeContainer$el.get(0).removeEventListener("click", this._bodyClickHandler);
    }
    if(this._markSelectedBound){
        $("body").off("touchend", this._markSelectedBound);
    }
    if(this._selectionClickTimeout){
        clearTimeout(this._selectionClickTimeout);
    }
    this._bodyClickHandler = null;
    this._markSelectedBound = null;
}

if(this._searchEditorPanelReactRoot){
    this._searchEditorPanelReactRoot.unmount();
    this._searchEditorPanelReactRoot = null;
}

if (this._playerSliderEl && this._playerSliderEl.noUiSlider) {
    try {
        this._playerSliderEl.noUiSlider.destroy();
    } catch (error) {
        console.error('[SequencerView] Error destroying player slider:', error);
    }
    this._noUiSliderObj = null;
}
// Clean up modern renderer React root
if(this._modernVideoRenderer && typeof this._modernVideoRenderer.destroy === "function"){
    try {
        this._modernVideoRenderer.destroy();
    } catch (error) {
        console.error('[SequencerView] Error destroying modern video renderer:', error);
    }
}
if(this._modernRendererRoot){
    try {
        this._modernRendererRoot.unmount();
    } catch (error) {
        console.error('[SequencerView] Error unmounting modern renderer:', error);
    } finally {
        this._modernRendererRoot = null;
    }
}
// Clear model renderer references while model is still available
if (this.model) {
    if (typeof this.model.setModernVideoRenderer === 'function') {
        this.model.setModernVideoRenderer(null);
    }
}
if (this._modernVideoRenderer) {
    this._modernVideoRenderer = null;
}
if(this._jqueryPageElWhereSequencerWillBeAdded$el){
    if(this._pageContextMenuHandler){
        this._jqueryPageElWhereSequencerWillBeAdded$el.off("contextmenu", this._pageContextMenuHandler);
        this._pageContextMenuHandler = null;
    }
    if(this._outsideSequencerClickHandler){
        this._jqueryPageElWhereSequencerWillBeAdded$el.off("click", this._outsideSequencerClickHandler);
        this._outsideSequencerClickHandler = null;
    }
    this._jqueryPageElWhereSequencerWillBeAdded$el = null;
}
// Cancel any pending RAF loop and disconnect observers
try {
  this._isPlaybackProgressLoopActive = false;
  if (this._updateRequestAnimationFrameId) {
    cancelAnimationFrame(this._updateRequestAnimationFrameId);
    this._updateRequestAnimationFrameId = null;
  }
  this._sequencerNodeVisibleObserver?.disconnect?.();
  this._sequencerNodeHiddenObserver?.disconnect?.();
  this._paragraphObserver?.disconnect?.();
} catch(_) {}
// Destroy legacy VideoContext if present
if (this._videoCtx) {
  try { this._videoCtx.destroy?.(); } catch(_) {}
  try { this.model?.setVideoContext?.(null); } catch(_) {}
  this._videoCtx = null;
}
// Trigger event before nulling model so listeners can access it
this.trigger("removedFromPage", this);
const modelToDispose = this.model;
// Clear model reference after event has been triggered
if (modelToDispose && typeof modelToDispose.dispose === "function") {
    modelToDispose.dispose().catch(function(error){
        console.error('[SequencerView] Error disposing sequencer model:', error);
    });
}
if (this.model) {
    this.model = null;
}
},

_showWebGLErrorMessage: function() {
    // Only show the error once per session
    if (this._webGLWarningDisplayed) {
        return;
    }

    this._webGLWarningDisplayed = true;

    // Show user-friendly error message with help link
    const helpUrl = window.getI18n(utilsi18n, "WEBGL_HELP_URL");
    const message = window.getI18n(utilsi18n, "HARDWARE_ACCELERATION_MESSAGE");
    const linkText = window.getI18n(utilsi18n, "LEARN_HOW_TO_FIX");

    const fullMessage = `${message}<br><br><a href="${helpUrl}" target="_blank">${linkText} →</a>`;
    const hardwareAccelerationError = new ExpectedError(
        window.getI18n(utilsi18n, "HARDWARE_ACCELERATION_REQUIRED"),
        {
            i18nKey: "HARDWARE_ACCELERATION_REQUIRED",
            classification: EXPECTED_ERROR_CLASSIFICATION.ENVIRONMENT,
            errorCode: "WEBGL_HARDWARE_ACCELERATION_REQUIRED",
            expectedErrorCategory: EXPECTED_ERROR_CATEGORY.HARDWARE_ACCELERATION_UNAVAILABLE,
            watchInAnalytics: true,
            source: EXPECTED_ERROR_SOURCE.SEQUENCER_WEBGL_ERROR,
        }
    );

    window.alertErrorMessage(
        hardwareAccelerationError,
        fullMessage,
        null, // callback
        null, // buttonLabel
        true  // enableHtml
    );

    // Disable video features by clearing video context
    this.model.setVideoContext(null);
},

initVideoContext :function(){
if (!this.model) {
    return;
}
// Only initialize once
if (this._videoCtx) {
    return;
}

const canvasEl =this.$el.find("#sequencer_video_canvas").get(0);
if(canvasEl){
    // Check if WebGL/hardware acceleration is supported
    if (!Utils.getInstance().isWebGLSupported()) {
        console.warn('WebGL not supported, video editing disabled');
        this._showWebGLErrorMessage();
        return;
    }

    try {
        this._videoCtx = new VideoContext(canvasEl, null,
        {
            manualUpdate :false,
            endOnLastSourceEnd : false,
            useVideoElementCache : true,
            videoElementCacheSize : 6,
            webglContextAttributes : {}
        });
        this.model.setVideoContext(this._videoCtx);
    } catch (error) {
        console.error('Failed to initialize VideoContext:', error);
        this._showWebGLErrorMessage();
    }
}
},

/**
 * Calculate the closest supported aspect ratio from width/height dimensions
 * @param {number} width - Video width in pixels
 * @param {number} height - Video height in pixels
 * @returns {string|null} Closest aspect ratio string ('16:9', '9:16', '1:1', or '4:5'), or null if invalid dimensions
 */
_calculateAspectRatioFromDimensions: function(width, height) {
    if (!width || !height) return null;

    const ratio = width / height;

    // Define supported aspect ratios and their numeric values
    const aspectRatios = {
        '16:9': 16/9,    // ~1.778 (landscape)
        '9:16': 9/16,    // ~0.5625 (portrait)
        '1:1': 1,        // 1.0 (square)
        '4:5': 4/5       // 0.8 (slightly tall)
    };

    // Find the closest match
    let closestRatio = '16:9';
    let smallestDiff = Infinity;

    for (const [name, value] of Object.entries(aspectRatios)) {
        const diff = Math.abs(ratio - value);
        if (diff < smallestDiff) {
            smallestDiff = diff;
            closestRatio = name;
        }
    }

    return closestRatio;
},

/**
 * Detect the current aspect ratio for splitter positioning
 * Priority: 1) Video dimensions (actual content), 2) Project config, 3) Default fallback
 *
 * Note: For splitter positioning, we prioritize actual video dimensions over project config
 * because the splitter should optimize for the content that exists, not the render output setting.
 * @returns {string} Aspect ratio string, defaults to '16:9' if cannot detect
 */
_detectCurrentAspectRatio: function() {
    // 1. First try to calculate from video dimensions stored in SequencerSettings
    // This is the actual content dimensions, which is what matters for splitter positioning
    const sequencerSettings = this.model?.getSequencerSettings?.();
    if (sequencerSettings?.hasVideoResolution?.()) {
        const resolution = sequencerSettings.getVideoResolution();
        const calculatedRatio = this._calculateAspectRatioFromDimensions(
            resolution.width,
            resolution.height
        );
        if (calculatedRatio) {
            return calculatedRatio;
        }
    }

    // 2. Fall back to project config (render output setting)
    const projectConfig = this.model?.getProjectConfig?.();
    const configRatio = projectConfig?.getDefaultAspectRatio?.();
    if (configRatio) {
        return configRatio;
    }

    // 3. Final fallback
    return '16:9';
},

initTimeloomRenderer: function() {
    /* global USE_TIMELOOM_RENDERER */
    if (window.DEBUG_BROLL) {
        console.log('[B-Roll Debug] initTimeloomRenderer called, USE_TIMELOOM_RENDERER =', typeof USE_TIMELOOM_RENDERER !== 'undefined' ? USE_TIMELOOM_RENDERER : 'undefined');
    }

    // Feature flag check - safe pattern to avoid ReferenceError
    if (typeof USE_TIMELOOM_RENDERER === 'undefined' || !USE_TIMELOOM_RENDERER) {
        recordWindowedAudioDebugEvent('timeloom-renderer-init-fallback-video-context', _.extend({
            reason: 'feature-flag-disabled'
        }, getWindowedAudioDebugVisibilityState()));
        if (window.DEBUG_BROLL) {
            console.log('[B-Roll Debug] Falling back to VideoContext (Timeloom not enabled)');
        }
        return this.initVideoContext();
    }

    if (window.DEBUG_BROLL) {
        console.log('[B-Roll Debug] Initializing Timeloom renderer...');
    }

    // Only initialize once - use atomic guard flag to prevent concurrent initialization
    if (this._modernRendererRoot || this._initializingModernRenderer) {
        recordWindowedAudioDebugEvent('timeloom-renderer-init-skipped', _.extend({
            reason: this._modernRendererRoot ? 'root-already-mounted' : 'initialization-in-progress',
            hasModernRendererRoot: !!this._modernRendererRoot,
            initializingModernRenderer: this._initializingModernRenderer === true
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomInitSkipped: true,
                timeloomRendererReady: !!this._modernVideoRenderer
            }
        }));
        return;
    }
    this._initializingModernRenderer = true;
    recordWindowedAudioDebugEvent('timeloom-renderer-init-start', _.extend({
        sequencerId: this.model && this.model.getId ? this.model.getId() : null,
        hasVideoSegment: this.model && this.model.getHasVideoSegment ? this.model.getHasVideoSegment() : null
    }, getWindowedAudioDebugVisibilityState(), {
        debugState: {
            timeloomInitializing: true,
            timeloomRendererReady: false
        }
    }));

    // Defensive null check for model
    if (!this.model) {
        console.error('[SequencerView] Model is null/undefined, cannot initialize Timeloom renderer');
        this._initializingModernRenderer = false;
        recordWindowedAudioDebugEvent('timeloom-renderer-init-aborted', _.extend({
            reason: 'missing-model'
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomInitializing: false
            }
        }));
        return;
    }

    const container = this.$el.find(".video_canvas_container").get(0);
    if (!container) {
        console.error('[SequencerView] Video canvas container not found, falling back to VideoContext');
        this._initializingModernRenderer = false;
        recordWindowedAudioDebugEvent('timeloom-renderer-init-aborted', _.extend({
            reason: 'missing-container'
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomInitializing: false
            }
        }));
        return this.initVideoContext();
    }

    try{
        // Create React root for Timeloom component (internal implementation detail)
        const reactRoot = createRoot(container);
        const initAttemptId = this._timeloomRendererInitAttemptId + 1;
        this._timeloomRendererInitAttemptId = initAttemptId;

        // Create bound callbacks
        const onReadyCallback = (api) => {
            this.onModernRendererReady(api, initAttemptId);
        };
        const onErrorCallback = (error) => {
            this.onModernRendererError(error, initAttemptId);
        };
        const onTimeUpdateCallback = this.onModernRendererTimeUpdate.bind(this);

        // Calculate responsive video dimensions based on container and aspect ratio
        const dimensions = this._calculateVideoDimensions(container);

        // Render TimeloomRenderer component with responsive container size
        // Note: TimeloomRenderer is the internal implementation class name
        reactRoot.render(
            React.createElement(TimeloomRenderer, {
                sequencer: this.model,
                width: dimensions.width,
                height: dimensions.height,
                onReady: onReadyCallback,
                onError: onErrorCallback,
                onTimeUpdate: onTimeUpdateCallback,
                debug: false,
                i18nModule: timeloomRendereri18n
            })
        );

        this._modernRendererRoot = reactRoot;
        this._initializingModernRenderer = false; // Clear flag after successful init
        this._scheduleTimeloomRendererReadyWatchdog(initAttemptId);
        recordWindowedAudioDebugEvent('timeloom-renderer-root-mounted', _.extend({
            sequencerId: this.model && this.model.getId ? this.model.getId() : null
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomInitializing: false,
                timeloomRootMounted: true
            }
        }));

        // Set up ResizeObserver to re-render when container size changes
        this._setupVideoContainerResizeObserver(container);

    } catch (error) {
        console.error('[SequencerView] Failed to initialize Timeloom renderer:', error);
        this._initializingModernRenderer = false; // Clear flag to allow retry
        recordWindowedAudioDebugEvent('timeloom-renderer-init-failed', _.extend({
            message: error && error.message ? error.message : String(error)
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomInitializing: false,
                timeloomRendererReady: false
            }
        }));
        // Fallback to VideoContext on error
        this.initVideoContext();
    }
},

_clearTimeloomRendererReadyWatchdog: function() {
    if (this._timeloomRendererReadyTimeoutId) {
        clearTimeout(this._timeloomRendererReadyTimeoutId);
        this._timeloomRendererReadyTimeoutId = null;
    }
    if (this._cancelPendingTimeloomRendererRecovery) {
        this._cancelPendingTimeloomRendererRecovery();
        this._cancelPendingTimeloomRendererRecovery = null;
    }
},

_scheduleTimeloomRendererReadyWatchdog: function(initAttemptId) {
    this._clearTimeloomRendererReadyWatchdog();
    this._timeloomRendererReadyTimeoutId = setTimeout((function() {
        this._timeloomRendererReadyTimeoutId = null;
        if (this._modernVideoRenderer || !this._modernRendererRoot) {
            return;
        }
        if (this._timeloomRendererInitAttemptId !== initAttemptId) {
            return;
        }
        recordWindowedAudioDebugEvent('timeloom-renderer-ready-timeout', _.extend({
            sequencerId: this.model && this.model.getId ? this.model.getId() : null,
            initAttemptId: initAttemptId,
            recoveryAttempts: this._timeloomRendererRecoveryAttempts
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomRendererReady: false,
                timeloomRootMounted: !!this._modernRendererRoot
            }
        }));
        this._recoverTimedOutTimeloomRendererInitialization(initAttemptId);
    }).bind(this), TIMELOOM_RENDERER_READY_TIMEOUT_MS);
},

_recoverTimedOutTimeloomRendererInitialization: function(initAttemptId) {
    const retryInitialization = function(reason) {
        if (this._timeloomRendererInitAttemptId !== initAttemptId) {
            return;
        }
        if (this._modernVideoRenderer) {
            return;
        }
        if (this._timeloomRendererRecoveryAttempts >= MAX_TIMELOOM_RENDERER_RECOVERY_ATTEMPTS) {
            this.onModernRendererError(
                new Error(
                    'Timeloom renderer did not become ready within ' +
                    TIMELOOM_RENDERER_READY_TIMEOUT_MS +
                    'ms'
                ),
                initAttemptId
            );
            return;
        }
        this._timeloomRendererRecoveryAttempts += 1;
        recordWindowedAudioDebugEvent('timeloom-renderer-recovery-start', _.extend({
            sequencerId: this.model && this.model.getId ? this.model.getId() : null,
            initAttemptId: initAttemptId,
            recoveryAttempts: this._timeloomRendererRecoveryAttempts,
            reason: reason
        }, getWindowedAudioDebugVisibilityState(), {
            debugState: {
                timeloomRendererReady: false,
                timeloomRecoveryInProgress: true
            }
        }));
        if (this._modernRendererRoot) {
            try {
                this._modernRendererRoot.unmount();
            } catch (error) {
                console.error('[SequencerView] Error unmounting timed-out Timeloom renderer:', error);
            }
            this._modernRendererRoot = null;
        }
        if (this.model && typeof this.model.setModernVideoRenderer === 'function') {
            this.model.setModernVideoRenderer(null);
        }
        this._modernVideoRenderer = null;
        this._initializingModernRenderer = false;
        this.initTimeloomRenderer();
    }.bind(this);

    if (Utils.getInstance().isTrebbleAppInForeground()) {
        retryInitialization('timeout');
        return;
    }

    recordWindowedAudioDebugEvent('timeloom-renderer-recovery-deferred', _.extend({
        sequencerId: this.model && this.model.getId ? this.model.getId() : null,
        initAttemptId: initAttemptId
    }, getWindowedAudioDebugVisibilityState(), {
        debugState: {
            timeloomRendererReady: false,
            timeloomRecoveryDeferredUntilForeground: true
        }
    }));
    this._cancelPendingTimeloomRendererRecovery =
        Utils.getInstance().executeFunctionWhenAppGoesInForeground(function() {
            this._cancelPendingTimeloomRendererRecovery = null;
            retryInitialization('foreground');
        }.bind(this), {
            key: 'timeloom-renderer-recovery-' + (this.model && this.model.getId ? this.model.getId() : this.cid)
        });
},

/**
 * Calculate video dimensions based on container size and aspect ratio
 * Maintains aspect ratio while fitting within container
 * @param {HTMLElement} container - The video container element
 * @returns {{width: number, height: number}} - Calculated dimensions
 */
_calculateVideoDimensions: function(container) {
    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    // Use the same detection logic as _detectCurrentAspectRatio
    // This ensures the video container matches the actual video content, not the render output setting
    const aspectRatioStr = this._detectCurrentAspectRatio();

    // Convert aspect ratio string to numeric value
    const aspectRatioMap = {
        '16:9': 16 / 9,
        '1:1': 1,
        '9:16': 9 / 16,
        '4:5': 4 / 5
    };
    const aspectRatio = aspectRatioMap[aspectRatioStr] || 16 / 9;

    // Calculate dimensions to fit container while maintaining aspect ratio
    // Leave padding for visual spacing
    const padding = 16;
    const availableWidth = Math.max(containerWidth - padding * 2, 100);
    const availableHeight = Math.max(containerHeight - padding * 2, 56);

    let videoWidth, videoHeight;

    // Calculate based on available space
    const widthBasedHeight = availableWidth / aspectRatio;
    const heightBasedWidth = availableHeight * aspectRatio;

    if (widthBasedHeight <= availableHeight) {
        // Width is the limiting factor
        videoWidth = availableWidth;
        videoHeight = widthBasedHeight;
    } else {
        // Height is the limiting factor
        videoHeight = availableHeight;
        videoWidth = heightBasedWidth;
    }

    // Ensure minimum dimensions
    videoWidth = Math.max(Math.round(videoWidth), 100);
    videoHeight = Math.max(Math.round(videoHeight), 56);

    return { width: videoWidth, height: videoHeight };
},

/**
 * Set up ResizeObserver to update video dimensions when container resizes
 * @param {HTMLElement} container - The video container element
 */
_setupVideoContainerResizeObserver: function(container) {
    // Clean up existing observer
    if (this._videoContainerResizeObserver) {
        this._videoContainerResizeObserver.disconnect();
    }

    // Store initial dimensions
    this._lastVideoDimensions = this._calculateVideoDimensions(container);

    // Debounce resize handling to avoid excessive updates
    // Hot container resize is fast (~1ms) so we use short debounce
    let resizeTimeout = null;
    const handleResize = () => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(() => {
            this._updateTimeloomRendererSize(container);
        }, 50); // Short debounce - hot resize is fast
    };

    this._videoContainerResizeObserver = new ResizeObserver(handleResize);
    this._videoContainerResizeObserver.observe(container);
},

/**
 * Update TimeloomRenderer container size when panel resizes.
 * Uses hot container resize API for instant updates without React re-render.
 * This works during playback without interruption (~1ms vs 750ms+ for re-render).
 * @param {HTMLElement} container - The video container element
 */
_updateTimeloomRendererSize: function(container) {
    if (!this._modernRendererRoot) {
        return;
    }

    const dimensions = this._calculateVideoDimensions(container);

    // Only update if dimensions changed significantly (more than 10px)
    const lastDims = this._lastVideoDimensions || { width: 0, height: 0 };
    const widthDiff = Math.abs(dimensions.width - lastDims.width);
    const heightDiff = Math.abs(dimensions.height - lastDims.height);

    if (widthDiff < 10 && heightDiff < 10) {
        return; // Skip update for small changes
    }

    this._lastVideoDimensions = dimensions;

    // Try hot container resize first - this works during playback without interruption
    // It directly updates the container element's CSS style via ref
    const renderer = this.model?.getModernVideoRenderer?.();
    if (renderer?.resizeContainer) {
        renderer.resizeContainer(dimensions.width, dimensions.height);
        return;
    }

    // Fallback: Skip re-render during playback to avoid disrupting video.
    // Uses the authoritative `renderedBufferPlaying` flag via the model helper.
    const isPlaying = this.model?.isRenderedBufferPlaying?.() || this.model?.get('renderedBufferPlaying');
    if (isPlaying) {
        return;
    }

    // Fallback to full re-render if hot resize not available
    const initAttemptId = this._timeloomRendererInitAttemptId;
    const onReadyCallback = (api) => {
        this.onModernRendererReady(api, initAttemptId);
    };
    const onErrorCallback = (error) => {
        this.onModernRendererError(error, initAttemptId);
    };
    const onTimeUpdateCallback = this.onModernRendererTimeUpdate.bind(this);

    this._modernRendererRoot.render(
        React.createElement(TimeloomRenderer, {
            sequencer: this.model,
            width: dimensions.width,
            height: dimensions.height,
            onReady: onReadyCallback,
            onError: onErrorCallback,
            onTimeUpdate: onTimeUpdateCallback,
            debug: false,
            i18nModule: timeloomRendereri18n
        })
    );
},

/**
 * Handle video resolution changes from project settings (aspect ratio changes)
 * Uses full renderer recreation because aspect ratio changes are fundamental composition changes.
 *
 * NOTE: We intentionally do NOT use renderer.resize() here because:
 * 1. resize() updates React state (compositionDimensions), triggering Player re-render
 * 2. This causes the Remotion Player to lose playback state, freezing the video
 * 3. Audio continues via WebAudio API (unaffected by React), causing A/V desync
 *
 * For display-only resizing (splitter drag, browser resize), use resizeContainer() instead
 * which only updates CSS and doesn't trigger React re-renders.
 *
 * @param {Object} newDimensions - {width, height}
 */
_onVideoResolutionChanged: function(newDimensions) {
    // Aspect ratio changes are fundamental composition changes
    // Use full renderer recreation - brief pause is acceptable for this scenario
    // Do NOT use resize() as it causes React re-render that freezes video

    // Set flag on model (Layer 2) - View will check this and recreate
    this.model.setTimeloomRecreationRequired();
    this._recreateTimeloomIfNeeded();
},

/**
 * Handle project config changes (layout defaults, etc.)
 * Refreshes the Timeloom renderer to apply new defaults
 */
_onProjectConfigChanged: function() {
    // Skip refresh if renderer is being recreated - the new renderer will have fresh config
    // Use model's state (Layer 2) instead of View's local state
    if (this.model.isTimeloomRecreationRequired() || this._rendererRecreationTimeout) {
        return;
    }
    // Refresh Timeloom renderer to apply new layout defaults
    const timeloomRenderer = this.model.getModernVideoRenderer?.();
    if (timeloomRenderer && timeloomRenderer.refresh) {
        timeloomRenderer.refresh();
    }
},

/**
 * Handle theme changes from project settings
 * Uses hot theme update to apply changes without recreating renderer.
 * This preserves playback state during theme changes.
 */
_onThemeChanged: function(theme) {
    // Try hot theme update first - this preserves playback state
    // Hot update modifies timeline.settings.theme and triggers React re-render
    const renderer = this.model?.getModernVideoRenderer?.();
    if (renderer?.updateTheme && theme) {
        renderer.updateTheme(theme);
        return;
    }

    // Fallback to full recreation if hot theme update is not available
    // Set flag on model (Layer 2) - View will check this and recreate
    this.model.setTimeloomRecreationRequired();
    this._recreateTimeloomIfNeeded();
},

/**
 * Recreate Timeloom renderer if model indicates recreation is required.
 * Coalesces multiple rapid recreation requests into a single recreation.
 * This prevents the renderer from being recreated multiple times when
 * cascading events fire (videoResolutionChanged, themeChanged, projectConfigChanged)
 *
 * State flow: Model sets 'recreationRequired' -> View starts recreation ->
 *             Model transitions to 'recreating' -> View mounts React ->
 *             Model transitions to 'ready'
 */
_recreateTimeloomIfNeeded: function() {
    // Check model flag - only recreate if needed (Layer 2 state check)
    if (!this.model.isTimeloomRecreationRequired()) {
        return;
    }

    // Clear any pending recreation timeout
    if (this._rendererRecreationTimeout) {
        clearTimeout(this._rendererRecreationTimeout);
    }

    // Signal that recreation is starting (transitions state to 'recreating')
    // This also clears the renderer on the model
    this.model.onTimeloomRecreationStarted();

    // Unmount existing renderer immediately to prevent any further interaction
    if (this._modernRendererRoot) {
        this._modernRendererRoot.unmount();
        this._modernRendererRoot = null;
        this._modernVideoRenderer = null;
    }

    // Also clear the initialization flag so initTimeloomRenderer can proceed
    this._initializingModernRenderer = false;

    // Debounce the actual recreation - wait for all cascading events to settle
    this._rendererRecreationTimeout = setTimeout(() => {
        this._rendererRecreationTimeout = null;
        this._doTimeloomRecreation();
    }, 100); // 100ms debounce - enough for cascading events to settle
},

/**
 * Actually perform the Timeloom recreation.
 * Called after debounce period from _recreateTimeloomIfNeeded.
 */
_doTimeloomRecreation: async function() {
    try {
        await this.initTimeloomRenderer();
        // onModernRendererReady will be called by initTimeloomRenderer
        // which now calls model.onTimeloomRendererReady(api)
    } catch (error) {
        console.error('[SequencerView] Timeloom recreation failed:', error);
        this.model.onTimeloomRendererFailed(error);
    }
},

onModernRendererReady: function(api, initAttemptId) {
    if (typeof initAttemptId === "number" && this._timeloomRendererInitAttemptId !== initAttemptId) {
        if (api && typeof api.destroy === "function") {
            try {
                api.destroy();
            } catch (error) {
                console.error('[SequencerView] Error destroying stale modern renderer instance:', error);
            }
        }
        return;
    }
    if (!this._modernRendererRoot) {
        if (api && typeof api.destroy === "function") {
            try {
                api.destroy();
            } catch (error) {
                console.error('[SequencerView] Error destroying renderer after root teardown:', error);
            }
        }
        return;
    }
    this._clearTimeloomRendererReadyWatchdog();
    this._modernVideoRenderer = api;
    this._timeloomRendererRecoveryAttempts = 0;
    recordWindowedAudioDebugEvent('timeloom-renderer-ready', _.extend({
        sequencerId: this.model && this.model.getId ? this.model.getId() : null,
        rendererType: api && api.rendererType ? api.rendererType : null
    }, getWindowedAudioDebugVisibilityState(), {
        debugState: {
            timeloomRendererReady: true,
            timeloomInitializing: false
        }
    }));

    // Signal success to model (Layer 2)
    // This transitions state to 'ready', stores the renderer, and triggers 'timeloomRendererReady' event
    if (this.model && this.model.onTimeloomRendererReady) {
        this.model.onTimeloomRendererReady(api);

        // Set up listener for sequencer changes to refresh video timeline
        // Only attach listener if model exists to avoid null reference
        this.listenTo(this.model, "historyUpdated", this.onModernRendererHistoryUpdated);
    } else {
        console.error('[SequencerView] ERROR: model or onTimeloomRendererReady not available!', {
            model: this.model,
            onTimeloomRendererReady: this.model?.onTimeloomRendererReady
        });
    }
},

onModernRendererHistoryUpdated: function() {
    // Refresh modern renderer timeline when sequencer nodes change (e.g., duplicate words, delete, etc)
    if (this._modernVideoRenderer &&
        typeof this._modernVideoRenderer.refresh === 'function' &&
        this.model &&
        typeof this.model.getHasVideoSegment === 'function' &&
        this.model.getHasVideoSegment()) {
        this._modernVideoRenderer.refresh().catch((error) => {
            console.error('[SequencerView.onModernRendererHistoryUpdated] Error refreshing modern video timeline:', error);
        });
    }
},

onModernRendererError: function(error, initAttemptId) {
    if (typeof initAttemptId === "number" && this._timeloomRendererInitAttemptId !== initAttemptId) {
        return;
    }
    if (!this._modernRendererRoot && !this._initializingModernRenderer) {
        return;
    }
    this._clearTimeloomRendererReadyWatchdog();
    console.error('[SequencerView] Modern video renderer error:', error);
    recordWindowedAudioDebugEvent('timeloom-renderer-error', _.extend({
        sequencerId: this.model && this.model.getId ? this.model.getId() : null,
        message: error && error.message ? error.message : String(error)
    }, getWindowedAudioDebugVisibilityState(), {
        debugState: {
            timeloomRendererReady: false,
            timeloomInitializing: false
        }
    }));

    // Cleanup failed modern renderer
    if (this._modernRendererRoot) {
        try {
            this._modernRendererRoot.unmount();
        } catch (e) {
            console.error('[SequencerView] Error unmounting modern renderer root:', e);
        }
        this._modernRendererRoot = null;
    }

    // Remove historyUpdated listener and clear model reference
    if (this.model) {
        this.stopListening(this.model, "historyUpdated", this.onModernRendererHistoryUpdated);

        // Clear model reference to prevent stale API pointer
        if (typeof this.model.setModernVideoRenderer === 'function') {
            this.model.setModernVideoRenderer(null);
        }
    }

    this._modernVideoRenderer = null;

    // Fallback to VideoContext (only if not already tried)
    if (!this._videoContextFallbackTried) {
        this._videoContextFallbackTried = true;
        try {
            this.initVideoContext();
        } catch (fallbackError) {
            console.error('[SequencerView] VideoContext fallback also failed:', fallbackError);
        }
    } else {
        console.error('[SequencerView] VideoContext fallback already attempted, not retrying');
    }
},

onModernRendererTimeUpdate: function(timeMs) {
    // Optional: Sync timeline cursor with modern renderer playback
    // This can be implemented when playback synchronization is needed
},

render : function() {	


this.$el.html(this.compiledTemlate({"ti18n": ti18n, "isSearchAllowed": ALLOW_TEXT_SEARCH_IN_AUDIO_EDITOR,"isPlaybackOfSearchResultsAllowed": ALLOW_PLAYBACK_OF_SEARCH_RESULTS, "getTooltip": this._getTooltipFunction(), "CONFIGURE_SOUND_ENHANCING": CONFIGURE_SOUND_ENHANCING, displaySearchWidget: !SHOW_SEARCH_WIDGET_ON_LEFT_SECTION_OF_EDITOR}));
this.setElement(this.$el.find("div").first());
this._playerSlider$el = this.$el.find("#playerSongPositionSlider");
this.timeElapsed$el = this.$el.find("#time_ellapsed");
this.totalTime$el =  this.$el.find("#total_time");
this.autoScrollBtn$el = this.$el.find("#autoScrollBtn");
this.noiseCancellationBtn$el = this.$el.find("#noiseCancellationBtn");
this.configureViewBtn$el = this.$el.find("#configureViewBtn");
this.projectSettingsBtn$el = this.$el.find("#projectSettingsBtn");
this.showBeatifyMenuBtn$el = this.$el.find("#showBeatifyMenuBtn");
this.showAutomatedOperationsMenuBtn$el = this.$el.find("#showAutomatedOperationsMenuBtn");
this.showHelpBtn$el = this.$el.find("#showHelpBtn");
this.shareProjectBtn$el = this.$el.find("#shareProjectBtn");
this.bottomBar$el = this.$el.find(".bottom_toolbar");
this.headerBar$el = this.$el.find(".header_toolbar");
this.searchWidgetFloatingMenu$el = this.$el.find(".search_widget.floating_menu");
this.searchInput$el = this.$el.find(".search_input");

this.showNextSearchBtn$el  = this.$el.find("#nextResultBtn");
this.showPreviousSearchBtn$el  = this.$el.find("#previousResultBtn");
this.focusSearchIndexLabel$el  = this.$el.find(".focus_search_index");
this.totalSearchResult$el  = this.$el.find(".total_search_result");
this.mainSection$el = this.$el.find(".main_section");
this.playSelectionBtn$el = this.$el.find("#playSelectionBtn");
this.playWithoutSelection$el = this.$el.find("#playWithoutSelection");
this.deleteSelectionBtn$el = this.$el.find("#deleteSelectionBtn");
this.deleteAllHighligthed$el = this.$el.find("#removeAllHightlightedBtn");

this._playerSliderEl= this._playerSlider$el.get(0);
this._sequencer_node_inspector_container$el = this.$el.find(".sequencer_node_inspector_container");
this._sequencer_settings_container$el = this.$el.find(".sequencer_settings_container");
this._initPlayerSlider();
if(this._sequencerNodeInspectorView){
this._sequencerNodeInspectorView.render();
this._sequencer_node_inspector_container$el.append(this._sequencerNodeInspectorView.$el)
}


if(this._sequencerSettingsView){
this._sequencerSettingsView.render();
this._sequencer_settings_container$el.append(this._sequencerSettingsView.$el);
}
this.sequencerNodeContainer$el = this.$el.find(".sequencer_node_container");
if(!this.model.showNotDisplayedNotExplicitelyDisplayedPause()){
this.sequencerNodeContainer$el.addClass("do_not_show_pause_non_explicitely_displayed");
}

if(BREAK_DOWN_TEXT_IN_AUDIO_EDITOR_AUTOMATICALLY){
this.sequencerNodeContainer$el.addClass("break_down_text_automatically");
}

this.searchInput$el.on("keyup input", this.onSearchInputChange.bind(this));
this._setupVisibilityObservers();
//this._makeSequencerNodesMovable()
this._initRenderOfSequencer();

if(window.isMobileBrowser && !window.isSafariBrowser){
//work around for android chrome around selection
//	this._hideHeaderOrBottomBarVisibilityOnAndroidMobileOnSelectionChangeListener = this._hideHeaderOrBottomBarVisibilityOnAndroidMobileOnSelectionChange.bind(this);
//	document.addEventListener('selectionchange', this._hideHeaderOrBottomBarVisibilityOnAndroidMobileOnSelectionChangeListener);
this._listenToSelectionChangeListener = this._listenToSelectionChange.bind(this);
document.addEventListener('selectionchange', this._listenToSelectionChangeListener);
}

// Store bound handler for proper cleanup.
// Debounce with 100ms to collapse rapid clicks during selection gestures.
// Using native addEventListener on the transcript container instead of
// $("body").on("click") to avoid jQuery Sizzle walking 15,000+ DOM nodes
// on every click event for delegated selector matching.
this._markSelectedBound = this._markCurrentlySelectedNodesAsSelected.bind(this);
this._bodyClickHandler = (function(event) {
    if (this._selectionClickTimeout) {
        clearTimeout(this._selectionClickTimeout);
    }
    this._selectionClickTimeout = setTimeout(this._markSelectedBound, 100, event);
}).bind(this);

if(window.isMobileBrowser){
this.sequencerNodeContainer$el.on("touchstart", (function(){
    $("body").one("touchend", this._markSelectedBound)
}).bind(this));
}else{
this.sequencerNodeContainer$el.get(0).addEventListener("click", this._bodyClickHandler);
}

/*if(this._isFirefoxBrowser()){
this.sequencerNodeContainer$el.on("tap", this._markCurrentlySelectedNodesAsSelected.bind(this));
}*/
if(window.isMobileBrowser){
if(!window.isSafariBrowser){
    //For android chrome
    this.sequencerNodeContainer$el.on("tap", this._onTapOnAndroidChrome.bind(this));
}else{
    this.sequencerNodeContainer$el.on("tap", this._markCurrentlySelectedNodesAsSelected.bind(this));
}
}
this.$el.attr("hide_pauses_under_ten_milliseconds",HIDE_PAUSE_UNDER_10_MILLISECONDS?"true":"false");
this.$el.on("remove", this.onRemovedFromPage.bind(this));
this.undoBtn$el = this.$el.find("#undoBtn");
this.redoBtn$el = this.$el.find("#redoBtn");
this._listenForScrollEventOnSequencerNodeContainer();
this.onHistoryUpdated();
this._onSelectionChange();
this.onAutoscrollChange();
this.onHasVideoSegmentChanged();
this.setSequencerSettingsDisplayed(false);
this.setSequencerAutomationOperationsMenuDisplayed(false);
this._showWarningToSwitchToChromeIfApplicable();
if(ENABLE_NOISE_CANCELLATION_FEATURE){
this.onNoiseCancellationOnChange();
}else{
this.noiseCancellationBtn$el.hide();
}
this.onShowIgnoredContentSettingChange();
this.onRevealDeletedContentSettingChange();
this.onShowGapNodesSettingChange();
this.onShowEditBoundariesSettingChange();
this.onShowDarkThemeChange();
this.onAutoscrollChange();
this._initializeTippyJsTooltips(this.$el, false);

this._disableContextMenuForiOS();

return this;
}

});
export default SequencerView;
